import type {
	AxiosInstance,
	AxiosRequestConfig,
	HeadersDefaults,
	ResponseType,
} from 'axios'

import axios from 'axios'

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum VideoTag {
	OptimizationGroupList = 'optimization_group_list',
	PricingCampaignList = 'pricing_campaign_list',
	OptimizationGroup = 'optimization_group',
	OptimizationGroupSettings = 'optimization_group_settings',
	PricingCampaignSettings = 'pricing_campaign_settings',
	DynamicAssignment = 'dynamic_assignment',
	RepricingLimits = 'repricing_limits',
	AnchoringBehavior = 'anchoring_behavior',
	RoundingRules = 'rounding_rules',
	MinimalStep = 'minimal_step',
	WhatIf = 'what_if',
	Products = 'products',
	Promo = 'promo',
	Anchors = 'anchors',
	Templates = 'templates',
	Tactics = 'tactics',
	CampaignActivity = 'campaign_activity',
	Markdown = 'markdown',
	Treemap = 'treemap',
	BiAnalytics = 'bi_analytics',
	AiAnalytics = 'ai_analytics',
	CompetitiveData = 'competitive_data',
	CdMatches = 'cd_matches',
	CdDataHealth = 'cd_data_health',
	CdProductOverview = 'cd_product_overview',
	CdAssortment = 'cd_assortment',
	CdSettings = 'cd_settings',
	CdReports = 'cd_reports',
	CdChangelog = 'cd_changelog',
}

/** @default "auto" */
export enum TargetPriceTypeModel {
	Auto = 'auto',
	Promo = 'promo',
	Regular = 'regular',
}

export enum PricingEngineType {
	MD = 'MD',
	ML = 'ML',
	RB = 'RB',
	Promo = 'Promo',
}

/** PromoCampaignSource */
export enum PromoCampaignSource {
	Manual = 'manual',
	Integration = 'integration',
}

/** FieldType */
export enum FieldType {
	Tree = 'tree',
	Text = 'text',
	Delta = 'delta',
	Number = 'number',
	Percent = 'percent',
	Url = 'url',
	Image = 'image',
	Choice = 'choice',
	Badge = 'badge',
	Chip = 'chip',
	Flag = 'flag',
	Checkbox = 'checkbox',
	Lock = 'lock',
	Count = 'count',
	Currency = 'currency',
	DateDistanceAt = 'date_distance_at',
	Date = 'date',
	Datetime = 'datetime',
	Custom = 'custom',
	Price = 'price',
}

/** ValueEditorType */
export enum ValueEditorType {
	Select = 'select',
	Multiselect = 'multiselect',
	Text = 'text',
	Number = 'number',
	Checkbox = 'checkbox',
	CheckboxTree = 'checkbox_tree',
	Daterange = 'daterange',
	Datetimerange = 'datetimerange',
	Date = 'date',
}

/** ValueType */
export enum ValueType {
	String = 'string',
	Integer = 'integer',
	Number = 'number',
	Boolean = 'boolean',
	Array = 'array',
	Date = 'date',
	Datetime = 'datetime',
}

/** HiddenOnContext */
export enum HiddenOnContext {
	Assortment = 'assortment',
	Products = 'products',
	Export = 'export',
	PricingTactics = 'pricing_tactics',
	PriceLimits = 'price_limits',
	AnchorGrouping = 'anchor_grouping',
	AnchorClustering = 'anchor_clustering',
	AnchorIndexing = 'anchor_indexing',
}

/** DeltaType */
export enum DeltaType {
	Month = 'month',
	Week = 'week',
	Day = 'day',
}

/** SalesMetric */
export enum SalesMetric {
	MinPrice = 'min_price',
	MaxPrice = 'max_price',
	MinPriceEsp = 'min_price_esp',
	MaxPriceEsp = 'max_price_esp',
	AvgSalesItems = 'avg_sales_items',
	SumSalesItems = 'sum_sales_items',
	Revenue = 'revenue',
	GrossProfit = 'gross_profit',
	Cost = 'cost',
}

/** SavedFilterType */
export enum SavedFilterType {
	Products = 'products',
	Anchors = 'anchors',
}

/** AlertLevel */
export enum AlertLevel {
	Unassigned = 'unassigned',
	Critical = 'critical',
	Warning = 'warning',
}

/** OptimizationAction */
export enum OptimizationAction {
	Start = 'start',
	DryRun = 'dry_run',
	Stop = 'stop',
	Lock = 'lock',
	Unlock = 'unlock',
	DeleteExport = 'delete_export',
	UpdateFinalFields = 'update_final_fields',
	Update = 'update',
	RevertPrices = 'revert_prices',
	Reset = 'reset',
	InitFields = 'init_fields',
	ProductDiffs = 'product_diffs',
	SetPending = 'set_pending',
}

/** OptimizationStatus */
export enum OptimizationStatus {
	New = 'new',
	Scheduled = 'scheduled',
	Finished = 'finished',
	Failed = 'failed',
	Canceled = 'canceled',
	Locked = 'locked',
	Updating = 'updating',
	UpdatingFailed = 'updating_failed',
	Pending = 'pending',
}

/** OptimizationRunType */
export enum OptimizationRunType {
	Default = 'default',
	DryRun = 'dry_run',
}

/** ExportGroupBy */
export enum ExportGroupBy {
	Product = 'product',
	PricingLine = 'pricing_line',
}

/** ExportStatus */
export enum ExportStatus {
	Started = 'started',
	Finished = 'finished',
	Failed = 'failed',
}

/** ExportType */
export enum ExportType {
	Csv = 'csv',
	Xlsx = 'xlsx',
	Kafka = 'kafka',
	Bigquery = 'bigquery',
}

/** AnchorGeneratedFamilyStatus */
export enum AnchorGeneratedFamilyStatus {
	Review = 'review',
	Approved = 'approved',
	Rejected = 'rejected',
}

/** AnchorType */
export enum AnchorType {
	Flat = 'flat',
	Size = 'size',
	Bundle = 'bundle',
	Ladder = 'ladder',
	ProductSet = 'product_set',
}

/** ApplyAction */
export enum ApplyAction {
	UpdatePricingCampaignSettings = 'update_pricing_campaign_settings',
	ReplacePricingCampaignSettings = 'replace_pricing_campaign_settings',
	UpdateScenarioSettings = 'update_scenario_settings',
	AddWhatIfScenario = 'add_what_if_scenario',
	ReplaceMainScenario = 'replace_main_scenario',
}

/** SettingsTemplateType */
export enum SettingsTemplateType {
	Scenario = 'scenario',
	ScenarioStrategy = 'scenario_strategy',
	ScenarioStopList = 'scenario_stop_list',
	ScenarioBusinessConstraints = 'scenario_business_constraints',
	PricingCampaign = 'pricing_campaign',
	PricingCampaignTacticsRb = 'pricing_campaign_tactics_rb',
	PricingCampaignTacticsMl = 'pricing_campaign_tactics_ml',
	PricingCampaignTacticsMd = 'pricing_campaign_tactics_md',
	PricingCampaignTacticsPromo = 'pricing_campaign_tactics_promo',
	PricingCampaignLimits = 'pricing_campaign_limits',
	PricingCampaignMinimalSteps = 'pricing_campaign_minimal_steps',
	PricingCampaignRounding = 'pricing_campaign_rounding',
	PricingCampaignAnchoring = 'pricing_campaign_anchoring',
	PricingCampaignProductAssignment = 'pricing_campaign_product_assignment',
	PricingCampaignActivity = 'pricing_campaign_activity',
}

/** ScenarioType */
export enum ScenarioType {
	Default = 'default',
	Recommendation = 'recommendation',
}

/** RuleApplyErrorType */
export enum RuleApplyErrorType {
	RemovedParameter = 'removed_parameter',
	FailedConstraint = 'failed_constraint',
	UnknownParameterType = 'unknown_parameter_type',
}

/** AlertGroupBy */
export enum AlertGroupBy {
	OptimizationGroupId = 'optimization_group_id',
	PricingCampaignId = 'pricing_campaign_id',
}

/** MetricType */
export enum MetricType {
	Business = 'business',
	Pricing = 'pricing',
	Reprice = 'reprice',
	AiImportance = 'ai_importance',
	Statistics = 'statistics',
	PredictDefault = 'predict_default',
	PredictCustom = 'predict_custom',
	Summary = 'summary',
}

/** TableType */
export enum TableType {
	Bi = 'bi',
	AiBoostMetrics = 'ai_boost_metrics',
	FeatureImportance = 'feature_importance',
	Statistics = 'statistics',
	PredictStatistics = 'predict_statistics',
	PredictProduct = 'predict_product',
}

/** MetricDeltaType */
export enum MetricDeltaType {
	Absolute = 'absolute',
	Relative = 'relative',
}

/** MetricMeasure */
export enum MetricMeasure {
	Percent = 'percent',
	Unit = 'unit',
	Money = 'money',
}

/** ValueFilterRule */
export type ValueFilterRule =
	| ({
			operation: 'array_all_of'
	  } & StringArrayFilterRule)
	| ({
			operation: 'array_any_of'
	  } & StringArrayFilterRule)
	| ({
			operation: 'array_exact'
	  } & StringArrayFilterRule)
	| ({
			operation: 'array_none_of'
	  } & StringArrayFilterRule)
	| ({
			operation: 'bl'
	  } & BooleanFilterRule)
	| ({
			operation: 'contains'
	  } & StringFilterRule)
	| ({
			operation: 'date_after'
	  } & BinaryDateFilterRule)
	| ({
			operation: 'date_at'
	  } & BinaryDateFilterRule)
	| ({
			operation: 'date_before'
	  } & BinaryDateFilterRule)
	| ({
			operation: 'date_between'
	  } & TernaryDateFilterRule)
	| ({
			operation: 'eq'
	  } & BinaryNumericFilterRule)
	| ({
			operation: 'gt'
	  } & BinaryNumericFilterRule)
	| ({
			operation: 'gte'
	  } & BinaryNumericFilterRule)
	| ({
			operation: 'in'
	  } & NullableStringArrayFilterRule)
	| ({
			operation: 'is'
	  } & StringFilterRule)
	| ({
			operation: 'is_empty'
	  } & BooleanFilterRule)
	| ({
			operation: 'is_not'
	  } & StringFilterRule)
	| ({
			operation: 'is_not_empty'
	  } & BooleanFilterRule)
	| ({
			operation: 'lt'
	  } & BinaryNumericFilterRule)
	| ({
			operation: 'lte'
	  } & BinaryNumericFilterRule)
	| ({
			operation: 'ne'
	  } & BinaryNumericFilterRule)
	| ({
			operation: 'not_contains'
	  } & StringFilterRule)
	| ({
			operation: 'not_in'
	  } & NullableStringArrayFilterRule)
	| ({
			operation: 'num_between'
	  } & TernaryNumericFilterRule)
	| ({
			operation: 'select'
	  } & StringFilterRule)

/**
 * StatusModel
 * Service availability and data readiness.
 */
export interface StatusModel {
	/**
	 * Version
	 * Current service semver, e.g. "1.0.0".
	 */
	version: string
	/**
	 * Is Enabled
	 * Whether the service is enabled for this client.
	 */
	is_enabled: boolean
	/**
	 * Is Ready
	 * Whether the data backing predictions is up to date. Always false when is_enabled is false.
	 */
	is_ready: boolean
}

/**
 * Problem
 * Error envelope returned for every non-2xx response.
 */
export interface Problem {
	/**
	 * Type
	 * Slim machine code, e.g. "pricing_line_not_found".
	 */
	type: string
	/**
	 * Title
	 * Short human-readable title.
	 */
	title: string
	/**
	 * Status
	 * HTTP status code.
	 */
	status: number
	/**
	 * Detail
	 * Human-readable explanation.
	 */
	detail: string
}

/**
 * ForecastModel
 * The forecast and forecastability verdict for one pricing line.
 */
export interface ForecastModel {
	/**
	 * Optimization Group Id
	 * Optimization group the request addressed.
	 */
	optimization_group_id: string
	/**
	 * Optimization Id
	 * Optimization the request addressed.
	 */
	optimization_id: string
	/**
	 * Pricing Line Id
	 * Pricing line the request addressed.
	 */
	pricing_line_id: string
	/**
	 * Prediction On
	 * ISO day the forecast was generated; typically the first forecast day. Null when the series has no forecast.
	 */
	prediction_on: string | null
	/** Day range covered. The series' own forecast when it has one, otherwise the period the published run covers, so a blocked series still states which days have no forecast. Null when nothing is published. */
	forecast_period: ForecastPeriodModel | null
	/**
	 * Is Forecastable
	 * Whether a forecast was produced for this series.
	 */
	is_forecastable: boolean
	/**
	 * Reasons
	 * Why the series is not forecastable; null when it is.
	 */
	reasons: ReasonModel[] | null
	/** Interval-derived confidence; null when not forecastable. */
	confidence: ConfidenceModel | null
	/** Daily history + forecast; null when not forecastable. */
	sales_quantity: SalesQuantityModel | null
	/** Period aggregate; null when not forecastable. */
	sales_quantity_total: SalesQuantityTotalModel | null
}

/**
 * ForecastPeriodModel
 * The inclusive day range a forecast covers.
 */
export interface ForecastPeriodModel {
	/**
	 * Starts On
	 * First forecast day, inclusive, "YYYY-MM-DD".
	 */
	starts_on: string
	/**
	 * Ends On
	 * Last forecast day, inclusive, "YYYY-MM-DD".
	 */
	ends_on: string
}

/**
 * ReasonModel
 * A single reason the series is not forecastable.
 */
export interface ReasonModel {
	/**
	 * Code
	 * Machine-readable reason the series is blocked.
	 */
	code:
		| 'intermittent'
		| 'lumpy'
		| 'is_new'
		| 'dormant'
		| 'not_enough_data'
		| 'unknown'
	/**
	 * Factor
	 * Which dimension caused the block.
	 */
	factor: 'demand' | 'lifecycle' | 'common'
	/**
	 * Evidence
	 * Reason-specific supporting facts; null when the reason carries none.
	 */
	evidence?:
		AgeEvidenceModel | DormancyEvidenceModel | PatternEvidenceModel | null
}

/**
 * AgeEvidenceModel
 * Evidence of ``is_new``: the series is younger than the age gate.
 */
export interface AgeEvidenceModel {
	/**
	 * Days Live
	 * Days since the series first sold.
	 */
	days_live: number
	/**
	 * Min Days
	 * Days it must reach to be scorable.
	 */
	min_days: number
}

/**
 * DormancyEvidenceModel
 * Evidence of ``dormant``: the series has not sold recently enough.
 */
export interface DormancyEvidenceModel {
	/**
	 * Days Since Last Sale
	 * Days since the last sale.
	 */
	days_since_last_sale: number
	/**
	 * Max Days
	 * Days it may go without a sale and stay scorable.
	 */
	max_days: number
}

/**
 * PatternEvidenceModel
 * Evidence of ``intermittent`` / ``lumpy``: the demand shape is not modellable.
 */
export interface PatternEvidenceModel {
	/**
	 * Pattern
	 * Demand pattern the series was labelled with.
	 */
	pattern: 'smooth' | 'erratic' | 'intermittent' | 'lumpy'
	/**
	 * Allowed
	 * Patterns that are scorable.
	 */
	allowed: ('smooth' | 'erratic' | 'intermittent' | 'lumpy')[]
}

/**
 * ConfidenceModel
 * Confidence summary derived from the forecast intervals.
 */
export interface ConfidenceModel {
	/**
	 * Level
	 * Bucketed confidence: high / medium / low.
	 */
	level: 'high' | 'medium' | 'low'
	/**
	 * Spread
	 * Interval-width multiplier tied to the level.
	 */
	spread: number
}

/**
 * SalesQuantityModel
 * The sales-quantity fan chart, split into observed history and forecast.
 */
export interface SalesQuantityModel {
	/**
	 * History
	 * Observed daily points up to the origin, ascending by date.
	 */
	history: HistoryPointModel[]
	/**
	 * Forecast
	 * Forecast daily points after the origin, ascending by date.
	 */
	forecast: ForecastPointModel[]
}

/**
 * HistoryPointModel
 * One observed daily point of a series.
 */
export interface HistoryPointModel {
	/**
	 * Date On
	 * Calendar day of the point, "YYYY-MM-DD".
	 */
	date_on: string
	/**
	 * Value
	 * Observed value on that day.
	 */
	value: number
}

/**
 * ForecastPointModel
 * One forecast daily point, as prediction-interval quantiles.
 */
export interface ForecastPointModel {
	/**
	 * Date On
	 * Calendar day of the point, "YYYY-MM-DD".
	 */
	date_on: string
	/**
	 * Q05
	 * 5th percentile (lower 90% bound), clamped at 0.
	 */
	q05: number
	/**
	 * Q25
	 * 25th percentile (lower 75% bound), clamped at 0.
	 */
	q25: number
	/**
	 * Q50
	 * Median forecast, clamped at 0.
	 */
	q50: number
	/**
	 * Q75
	 * 75th percentile (upper 75% bound), clamped at 0.
	 */
	q75: number
	/**
	 * Q95
	 * 95th percentile (upper 90% bound), clamped at 0.
	 */
	q95: number
}

/**
 * SalesQuantityTotalModel
 * Sales quantity aggregated over the whole forecast period.
 */
export interface SalesQuantityTotalModel {
	/**
	 * Total
	 * Sum of q50 over the forecast points.
	 */
	total: number
	/**
	 * Lo
	 * Sum of q25 over the forecast points.
	 */
	lo: number
	/**
	 * Hi
	 * Sum of q75 over the forecast points.
	 */
	hi: number
}

/**
 * SegmentationModel
 * The demand and lifecycle segmentation of one pricing line.
 */
export interface SegmentationModel {
	/**
	 * Optimization Group Id
	 * Optimization group the request addressed.
	 */
	optimization_group_id: string
	/**
	 * Optimization Id
	 * Optimization the request addressed.
	 */
	optimization_id: string
	/**
	 * Pricing Line Id
	 * Pricing line the request addressed.
	 */
	pricing_line_id: string
	/** Demand-shape facts; null when no data. */
	demand: DemandSegmentModel | null
	/** Lifecycle facts; null when no data. */
	lifecycle: LifecycleSegmentModel | null
}

/**
 * DemandSegmentModel
 * Demand-shape facts for a series.
 */
export interface DemandSegmentModel {
	/**
	 * Pattern
	 * Demand pattern, lower_snake.
	 */
	pattern: 'smooth' | 'erratic' | 'intermittent' | 'lumpy'
	/**
	 * Adi
	 * Average demand interval.
	 */
	adi: number
	/**
	 * Cv
	 * Coefficient of variation of demand size.
	 */
	cv: number
	/**
	 * Cv2
	 * Squared coefficient of variation.
	 */
	cv2: number
	/**
	 * Zero Sale Rate
	 * Fraction of days with zero sales.
	 */
	zero_sale_rate: number
	/**
	 * History Days
	 * Number of days of history observed.
	 */
	history_days: number
	/** Daily observed demand. */
	sales_quantity_daily: DemandWindowModel
	/** The same demand aggregated to week beginnings (Mondays). */
	sales_quantity_weekly: DemandWindowModel
}

/**
 * DemandWindowModel
 * Observed demand split into the segmentation window and what precedes it.
 */
export interface DemandWindowModel {
	/**
	 * Segmentation Window
	 * Gapless sequential buckets used for demand pattern detection.
	 */
	segmentation_window: DemandPointModel[]
	/**
	 * Recent History
	 * Gapless sequential buckets immediately before the segmentation window.
	 */
	recent_history: DemandPointModel[]
}

/**
 * DemandPointModel
 * One day (or week) of observed demand.
 */
export interface DemandPointModel {
	/**
	 * Date On
	 * Calendar day, "YYYY-MM-DD"; a Monday when weekly.
	 */
	date_on: string
	/**
	 * Units
	 * Units sold in that bucket.
	 */
	units: number
}

/**
 * LifecycleSegmentModel
 * Lifecycle facts for a series.
 */
export interface LifecycleSegmentModel {
	/**
	 * Stage
	 * Lifecycle stage: new / active / inactive.
	 */
	stage: 'new' | 'active' | 'inactive'
	/**
	 * Days Live
	 * Days since the series went live.
	 */
	days_live: number
	/**
	 * Weeks Live
	 * Weeks since the series went live.
	 */
	weeks_live: number
	/**
	 * Months Live
	 * Months since the series went live.
	 */
	months_live: number
}

/** AppModel */
export interface AppModel {
	/** Name */
	name: string
	/** Is Active */
	is_active: boolean
	/** Roles */
	roles: string[]
	/** Entities */
	entities: Record<string, EntityModel[]>
}

/** EntityModel */
export interface EntityModel {
	/** Id */
	id: string
	/** Name */
	name?: string | null
	/** Parent Id */
	parent_id?: string | null
}

/** HTTPValidationError */
export interface HTTPValidationError {
	/** Detail */
	detail?: ValidationError[]
}

/** ValidationError */
export interface ValidationError {
	/** Location */
	loc: (string | number)[]
	/** Message */
	msg: string
	/** Error Type */
	type: string
	/** Input */
	input?: any
	/** Context */
	ctx?: object
}

/** AccessTokenModel */
export interface AccessTokenModel {
	/** Access Token */
	access_token: string
}

/** DepartmentShortModel */
export interface DepartmentShortModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Users Count */
	users_count: number
	/** Enabled Apps */
	enabled_apps: string[]
	/** Role Names */
	role_names: string[]
}

/** DepartmentDataModel */
export interface DepartmentDataModel {
	/**
	 * Name
	 * @minLength 1
	 */
	name: string
	/** Apps */
	apps: UserAppDataModel[]
}

/** UserAppDataModel */
export interface UserAppDataModel {
	/** Name */
	name: string
	/** Enabled */
	enabled: boolean
	/**
	 * Direct Role Names
	 * @default []
	 */
	direct_role_names?: string[]
	/**
	 * Entities
	 * @default {}
	 */
	entities?: Record<string, string[]>
}

/** DepartmentModel */
export interface DepartmentModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Apps */
	apps: UserAppModel[]
}

/** UserAppModel */
export interface UserAppModel {
	/** Name */
	name: string
	/** Enabled */
	enabled: boolean
	/**
	 * Direct Role Names
	 * @default []
	 */
	direct_role_names?: string[]
	/**
	 * Entities
	 * @default {}
	 */
	entities?: Record<string, string[]>
	/**
	 * Role Names
	 * @default []
	 */
	role_names?: string[]
	/**
	 * Permissions
	 * @default []
	 */
	permissions?: string[]
	/**
	 * Unavailable Permissions
	 * @default []
	 */
	unavailable_permissions?: string[]
}

/** UserModel */
export interface UserModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/**
	 * Email
	 * @format email
	 */
	email: string
	/** First Name */
	first_name?: string | null
	/** Last Name */
	last_name?: string | null
	/** Job Title */
	job_title?: string | null
	/** Departments */
	departments: UserDepartmentModel[]
	/** Apps */
	apps: UserAppModel[]
}

/** UserDepartmentModel */
export interface UserDepartmentModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
}

/** AddDepartmentUsersModel */
export interface AddDepartmentUsersModel {
	/** User Ids */
	user_ids: string[]
}

/** PermissionModel */
export interface PermissionModel {
	/** App Name */
	app_name: string
	/** Name */
	name: string
	/** Inner */
	inner: boolean
}

/** RoleModel */
export interface RoleModel {
	/** App */
	app: string
	/**
	 * Name
	 * @minLength 1
	 */
	name: string
	/** Permissions */
	permissions: string[]
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Read Only */
	read_only: boolean
	/** Users Count */
	users_count: number
}

/** RoleDataModel */
export interface RoleDataModel {
	/** App */
	app: string
	/**
	 * Name
	 * @minLength 1
	 */
	name: string
	/** Permissions */
	permissions: string[]
}

/** RoleUpdateDataModel */
export interface RoleUpdateDataModel {
	/** Name */
	name?: string | null
	/** Permissions */
	permissions: string[]
}

/** ServiceAccountModel */
export interface ServiceAccountModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Client Id */
	client_id: string
	/** Description */
	description?: string | null
	user: UserModel
}

/** ServiceAccountDataModel */
export interface ServiceAccountDataModel {
	/**
	 * Client Id
	 * @pattern ^[a-z]+(-[a-z]+)*$
	 */
	client_id: string
	/** Description */
	description?: string | null
	/** Apps */
	apps: UserAppDataModel[]
}

/** ServiceAccountSecretModel */
export interface ServiceAccountSecretModel {
	/** Token Endpoint */
	token_endpoint: string
	data: ClientSecretDataModel
}

/** ClientSecretDataModel */
export interface ClientSecretDataModel {
	/** Grant Type */
	grant_type: 'client_credentials'
	/** Client Id */
	client_id: string
	/** Client Secret */
	client_secret: string
}

/** UsersModel */
export interface UsersModel {
	/** Users */
	users: UserModel[]
	/** Domains */
	domains: string[]
}

/** UserDataModel */
export interface UserDataModel {
	/**
	 * Email
	 * @format email
	 */
	email: string
	/** First Name */
	first_name?: string | null
	/** Last Name */
	last_name?: string | null
	/** Job Title */
	job_title?: string | null
	/** Apps */
	apps: UserAppDataModel[]
}

/** UserProfileDataModel */
export interface UserProfileDataModel {
	/** First Name */
	first_name?: string | null
	/** Last Name */
	last_name?: string | null
}

/** Metric */
export interface Metric {
	/** Name */
	name: string
	/** Description */
	description: string
	/** Is Accumulative */
	is_accumulative: boolean
	measure: MetricMeasure
	delta_type: MetricDeltaType
	table: TableType
	type: MetricType
	/** Formula Sql */
	formula_sql: string
	/** Formula Sql Conditional */
	formula_sql_conditional: string | null
	/** Formula Text */
	formula_text: string
}

/** BIRevision */
export interface BIRevision {
	/** Name */
	name: string
	/**
	 * Date
	 * @format date
	 */
	date: string
	/** Period Days */
	period_days: number
	/** Periods */
	periods: number
	/** Last */
	last: boolean
}

/** BIRequest */
export interface BIRequest {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Metrics */
	metrics: string[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/**
	 * Product Filters
	 * @default []
	 */
	product_filters?: FilterRuleModel[]
	/** Date Aggregation */
	date_aggregation:
		'date_key' | 'week_key' | 'month_key' | 'quarter_key' | 'year_key' | null
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: (
		| 'sku'
		| 'brand'
		| 'category_1_lvl_id'
		| 'optimization_group'
		| 'optimization_group_id'
		| 'product_group'
		| 'product_group_id'
		| 'pricing_campaign_name'
		| 'pricing_campaign_engine'
		| 'diff_esp_pp_int'
		| 'optimization_lag'
		| 'price_change_status'
	)[]
	/**
	 * Skip Dates
	 * @default false
	 */
	skip_dates?: boolean
	/** Currency */
	currency?: string | null
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** FilterRule */
export type FilterRuleModel = ValueFilterRule | ReferenceFilterRule

/**
 * BinaryNumericFilterRule
 * Rule for filtering numeric fields.
 * @example {"name":"price","operation":"eq","value":10}
 */
export interface BinaryNumericFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'gt' | 'lt' | 'lte' | 'gte' | 'eq' | 'ne'
	/** Value */
	value: number
}

/**
 * TernaryNumericFilterRule
 * Rule for filtering numeric values within a specified range.
 * @example {"name":"price","operation":"num_between","value":[10,100]}
 */
export interface TernaryNumericFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'num_between'
	/**
	 * Value
	 * @maxItems 2
	 * @minItems 2
	 */
	value: [number, number]
}

/**
 * BooleanFilterRule
 * Rule for filtering by boolean conditions.
 * @example {"name":"is_available","operation":"bl","value":true}
 */
export interface BooleanFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'bl' | 'is_empty' | 'is_not_empty'
	/** Value */
	value: boolean | '0' | '1' | 0 | 1
}

/**
 * StringFilterRule
 * Rule for filtering string fields.
 * @example {"name":"url","operation":"contains","value":"test"}
 */
export interface StringFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'select' | 'is' | 'is_not' | 'contains' | 'not_contains'
	/** Value */
	value: string
}

/**
 * NullableStringArrayFilterRule
 * Rule for filtering string fields based on inclusion or exclusion from a list.
 */
export interface NullableStringArrayFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'in' | 'not_in'
	/** Value */
	value: (string | null)[]
}

/**
 * StringArrayFilterRule
 * Rule for filtering list-like fields.
 * @example {"name":"promo_types","operation":"array_any_of","value":["PROMOTION"]}
 */
export interface StringArrayFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'array_any_of' | 'array_all_of' | 'array_none_of' | 'array_exact'
	/** Value */
	value: string[]
}

/**
 * BinaryDateFilterRule
 * Rule for filtering by dates comparison.
 * @example {"name":"created_at","operation":"date_at","value":"2023-01-1"}
 */
export interface BinaryDateFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'date_after' | 'date_before' | 'date_at'
	/**
	 * Value
	 * @format date
	 */
	value: string
}

/**
 * TernaryDateFilterRule
 * Rule for date range filtering.
 * @example {"name":"collected_at","operation":"date_between","value":["2023-01-1","2023-12-31"]}
 */
export interface TernaryDateFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation: 'date_between'
	/**
	 * Value
	 * @maxItems 2
	 * @minItems 2
	 */
	value: [string, string]
}

/** ReferenceFilterRule */
export interface ReferenceFilterRule {
	/** Name */
	name: string
	/** Operation */
	operation:
		| 'gt'
		| 'lt'
		| 'lte'
		| 'gte'
		| 'eq'
		| 'ne'
		| 'bl'
		| 'select'
		| 'is'
		| 'is_not'
		| 'contains'
		| 'not_contains'
		| 'in'
		| 'not_in'
		| 'array_any_of'
		| 'array_all_of'
		| 'array_none_of'
		| 'array_exact'
		| 'date_after'
		| 'date_before'
		| 'date_at'
	/** Reference */
	reference: string
}

/** BIResponse */
export interface BIResponse {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Filters */
	filters: FilterRuleModel[]
	/** Product Filters */
	product_filters: FilterRuleModel[]
	/** Meta */
	meta: string[]
	/** Data */
	data: any[][]
}

/** CPIRequestModel */
export interface CPIRequestModel {
	/**
	 * Product Filters
	 * @default []
	 */
	product_filters?: FilterRuleModel[]
	/**
	 * Cd Filters
	 * @default []
	 */
	cd_filters?: FilterRuleModel[]
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: ('category_ids' | 'competitor_name')[]
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** CPIResponseModel */
export interface CPIResponseModel {
	/** Cpi */
	cpi: number
	/** Products Count */
	products_count: number
	/** Category Ids */
	category_ids?: string[] | null
	/** Competitor Name */
	competitor_name?: string | null
}

/** BIRevenueRequest */
export interface BIRevenueRequest {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/**
	 * Revenue Start Date
	 * @format date
	 */
	revenue_start_date: string
	/**
	 * Revenue End Date
	 * @format date
	 */
	revenue_end_date: string
	/** Metrics */
	metrics: string[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: ('optimization_lag' | 'price_change_status' | 'pricing_type')[]
	/** Currency */
	currency?: string | null
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** BIRevenueResponse */
export interface BIRevenueResponse {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Filters */
	filters: FilterRuleModel[]
	/** Meta */
	meta: string[]
	/** Data */
	data: any[][]
}

/** BIImpactRequest */
export interface BIImpactRequest {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Metrics */
	metrics: string[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: 'week_num'[]
	/** Currency */
	currency?: string | null
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** BIImpactResponse */
export interface BIImpactResponse {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Filters */
	filters: FilterRuleModel[]
	/** Meta */
	meta: string[]
	/** Data */
	data: any[][]
}

/** BIAIRequest */
export interface BIAIRequest {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Metrics */
	metrics: string[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/** Date Aggregation */
	date_aggregation:
		'date_key' | 'week_key' | 'month_key' | 'quarter_key' | 'year_key' | null
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: (
		'optimization_group_id' | 'pricing_line_id' | 'category_ids' | 'brand_id'
	)[]
	/**
	 * Skip Dates
	 * @default false
	 */
	skip_dates?: boolean
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** BIAIResponse */
export interface BIAIResponse {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Filters */
	filters: FilterRuleModel[]
	/** Meta */
	meta: string[]
	/** Data */
	data: any[][]
}

/**
 * MatchedProductsRequest
 * @minItems 1
 */
export type MatchedProductsRequest = PricingCampaignOrderAssignmentModel[]

/** PricingCampaignOrderAssignmentModel */
export interface PricingCampaignOrderAssignmentModel {
	/** Id */
	id: string
	/** Order */
	order: number
	/** Assignments */
	assignments: AssignmentModel[]
}

/** AssignmentModel */
export interface AssignmentModel {
	/** Id */
	id: string
	/**
	 * Filters
	 * @minItems 1
	 */
	filters: FilterRuleModel[]
}

/** MatchedProductsResponse */
export interface MatchedProductsResponse {
	/** Pricing Campaigns */
	pricing_campaigns: PricingCampaignCountModel[]
}

/** PricingCampaignCountModel */
export interface PricingCampaignCountModel {
	/** Id */
	id: string
	/** Count */
	count: number
}

/** TreeMapRequestModel */
export interface TreeMapRequestModel {
	/** Optimization Group Ids */
	optimization_group_ids?: string[] | null
	/** Pos Ids */
	pos_ids?: string[] | null
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/** Currency */
	currency?: string | null
}

/** TreeMapSalesEntityModel */
export interface TreeMapSalesEntityModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Sales Entity Id */
	sales_entity_id: string
	/** Sales Level Id */
	sales_level_id: number
	/** Products */
	products: number
	/** Revenue */
	revenue: number
	/** Revenue With Alerts */
	revenue_with_alerts: number
}

/** TreeMapProductGroupModel */
export interface TreeMapProductGroupModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Product Group Id
	 * @format uuid
	 */
	product_group_id: string
	/** Category Id */
	category_id: string | null
	/** Products */
	products: number
	/** Revenue */
	revenue: number
	/** Revenue With Alerts */
	revenue_with_alerts: number
}

/** StatisticsRequest */
export interface StatisticsRequest {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/** Metrics */
	metrics: string[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: string[]
	/** Currency */
	currency?: string | null
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** OptimizationIDModel */
export interface OptimizationIDModel {
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
}

/** StatisticsResponse */
export interface StatisticsResponse {
	/** Filters */
	filters: FilterRuleModel[]
	/** Meta */
	meta: string[]
	/** Data */
	data: any[][]
}

/** StatisticsRepricingRequest */
export interface StatisticsRepricingRequest {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** StatisticsRepricingResponse */
export interface StatisticsRepricingResponse {
	settings: SettingsDataUnit
	/** Metrics */
	metrics: MetricModel[]
}

/** SettingsDataUnit */
export interface SettingsDataUnit {
	strategy: StrategyDataUnit
	business: BusinessDataUnit
}

/** StrategyDataUnit */
export interface StrategyDataUnit {
	/** Target */
	target: string | null
	/** Protect */
	protect: string | null
}

/** BusinessDataUnit */
export interface BusinessDataUnit {
	/** Max Pricing Line Numbers */
	max_pricing_line_numbers: number | null
}

/** MetricModel */
export interface MetricModel {
	/** Group Type */
	group_type: string | null
	/** Group Value */
	group_value: string | null
	/** Name */
	name: string
	/** Value */
	value: number
}

/** StatisticsInterpretabilityRequest */
export interface StatisticsInterpretabilityRequest {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/** Currency */
	currency?: string | null
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
	/**
	 * Dimensions
	 * @default []
	 */
	dimensions?: 'category_ids'[]
}

/** StatisticsInterpretabilityResponse */
export interface StatisticsInterpretabilityResponse {
	/** Optimization Id */
	optimization_id: string | null
	/** Metrics */
	metrics: Record<string, any>
	elasticity: ElasticityDataUnit
}

/** ElasticityDataUnit */
export interface ElasticityDataUnit {
	/** Low */
	low: number
	/** Medium */
	medium: number
	/** High */
	high: number
	/** Median */
	median: number | null
	/** Raw */
	raw: ElasticityRawDataUnit[]
}

/** ElasticityRawDataUnit */
export interface ElasticityRawDataUnit {
	/** Bin */
	bin: number
	/** Height */
	height: number
}

/** StatisticsInterpretabilityGroupedResponseModel */
export interface StatisticsInterpretabilityGroupedResponseModel {
	/** Optimization Id */
	optimization_id: string | null
	/** Metrics */
	metrics: Record<string, any>
	elasticity: ElasticityDataUnit
	/** Category Ids */
	category_ids: string[]
}

/** StatisticsTargetProtectDistributionRequest */
export interface StatisticsTargetProtectDistributionRequest {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/** Currency */
	currency?: string | null
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
}

/** TargetProtectDistributionModel */
export interface TargetProtectDistributionModel {
	/** Metric */
	metric: string
	/** Type */
	type: 'target' | 'protect' | 'other'
	/** Value */
	value: number
}

/** StatisticsMultipleInterpretabilityRequest */
export interface StatisticsMultipleInterpretabilityRequest {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/** Currency */
	currency?: string | null
}

/** StatisticsOptimizationStatisticsRequest */
export interface StatisticsOptimizationStatisticsRequest {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/** Currency */
	currency?: string | null
}

/** OptimizationStatisticModel */
export interface OptimizationStatisticModel {
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
	/** Total */
	total: number
	/** Price Locked */
	price_locked: number | null
	/** Price Decreased */
	price_decreased: number | null
	/** Price Increased */
	price_increased: number | null
	/** Price Not Changed */
	price_not_changed: number | null
	/** Average Price Init */
	average_price_init: number | null
	/** Average Price Opt */
	average_price_opt: number | null
}

/** AlertInfoRequestModel */
export interface AlertInfoRequestModel {
	/**
	 * Optimization Group Ids
	 * @default []
	 */
	optimization_group_ids?: string[]
	group_by?: AlertGroupBy | null
	/**
	 * Total By Group
	 * @default false
	 */
	total_by_group?: boolean
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/** Currency */
	currency?: string | null
}

/** AlertsInfoResponseModel */
export interface AlertsInfoResponseModel {
	/** By Id */
	by_id: AlertInfoModel[]
	/** By Level */
	by_level: AlertInfoModel[]
}

/** AlertInfoModel */
export interface AlertInfoModel {
	/** Products */
	products: number
	/** Pricing Lines */
	pricing_lines: number
	/** Est Revenue */
	est_revenue: number
	/** Est Revenue Share */
	est_revenue_share: number
	/**
	 * Optimization Group Id
	 * Only present if group_by=optimization_group_id
	 */
	optimization_group_id?: string | null
	/**
	 * Pricing Campaign Id
	 * Only present if group_by=pricing_campaign_id
	 */
	pricing_campaign_id?: string | null
	/**
	 * Id
	 * Only present in by_id collection
	 */
	id?: string | null
	/** Level */
	level: string
}

/** PredictMetricModel */
export interface PredictMetricModel {
	/** Line Id */
	line_id: string
	/** Init Sales */
	init_sales?: number | null
	/** Optimal Sales */
	optimal_sales?: number | null
	/** Init Revenue */
	init_revenue?: number | null
	/** Optimal Revenue */
	optimal_revenue?: number | null
	/** Init Gross Profit */
	init_gross_profit?: number | null
	/** Optimal Gross Profit */
	optimal_gross_profit?: number | null
	/** Init Margin */
	init_margin?: number | null
	/** Optimal Margin */
	optimal_margin?: number | null
}

/** OptimizationPricesModel */
export interface OptimizationPricesModel {
	/** Line Id */
	line_id: string
	/** Init Price */
	init_price?: number | null
	/** Optimal Price */
	optimal_price?: number | null
	/** Final Price */
	final_price?: number | null
	/** Init Esp */
	init_esp?: number | null
	/** Optimal Esp */
	optimal_esp?: number | null
	/** Final Esp */
	final_esp?: number | null
}

/** MultipleAlertInfoModel */
export interface MultipleAlertInfoModel {
	/** Products */
	products: number
	/** Pricing Lines */
	pricing_lines: number
	/** Est Revenue */
	est_revenue: number
	/** Est Revenue Share */
	est_revenue_share: number
	/**
	 * Optimization Group Id
	 * Only present if group_by=optimization_group_id
	 */
	optimization_group_id?: string | null
	/**
	 * Pricing Campaign Id
	 * Only present if group_by=pricing_campaign_id
	 */
	pricing_campaign_id?: string | null
	/**
	 * Id
	 * Only present in by_id collection
	 */
	id?: string | null
	/** Level */
	level: string
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
}

/** PricingLineSearchRequest */
export interface PricingLineSearchRequest {
	/** Search */
	search: string | null
	/** Filters */
	filters: FilterRuleModel[]
	/** Limit */
	limit: number
	/** Offset */
	offset: number
	/** Order By */
	order_by: OrderByNode[]
}

/** OrderByNode */
export interface OrderByNode {
	/** Name */
	name: string
	/** Direction */
	direction: 'asc' | 'desc'
}

/** PricingLineSearchResponse */
export interface PricingLineSearchResponse {
	/** Pricing Line Count */
	pricing_line_count: number
	/** Product Count */
	product_count: number
	/** Pricing Lines */
	pricing_lines: [string, string][]
}

/** ProductsByEntityRequestModel */
export interface ProductsByEntityRequestModel {
	/** Filters */
	filters?: FilterRuleModel[] | null
	/** Currency */
	currency?: string | null
}

/** ProductsByEngineModel */
export interface ProductsByEngineModel {
	/**
	 * Pricing Campaign Engine
	 * @default "unassigned"
	 */
	pricing_campaign_engine?: string
	/**
	 * Product Count
	 * @default 0
	 */
	product_count?: number
	/**
	 * Price Points
	 * @default 0
	 */
	price_points?: number
	/**
	 * Price Points Percent
	 * @default 0
	 */
	price_points_percent?: number
	/**
	 * Revenue
	 * @default 0
	 */
	revenue?: number
}

/** ProductsByOptimizationStatusModel */
export interface ProductsByOptimizationStatusModel {
	/** Is Optimized */
	is_optimized: boolean
	/**
	 * Product Count
	 * @default 0
	 */
	product_count?: number
	/**
	 * Price Points
	 * @default 0
	 */
	price_points?: number
	/**
	 * Price Points Percent
	 * @default 0
	 */
	price_points_percent?: number
	/**
	 * Revenue
	 * @default 0
	 */
	revenue?: number
}

/** RepricingMetricsRequestModel */
export interface RepricingMetricsRequestModel {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	/**
	 * Filters
	 * @default []
	 */
	filters?: FilterRuleModel[]
	/**
	 * Label
	 * @default "unknown"
	 */
	label?: string
	/** Currency */
	currency?: string | null
}

/** RepricingMetricsModel */
export interface RepricingMetricsModel {
	/** Average Price Change Percent */
	average_price_change_percent: number
}

/** MultipleAlertInfoRequestModel */
export interface MultipleAlertInfoRequestModel {
	/** Optimizations */
	optimizations: OptimizationIDModel[]
	group_by?: AlertGroupBy | null
	/**
	 * Total By Group
	 * @default false
	 */
	total_by_group?: boolean
	/** Currency */
	currency?: string | null
}

/** MultipleAlertsInfoResponseModel */
export interface MultipleAlertsInfoResponseModel {
	/** By Id */
	by_id: MultipleAlertInfoModel[]
	/** By Level */
	by_level: MultipleAlertInfoModel[]
}

/** CampaignModel */
export interface CampaignModel {
	/** Id */
	id: number
	/** Name */
	name: string
}

/** UsageStatisticsRequestModel */
export interface UsageStatisticsRequestModel {
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * End Date
	 * @format date
	 */
	end_date: string
	/** Date Aggregation */
	date_aggregation?: 'day' | 'week' | 'month'
	/** Campaign Ids */
	campaign_ids?: number[]
}

/** UsageStatisticsModel */
export interface UsageStatisticsModel {
	/**
	 * Date
	 * @format date
	 */
	date: string
	/** Data Points */
	data_points: number
	/** Matchings */
	matchings: number
	/** Initial Matchings */
	initial_matchings: number
	/** Rematching Matchings */
	rematching_matchings: number
}

/** TicketQueryRequest */
export interface TicketQueryRequest {
	/**
	 * Limit
	 * @default 50
	 */
	limit?: number
	/**
	 * Start
	 * @default 0
	 */
	start?: number
	/** Search Term */
	search_term?: string
	/** Request Language */
	request_language: string
	/** Request Status */
	request_status: 'ALL_REQUESTS' | 'OPEN_REQUESTS' | 'CLOSED_REQUESTS'
	/** Request Type Id */
	request_type_id?: string
}

/** Body_create_ticket_api_v1_tickets_post */
export interface BodyCreateTicketApiV1TicketsPost {
	/** Summary */
	summary: string
	/** Description */
	description: string
	/** Request Type Id */
	request_type_id: string
	/**
	 * Attachments
	 * @default []
	 */
	attachments?: File[]
}

/** VideoModel */
export interface VideoModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Thumbnail */
	thumbnail: string
	/** Tags */
	tags: string[]
	/** Language */
	language?: string
	/** App */
	app?: string
	/** Url */
	url: string
}

/** GlobalPCSetModel */
export interface GlobalPCSetModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Is Main */
	is_main: boolean
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/** Created By */
	created_by?: string | null
	/** Updated At */
	updated_at?: string | null
	/** Updated By */
	updated_by?: string | null
}

/** GlobalPCSetCreateDataModel */
export interface GlobalPCSetCreateDataModel {
	/** Id */
	id?: string | null
	/** Name */
	name: string
}

/** GlobalPCSetUpdateDataModel */
export interface GlobalPCSetUpdateDataModel {
	/** Name */
	name: string
}

/** PricingCampaignModel */
export interface PricingCampaignModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Global Pc Set Id */
	global_pc_set_id?: string | null
	/** Optimization Group Id */
	optimization_group_id?: string | null
	/** Scenario Id */
	scenario_id?: string | null
	/** Order */
	order: number
	settings: PricingCampaignSettingsModel
	/** Updated At */
	updated_at?: string | null
	/** Updated By */
	updated_by?: string | null
}

/** FailedPendingResponse */
export interface FailedPendingResponse {
	/** Detail */
	detail: FailedPendingErrorModel[]
}

/** FailedPendingErrorModel */
export interface FailedPendingErrorModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Msg */
	msg: string
}

/** PricingCampaignCreateDataModel */
export interface PricingCampaignCreateDataModel {
	/** Id */
	id?: string | null
	/** Name */
	name: string
	/** Global Pc Set Id */
	global_pc_set_id?: string | null
	/** Optimization Group Id */
	optimization_group_id?: string | null
	/** Scenario Id */
	scenario_id?: string | null
	/** Settings */
	settings: Record<string, any>
}

/** PricingCampaignOverviewModel */
export interface PricingCampaignOverviewModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Global Pc Set Id */
	global_pc_set_id?: string | null
	/** Optimization Group Id */
	optimization_group_id?: string | null
	/** Scenario Id */
	scenario_id?: string | null
	/** Order */
	order: number
	/** Engine */
	engine: 'ML' | 'RB' | 'MD' | 'Promo'
	/** Rule Id */
	rule_id?: string | null
	/** Pricing Rule Id */
	pricing_rule_id?: string | null
	/** Pricing Rule Version Id */
	pricing_rule_version_id?: string | null
	/** Pricing Rule Name */
	pricing_rule_name?: string | null
	/** Pricing Rule Version */
	pricing_rule_version?: string | null
	/** Start Date */
	start_date?: string | null
	/** End Date */
	end_date?: string | null
	/** Updated At */
	updated_at?: string | null
	/** Updated By */
	updated_by?: string | null
}

/** PricingCampaignUpdateDataModel */
export interface PricingCampaignUpdateDataModel {
	/** Name */
	name?: string | null
	/** Settings */
	settings?: Record<string, any> | null
}

/** PricingCampaignProductsFilters */
export interface PricingCampaignProductsFilters {
	/** Filters */
	filters: FilterRuleModel[]
}

/** GlobalPcSetReorderRequest */
export interface GlobalPcSetReorderRequest {
	/**
	 * Scope
	 * @default "global_pc_set"
	 */
	scope?: 'global_pc_set'
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	global_pc_set_id: string
	/**
	 * Pricing Campaigns
	 * @minItems 1
	 */
	pricing_campaigns: PricingCampaignOrderModel[]
}

/** PricingCampaignOrderModel */
export interface PricingCampaignOrderModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Order */
	order: number
}

/** ScenarioReorderRequest */
export interface ScenarioReorderRequest {
	/**
	 * Scope
	 * @default "scenario"
	 */
	scope?: 'scenario'
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenario_id: string
	/**
	 * Pricing Campaigns
	 * @minItems 1
	 */
	pricing_campaigns: PricingCampaignOrderModel[]
}

/** PricingCampaignProductCountReorderRequestModel */
export interface PricingCampaignProductCountReorderRequestModel {
	/** Scenario Id */
	scenario_id: string | null
	/** Pricing Campaigns */
	pricing_campaigns: PricingCampaignOrderModel[]
}

/** PricingCampaignMatchedProductsCountResponseModel */
export interface PricingCampaignMatchedProductsCountResponseModel {
	/** Id */
	id: string
	/** Pricing Line Count */
	pricing_line_count: number
	/** Product Count */
	product_count: number
}

/** PricingCampaignProductCountRequestModel */
export interface PricingCampaignProductCountRequestModel {
	/** Id */
	id?: string | null
	/** Scenario Id */
	scenario_id?: string | null
	/** Settings */
	settings: Record<string, any>
	/** Order */
	order: number
}

/** PricingCampaignDuplicateRequest */
export interface PricingCampaignDuplicateRequest {
	/** Src Pricing Campaign Ids */
	src_pricing_campaign_ids: string[]
	/** Dst Entity Ids */
	dst_entity_ids: (string | null)[]
	/** Dst Entity Type */
	dst_entity_type: 'scenario' | 'optimization_group' | 'global_pc_set'
}

/** PricingCampaignReassignRequest */
export interface PricingCampaignReassignRequest {
	/** Src Pricing Campaign Ids */
	src_pricing_campaign_ids: string[]
	/**
	 * Dst Optimization Group Id
	 * @format uuid
	 */
	dst_optimization_group_id: string
}

/** PricingCampaignReassignResponseModel */
export interface PricingCampaignReassignResponseModel {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricing_campaign_id: string
	/** Success */
	success: boolean
	/** Message */
	message: string
}

/** PricingCampaignSettingsExportResponseModel */
export interface PricingCampaignSettingsExportResponseModel {
	/** Url */
	url: string
}

/** PricingCampaignCopySettingsRequestModel */
export interface PricingCampaignCopySettingsRequestModel {
	/** Dst Pricing Campaign Ids */
	dst_pricing_campaign_ids: string[]
	/** Pricing Campaign Settings */
	pricing_campaign_settings: Record<string, any>
}

/** PricingCampaignCopySettingsResponseModel */
export interface PricingCampaignCopySettingsResponseModel {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricing_campaign_id: string
	/** Success */
	success: boolean
	/** Message */
	message: string
}

/** CatalogResponseModel */
export interface CatalogResponseModel {
	/** Total */
	total: number
	/** Data */
	data: CatalogPricingRuleModel[]
}

/** CatalogPricingRuleModel */
export interface CatalogPricingRuleModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Description */
	description?: string | null
	/** Source */
	source: 'system' | 'user'
	/** Version Id */
	version_id?: string | null
	/** Version */
	version?: string | null
	/** Marked Name */
	marked_name?: string | null
	/** Params */
	params: CatalogParamModel[]
}

/** CatalogParamModel */
export interface CatalogParamModel {
	/** Id */
	id: string
	/** Type */
	type: string
	/** Default */
	default?: any
	/** Label */
	label?: string | null
	/**
	 * Required
	 * @default false
	 */
	required?: boolean
	/** Options */
	options?: any[]
}

/** PricingRuleListResponseModel */
export interface PricingRuleListResponseModel {
	/** Total */
	total: number
	/** Data */
	data: PricingRuleModel[]
}

/** PricingRuleModel */
export interface PricingRuleModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Description */
	description: string | null
	/** Is Archived */
	is_archived: boolean
	/** Published At */
	published_at?: string | null
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/**
	 * Created By
	 * @format uuid
	 */
	created_by: string
	/**
	 * Updated At
	 * @format date-time
	 */
	updated_at: string
	/**
	 * Updated By
	 * @format uuid
	 */
	updated_by: string
}

/** PricingRuleCreateModel */
export interface PricingRuleCreateModel {
	/**
	 * Id
	 * @format uuid
	 */
	id?: string
	/** Name */
	name: string
	/** Description */
	description?: string | null
}

/** PricingRuleUpdateModel */
export interface PricingRuleUpdateModel {
	/** Name */
	name?: string | null
	/** Description */
	description?: string | null
}

/** PricingRuleVersionModel */
export interface PricingRuleVersionModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricing_rule_id: string
	/** Version */
	version: string
	rule: PricingRuleBodyModel
	/** Hash */
	hash: string
	/** Marked Name */
	marked_name: string | null
	/** Marked Comment */
	marked_comment: string | null
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/**
	 * Created By
	 * @format uuid
	 */
	created_by: string
	/**
	 * Updated At
	 * @format date-time
	 */
	updated_at: string
	/**
	 * Updated By
	 * @format uuid
	 */
	updated_by: string
}

/** PricingRuleBodyModel */
export interface PricingRuleBodyModel {
	/** Variables */
	variables: RuleVariableModel[]
	logic: RuleLogicModel
}

/** RuleVariableModel */
export interface RuleVariableModel {
	/** Id */
	id: string
	/** Label */
	label: string | null
	/** Type */
	type: string
	/** Default */
	default: number | string | boolean | null
}

/** RuleLogicModel */
export interface RuleLogicModel {
	viewport: RuleViewportModel
	/** Nodes */
	nodes: RuleNodeModel[]
	/** Edges */
	edges: RuleEdgeModel[]
}

/** RuleViewportModel */
export interface RuleViewportModel {
	/** X */
	x: number
	/** Y */
	y: number
	/** Zoom */
	zoom: number
}

/** RuleNodeModel */
export interface RuleNodeModel {
	/** Id */
	id: string
	/** Type */
	type: string
	/** Data */
	data: Record<string, any>
	viewport: NodeViewportModel
}

/** NodeViewportModel */
export interface NodeViewportModel {
	position: NodePositionModel
	position_absolute: NodePositionModel
	/** Target Position */
	target_position: string
	/** Source Position */
	source_position: string
	/** Width */
	width: number
	/** Height */
	height: number
}

/** NodePositionModel */
export interface NodePositionModel {
	/** X */
	x: number
	/** Y */
	y: number
}

/** RuleEdgeModel */
export interface RuleEdgeModel {
	/** Source */
	source: string
	/** Source Handle */
	source_handle: string
	/** Target Handle */
	target_handle: string
	/** Target */
	target: string
}

/** PricingRuleDraftSaveModel */
export interface PricingRuleDraftSaveModel {
	rule: PricingRuleBodyModel
	/** Hash */
	hash: string
}

/** PricingRuleImportForm */
export interface PricingRuleImportForm {
	/** File */
	file: File | Blob
}

/** PricingRulePublishModel */
export interface PricingRulePublishModel {
	/** Marked Name */
	marked_name?: string | null
	/** Marked Comment */
	marked_comment?: string | null
}

/** PricingRuleVersionListResponseModel */
export interface PricingRuleVersionListResponseModel {
	/** Total */
	total: number
	/** Data */
	data: PricingRuleVersionModel[]
}

/** PricingRuleVersionUpdateModel */
export interface PricingRuleVersionUpdateModel {
	/** Marked Name */
	marked_name?: string | null
	/** Marked Comment */
	marked_comment?: string | null
}

/** PricingRuleArchivedErrorResponse */
export interface PricingRuleArchivedErrorResponse {
	/** Code */
	code: 'RULE_004'
	/** Message */
	message: 'pricing_rule_archived'
	/** Detail */
	detail: PricingRuleRefDetail[]
}

/** PricingRuleRefDetail */
export interface PricingRuleRefDetail {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricing_rule_id: string
}

/** PricingRuleNotPublishedErrorResponse */
export interface PricingRuleNotPublishedErrorResponse {
	/** Code */
	code: 'RULE_005'
	/** Message */
	message: 'pricing_rule_not_published'
	/** Detail */
	detail: PricingRuleRefDetail[]
}

/** PricingRuleApplyModel */
export interface PricingRuleApplyModel {
	/**
	 * Pricing Campaign Ids
	 * @minItems 1
	 */
	pricing_campaign_ids: string[]
	/**
	 * Force Update
	 * @default false
	 */
	force_update?: boolean
}

/** PricingRuleApplyErrorResponse */
export interface PricingRuleApplyErrorResponse {
	/** Code */
	code: 'RULE_003'
	/** Message */
	message: 'pricing_rule_apply_failed'
	/** Detail */
	detail: PricingRuleApplyErrorDetail[]
}

/** PricingRuleApplyErrorDetail */
export interface PricingRuleApplyErrorDetail {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricing_campaign_id: string
	/** Parameter Name */
	parameter_name: string
	error_type: RuleApplyErrorType
}

/** QueryScenarioRunSetRequestModel */
export interface QueryScenarioRunSetRequestModel {
	/** Filters */
	filters: FilterRuleModel[]
	/** Limit */
	limit: number | null
	/** Offset */
	offset: number | null
}

/** QueryScenarioRunSetResponseModel */
export interface QueryScenarioRunSetResponseModel {
	/** Data */
	data: ScenarioRunSetModel[]
	/** Total */
	total: number
}

/** ScenarioRunSetModel */
export interface ScenarioRunSetModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/**
	 * Created By
	 * @format uuid
	 */
	created_by: string
	/** Scenario Runs */
	scenario_runs: ScenarioRunModel[]
}

/** ScenarioRunModel */
export interface ScenarioRunModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenario_id: string
	/**
	 * Scenario Run Set Id
	 * @format uuid
	 */
	scenario_run_set_id: string
	/** Combination Id */
	combination_id: string
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	global_pc_set_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
	/** Settings */
	settings: Record<string, any>
}

/** ScenarioRunSetCreateModel */
export interface ScenarioRunSetCreateModel {
	/** Scenario Runs */
	scenario_runs: ScenarioRunCreateModel[]
}

/** ScenarioRunCreateModel */
export interface ScenarioRunCreateModel {
	/** Name */
	name: string
	/** Combination Id */
	combination_id: string
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	global_pc_set_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenario_id: string
	/** Settings */
	settings: Record<string, any>
}

/** ScenarioRunSetRestartModel */
export interface ScenarioRunSetRestartModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Scenario Runs */
	scenario_runs: ScenarioRunRestartModel[]
}

/** ScenarioRunRestartModel */
export interface ScenarioRunRestartModel {
	/** Id */
	id: string | null
	/** Name */
	name: string
	/** Combination Id */
	combination_id: string
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	global_pc_set_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenario_id: string
	/** Settings */
	settings: Record<string, any>
}

/** ScenarioQueryModel */
export interface ScenarioQueryModel {
	/** Optimization Group Ids */
	optimization_group_ids: string[] | null
}

/** ScenarioModel */
export interface ScenarioModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Description */
	description?: string | null
	scenario_type: ScenarioType
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Is Main */
	is_main: boolean
	settings: ScenarioSettingsModel
	/** Updated At */
	updated_at?: string | null
	/** Updated By */
	updated_by?: string | null
}

/** ScenarioCreateDataModel */
export interface ScenarioCreateDataModel {
	/** Id */
	id?: string | null
	/** Name */
	name: string
	/** Description */
	description?: string | null
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Settings */
	settings?: Record<string, any> | null
}

/** ScenarioUpdateDataModel */
export interface ScenarioUpdateDataModel {
	/** Name */
	name?: string | null
	/** Description */
	description?: string | null
	/** Settings */
	settings?: Record<string, any> | null
}

/** ScenarioMatchedProductsCountResponseModel */
export interface ScenarioMatchedProductsCountResponseModel {
	/** Pricing Line Count */
	pricing_line_count: number
	/** Product Count */
	product_count: number
}

/** ScenarioSetMainDataModel */
export interface ScenarioSetMainDataModel {
	settings?: ScenarioSetMainSettingsDataModel | null
}

/** ScenarioSetMainSettingsDataModel */
export interface ScenarioSetMainSettingsDataModel {
	/** Target */
	target: string
	/** Protect */
	protect: string
}

/** ScenarioMainCopySettings */
export interface ScenarioMainCopySettings {
	/** Dst Optimization Group Ids */
	dst_optimization_group_ids: string[]
	/** Copy Business Settings */
	copy_business_settings: boolean
	/** Copy Strategy Settings */
	copy_strategy_settings: boolean
	/** Copy Stop List Settings */
	copy_stop_list_settings: boolean
}

/** ScenarioMainCopySettingsResponseModel */
export interface ScenarioMainCopySettingsResponseModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Success */
	success: boolean
	/** Message */
	message: string
}

/** SettingsInterpretationResponseModel */
export interface SettingsInterpretationResponseModel {
	/** Children */
	children: any[]
	/** Data */
	data: Record<string, any>
}

/** SettingsTemplateQueryModel */
export interface SettingsTemplateQueryModel {
	/** Filters */
	filters?: FilterRuleModel[]
	/** Order By */
	order_by?: OrderByRule[]
	/** Limit */
	limit?: number | null
	/** Offset */
	offset?: number | null
}

/** OrderByRule */
export interface OrderByRule {
	/** Name */
	name: string
	/** Direction */
	direction: 'asc' | 'desc'
}

/** SettingsTemplateQueryResponseModel */
export interface SettingsTemplateQueryResponseModel {
	/** Total */
	total: number
	/** Data */
	data: SettingsTemplateModel[]
}

/** SettingsTemplateModel */
export interface SettingsTemplateModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Description */
	description?: string | null
	/** Is Favorite */
	is_favorite: boolean
	template_type: SettingsTemplateType
	/** Body */
	body: Record<string, any>
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/** Created By */
	created_by?: string | null
	/** Updated At */
	updated_at?: string | null
	/** Updated By */
	updated_by?: string | null
}

/** SettingsTemplateUpdateModel */
export interface SettingsTemplateUpdateModel {
	/** Name */
	name?: string | null
	/** Description */
	description?: string | null
	/**
	 * Is Favorite
	 * @default false
	 */
	is_favorite?: boolean | null
	/** Body */
	body?: Record<string, any> | null
}

/** SettingsTemplateCreateModel */
export interface SettingsTemplateCreateModel {
	/** Id */
	id?: string | null
	/** Name */
	name: string
	/** Description */
	description?: string | null
	/**
	 * Is Favorite
	 * @default false
	 */
	is_favorite?: boolean | null
	template_type: SettingsTemplateType
	/** Body */
	body: Record<string, any>
}

/** SettingsTemplateApplyRequestModel */
export interface SettingsTemplateApplyRequestModel {
	/** Ids */
	ids: string[]
	action: ApplyAction
}

/** AnchorsQueryModel */
export interface AnchorsQueryModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[]
	/** Order By */
	order_by?: OrderByModel[]
	/**
	 * Limit
	 * @default 100
	 */
	limit?: number
	/**
	 * Offset
	 * @default 0
	 */
	offset?: number
}

/** OrderByModel */
export interface OrderByModel {
	/** Name */
	name: string
	/** Direction */
	direction: 'asc' | 'desc'
}

/** AnchorsQueryResponseModel */
export interface AnchorsQueryResponseModel {
	/** Data */
	data: AnchorResponseModel[]
	/** Total */
	total: number
}

/** AnchorResponseModel */
export interface AnchorResponseModel {
	/** Sku */
	sku: string
	/** Sales Entity Id */
	sales_entity_id: string
	/** Optimization Group Id */
	optimization_group_id: string
	/** Title */
	title: string | null
	/** Line Id */
	line_id: string | null
	/** Line Name */
	line_name: string | null
	/** Category Id */
	category_id: string | null
	/** Category Name */
	category_name: string | null
	/** Cost */
	cost: number | null
	/** Last Price */
	last_price: number | null
	/** Alerts */
	alerts: string[] | null
	/** Flat Source Family Id */
	flat_source_family_id: string | null
	/** Flat Anchor Sku */
	flat_anchor_sku: string | null
	/** Flat Anchor Mul */
	flat_anchor_mul: number | null
	/** Flat Anchor Add */
	flat_anchor_add: number | null
	/** Flat Anchor Count */
	flat_anchor_count: number | null
	/** Size Source Family Id */
	size_source_family_id: string | null
	/** Size Anchor Sku */
	size_anchor_sku: string | null
	/** Size Anchor Mul */
	size_anchor_mul: number | null
	/** Size Anchor Add */
	size_anchor_add: number | null
	/** Size Anchor Count */
	size_anchor_count: number | null
	/** Bundle Source Family Id */
	bundle_source_family_id: string | null
	/** Bundle Anchor Sku */
	bundle_anchor_sku: string | null
	/** Bundle Anchor Mul */
	bundle_anchor_mul: number | null
	/** Bundle Anchor Add */
	bundle_anchor_add: number | null
	/** Bundle Anchor Count */
	bundle_anchor_count: number | null
	/** Ladder Source Family Id */
	ladder_source_family_id: string | null
	/** Ladder Anchor Sku */
	ladder_anchor_sku: string | null
	/** Ladder Anchor Mul */
	ladder_anchor_mul: number | null
	/** Ladder Anchor Add */
	ladder_anchor_add: number | null
	/** Ladder Anchor Count */
	ladder_anchor_count: number | null
	/** Product Set Source Family Id */
	product_set_source_family_id: string | null
	/** Product Set Anchor Sku */
	product_set_anchor_sku: string | null
	/** Product Set Anchor Mul */
	product_set_anchor_mul: number | null
	/** Product Set Anchor Add */
	product_set_anchor_add: number | null
	/** Product Set Anchor Count */
	product_set_anchor_count: number | null
	/**
	 * Updated At
	 * @format date-time
	 */
	updated_at: string
}

/** AnchorsExportModel */
export interface AnchorsExportModel {
	/**
	 * Format
	 * @default "csv"
	 */
	format?: 'csv' | 'xlsx'
	/** Filters */
	filters?: FilterRuleModel[]
	/** Order By */
	order_by?: OrderByModel[]
	/** Search */
	search?: string | null
}

/** AnchorsAlertsItemModel */
export interface AnchorsAlertsItemModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Description */
	description: string
	/** Level */
	level: string
}

/** AnchorsAlertsInfoQueryModel */
export interface AnchorsAlertsInfoQueryModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[]
}

/** AnchorsAlertsInfoModel */
export interface AnchorsAlertsInfoModel {
	/** Id */
	id: string
	/** Level */
	level: string
	/** Anchors */
	anchors: number
}

/** AnchorImportFileForm */
export interface AnchorImportFileForm {
	/** File */
	file: File | Blob
	/**
	 * Ignore Empties
	 * @default false
	 */
	ignore_empties?: boolean
}

/** AnchorsUpsertResponseModel */
export interface AnchorsUpsertResponseModel {
	/** Rows Updated */
	rows_updated: number
	/** Rows Inserted */
	rows_inserted: number
}

/** AnchorsUpsertModel */
export interface AnchorsUpsertModel {
	/** Anchors */
	anchors: AnchorModel[]
}

/** AnchorModel */
export interface AnchorModel {
	/** Sku */
	sku: string
	/** Sales Entity Id */
	sales_entity_id: string
	/** Optimization Group Id */
	optimization_group_id: string
	/** Flat Source Family Id */
	flat_source_family_id?: string | null
	/** Flat Anchor Sku */
	flat_anchor_sku?: string | null
	/** Flat Anchor Mul */
	flat_anchor_mul?: number | null
	/** Flat Anchor Add */
	flat_anchor_add?: number | null
	/** Size Source Family Id */
	size_source_family_id?: string | null
	/** Size Anchor Sku */
	size_anchor_sku?: string | null
	/** Size Anchor Mul */
	size_anchor_mul?: number | null
	/** Size Anchor Add */
	size_anchor_add?: number | null
	/** Bundle Source Family Id */
	bundle_source_family_id?: string | null
	/** Bundle Anchor Sku */
	bundle_anchor_sku?: string | null
	/** Bundle Anchor Mul */
	bundle_anchor_mul?: number | null
	/** Bundle Anchor Add */
	bundle_anchor_add?: number | null
	/** Ladder Source Family Id */
	ladder_source_family_id?: string | null
	/** Ladder Anchor Sku */
	ladder_anchor_sku?: string | null
	/** Ladder Anchor Mul */
	ladder_anchor_mul?: number | null
	/** Ladder Anchor Add */
	ladder_anchor_add?: number | null
	/** Product Set Source Family Id */
	product_set_source_family_id?: string | null
	/** Product Set Anchor Sku */
	product_set_anchor_sku?: string | null
	/** Product Set Anchor Mul */
	product_set_anchor_mul?: number | null
	/** Product Set Anchor Add */
	product_set_anchor_add?: number | null
}

/** AnchorsDeleteModel */
export interface AnchorsDeleteModel {
	/** Anchors */
	anchors: AnchorsDeleteItemModel[]
}

/** AnchorsDeleteItemModel */
export interface AnchorsDeleteItemModel {
	/** Sku */
	sku: string
	/** Sales Entity Id */
	sales_entity_id: string
	/** Optimization Group Id */
	optimization_group_id: string
}

/** AnchorsDeleteResponseModel */
export interface AnchorsDeleteResponseModel {
	/** Rows Deleted */
	rows_deleted: number
}

/** AnchorsSalesEntityResponseModel */
export interface AnchorsSalesEntityResponseModel {
	/** Sales Entity Id */
	sales_entity_id: string
}

/** AnchorStrategyQueryModel */
export interface AnchorStrategyQueryModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[]
	/**
	 * Limit
	 * @default 100
	 */
	limit?: number
	/**
	 * Offset
	 * @default 0
	 */
	offset?: number
	/** Order By */
	order_by?: OrderByModel[]
}

/** AnchorStrategyQueryResponseModel */
export interface AnchorStrategyQueryResponseModel {
	/** Data */
	data: AnchorStrategyModel[]
	/** Total */
	total: number
}

/** AnchorStrategyModel */
export interface AnchorStrategyModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	anchor_type: AnchorType
	settings: AnchorStrategySettingsModel
	/**
	 * Updated At
	 * @format date-time
	 */
	updated_at: string
	/**
	 * Updated By
	 * @format uuid
	 */
	updated_by: string
	/** Families Count */
	families_count: number
	/** Products Count */
	products_count: number
	/** Optimization Group Ids */
	optimization_group_ids: string[]
}

/** AnchorStrategySettingsModel */
export interface AnchorStrategySettingsModel {
	/** Groups */
	groups: AnchorStrategySettingsGroupModel[]
	indexes: AnchorStrategySettingsIndexesModel
	anchor_selection: AnchorStrategySettingsAnchorSelectionModel
	general: AnchorStrategySettingsGeneralModel
}

/** AnchorStrategySettingsGroupModel */
export interface AnchorStrategySettingsGroupModel {
	/**
	 * Id
	 * @format uuid
	 */
	id?: string
	/** Name */
	name: string
	/** Filters */
	filters: FilterRuleModel[]
	/** Aggregation */
	aggregation: string[]
	/** Clusterization */
	clusterization?: AnchorStrategyClusterizationModel[]
}

/** AnchorStrategyClusterizationModel */
export interface AnchorStrategyClusterizationModel {
	/** Column */
	column: string
	/**
	 * Percent
	 * @exclusiveMin 0
	 * @max 100
	 */
	percent: number
}

/** AnchorStrategySettingsIndexesModel */
export interface AnchorStrategySettingsIndexesModel {
	/** Index Type */
	index_type: 'add' | 'mul'
	/** Columns */
	columns: string[]
}

/** AnchorStrategySettingsAnchorSelectionModel */
export interface AnchorStrategySettingsAnchorSelectionModel {
	/** Filters */
	filters: FilterRuleModel[]
	/** Sorting */
	sorting: OrderByModel[]
}

/** AnchorStrategySettingsGeneralModel */
export interface AnchorStrategySettingsGeneralModel {
	/** Propagate Generated Anchors */
	propagate_generated_anchors: boolean
	/** Cleanup Generated Anchors */
	cleanup_generated_anchors: boolean
}

/** AnchorStrategyUpdateModel */
export interface AnchorStrategyUpdateModel {
	/** Name */
	name?: string | null
	settings?: AnchorStrategySettingsModel | null
	/** Optimization Group Ids */
	optimization_group_ids?: string[] | null
}

/** AnchorStrategyCreateModel */
export interface AnchorStrategyCreateModel {
	/**
	 * Id
	 * @format uuid
	 */
	id?: string
	/** Name */
	name: string
	anchor_type: AnchorType
	settings: AnchorStrategySettingsModel
	/** Optimization Group Ids */
	optimization_group_ids: string[]
}

/** AnchorStrategyMatchedProductsRequest */
export interface AnchorStrategyMatchedProductsRequest {
	/** Groups */
	groups: AnchorStrategySettingsGroupModel[]
	/** Optimization Group Ids */
	optimization_group_ids: string[]
}

/** AnchorStrategyGroupMatchedModel */
export interface AnchorStrategyGroupMatchedModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Products */
	products: number
	/** Families */
	families: number
}

/** AnchorGeneratedFamilyQueryModel */
export interface AnchorGeneratedFamilyQueryModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[]
	/**
	 * Limit
	 * @default 100
	 */
	limit?: number
	/**
	 * Offset
	 * @default 0
	 */
	offset?: number
}

/** AnchorGeneratedFamilyQueryResponseModel */
export interface AnchorGeneratedFamilyQueryResponseModel {
	/** Data */
	data: AnchorGeneratedFamilyModel[]
	/** Total */
	total: number
}

/** AnchorGeneratedFamilyModel */
export interface AnchorGeneratedFamilyModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Sales Entity Id */
	sales_entity_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	settings: AnchorStrategySettingsGroupModel
	/** Anchor Sku */
	anchor_sku: string
	anchor_type: AnchorType
	/**
	 * Anchor Strategy Id
	 * @format uuid
	 */
	anchor_strategy_id: string
	/** Anchor Strategy Name */
	anchor_strategy_name: string
	status: AnchorGeneratedFamilyStatus
	/** Anchor Count */
	anchor_count: number
	/** Anchor Generated Records */
	anchor_generated_records: AnchorGeneratedRecordModel[]
}

/** AnchorGeneratedRecordModel */
export interface AnchorGeneratedRecordModel {
	/** Sku */
	sku: string
	/** Line Id */
	line_id: string | null
	/** Line Name */
	line_name: string | null
	/** Sales Entity Id */
	sales_entity_id: string
	/**
	 * Anchor Strategy Id
	 * @format uuid
	 */
	anchor_strategy_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Anchor Generated Family Id
	 * @format uuid
	 */
	anchor_generated_family_id: string
	anchor_type: AnchorType
	/** Anchor Sku */
	anchor_sku: string | null
	/** Anchor Add */
	anchor_add: number | null
	/** Anchor Mul */
	anchor_mul: number | null
}

/** AnchorGeneratedFamilyReviewRequestModel */
export interface AnchorGeneratedFamilyReviewRequestModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[]
	/** Status */
	status: 'approved' | 'rejected'
}

/** ProductCatalogQueryModel */
export interface ProductCatalogQueryModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[][]
	/** Order By */
	order_by?: OrderByModel[]
	/**
	 * Limit
	 * @default 100
	 */
	limit?: number
	/**
	 * Offset
	 * @default 0
	 */
	offset?: number
}

/** ProductCatalogQueryResponseModel */
export interface ProductCatalogQueryResponseModel {
	/** Data */
	data: ProductCatalogModel[]
	/** Total */
	total: number
}

/** ProductCatalogModel */
export interface ProductCatalogModel {
	/** Sku */
	sku: string
	/** Sales Entity Id */
	sales_entity_id: string
	/** Title */
	title: string
	/** Line Id */
	line_id: string
	/** Line Name */
	line_name: string
	/** Category Id */
	category_id: string
	/** Category Name */
	category_name: string
	/** Cost */
	cost: number
	/** Last Price */
	last_price: number
}

/** CurrenciesResponseModel */
export interface CurrenciesResponseModel {
	/** Default Currency */
	default_currency: string | null
	/** Currencies */
	currencies: string[]
}

/** ExportModel */
export interface ExportModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	type: ExportType
	status: ExportStatus
	/**
	 * Created By
	 * @format uuid
	 */
	created_by: string
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/** Finished At */
	finished_at?: string | null
	/** Row Number */
	row_number?: number | null
	/** File Size */
	file_size?: number | null
}

/** ExportCreateModel */
export interface ExportCreateModel {
	/** Name */
	name: string
	type: ExportType
	/** Filters */
	filters: FilterRuleModel[]
	group_by?: ExportGroupBy | null
	/** Columns */
	columns?: ExportColumnModel[] | null
	/**
	 * Require Callback
	 * @default false
	 */
	require_callback?: boolean
}

/** ExportColumnModel */
export interface ExportColumnModel {
	/** Header */
	header: string
	/** Name */
	name: string
	reference?: ExportColumnReferenceModel | null
	/** Static Value */
	static_value?: string | null
}

/** ExportColumnReferenceModel */
export interface ExportColumnReferenceModel {
	/** Entity */
	entity: string
	/** Field */
	field: string
}

/** ExportDownloadUrlModel */
export interface ExportDownloadUrlModel {
	/** Url */
	url: string
}

/** ExportTemplateModel */
export interface ExportTemplateModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Columns */
	columns: ExportColumnModel[]
}

/** OptimizationModel */
export interface OptimizationModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Iteration Id
	 * @format uuid
	 */
	iteration_id: string
	run_type: OptimizationRunType
	status: OptimizationStatus
	/**
	 * Created Date
	 * @format date-time
	 */
	created_date: string
	/** Scheduled Date */
	scheduled_date: string | null
	/** Started Date */
	started_date: string | null
	/** Finished Date */
	finished_date: string | null
	/** Canceled Date */
	canceled_date: string | null
	/** Failed Date */
	failed_date: string | null
	/** Last Updated Date */
	last_updated_date: string | null
	/**
	 * Total Products
	 * @default 0
	 */
	total_products?: number
	/**
	 * Is Exported
	 * @default false
	 */
	is_exported?: boolean
}

/**
 * FinalFieldsListModel
 * @minItems 1
 */
export type FinalFieldsListModel = FinalFieldsSKUModel[]

/** FinalFieldsSKUModel */
export interface FinalFieldsSKUModel {
	/** Final Price */
	final_price?: number | string | null
	/** Final Esp */
	final_esp?: number | string | null
	/** Freeze Final Prices */
	freeze_final_prices?: boolean | null
	/** Review Check Cm */
	review_check_cm?: boolean | null
	/** Review Comment Pricing */
	review_comment_pricing?: string | null
	/** Review Comment Cm */
	review_comment_cm?: string | null
	/** Review Price Proposal */
	review_price_proposal?: number | string | null
	/** Review Done Pricing */
	review_done_pricing?: boolean | null
	/** Sku */
	sku: string
}

/** FinalFieldsPatchModel */
export interface FinalFieldsPatchModel {
	/** Filters */
	filters: FilterRuleModel[]
	final_fields: FinalFieldsModel
}

/** FinalFieldsModel */
export interface FinalFieldsModel {
	/** Final Price */
	final_price?: number | string | null
	/** Final Esp */
	final_esp?: number | string | null
	/** Freeze Final Prices */
	freeze_final_prices?: boolean | null
	/** Review Check Cm */
	review_check_cm?: boolean | null
	/** Review Comment Pricing */
	review_comment_pricing?: string | null
	/** Review Comment Cm */
	review_comment_cm?: string | null
	/** Review Price Proposal */
	review_price_proposal?: number | string | null
	/** Review Done Pricing */
	review_done_pricing?: boolean | null
}

/**
 * ProductDiffsModel
 * @minItems 1
 */
export type ProductDiffsModel = Record<string, any>[]

/** ProductsUpdateModel */
export interface ProductsUpdateModel {
	/** Filters */
	filters: FilterRuleModel[]
	/** Values */
	values: Record<string, any>
}

/** OptimizationActionModel */
export interface OptimizationActionModel {
	action: OptimizationAction
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Filters */
	filters?: FilterRuleModel[] | null
}

/** OptimizationActionResponseModel */
export interface OptimizationActionResponseModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Optimization Id */
	optimization_id?: string | null
	/** Success */
	success: boolean
	/** Error */
	error?: string | null
	/** Code */
	code?: number | null
	/** Count */
	count?: number | null
}

/** BulkProductDiffsFileForm */
export interface BulkProductDiffsFileForm {
	/** Product Diffs File */
	product_diffs_file: File | Blob
	/**
	 * Ignore Empties
	 * @default false
	 */
	ignore_empties?: boolean
	/**
	 * File Header Mapping
	 * @default "{}"
	 */
	file_header_mapping?: string
	/**
	 * Optimization Group Ids
	 * @default "[]"
	 */
	optimization_group_ids?: string
}

/** ValidateProductDiffsFileForm */
export interface ValidateProductDiffsFileForm {
	/** Product Diffs File */
	product_diffs_file: File | Blob
	/**
	 * Ignore Empties
	 * @default false
	 */
	ignore_empties?: boolean
	/**
	 * File Header Mapping
	 * @default "{}"
	 */
	file_header_mapping?: string
}

/** ValidateProductDiffsResponse */
export interface ValidateProductDiffsResponse {
	/** Product Diffs */
	product_diffs: Record<string, Record<string, any>>
	/** Errors */
	errors: ValidationError[]
}

/** BulkFinalFieldsFileForm */
export interface BulkFinalFieldsFileForm {
	/** Final Fields File */
	final_fields_file: File | Blob
	/**
	 * File Header Mapping
	 * @default "{}"
	 */
	file_header_mapping?: string
	/**
	 * Filters
	 * @default "[]"
	 */
	filters?: string
}

/** ProductGroupModel */
export interface ProductGroupModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/** Categories */
	categories: Record<string, string[]>
	/** Filters */
	filters: Record<string, (boolean | string)[]>
	/** Full Categories */
	full_categories: string[]
}

/** SalesEntitiesResponseModel */
export interface SalesEntitiesResponseModel {
	/** Sales Levels */
	sales_levels: SalesLevelModel[]
	/** Sales Entities */
	sales_entities: SalesEntityModel[]
}

/** SalesLevelModel */
export interface SalesLevelModel {
	/** Level */
	level: number
	/** Name */
	name: string
}

/** SalesEntityModel */
export interface SalesEntityModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Sales Level */
	sales_level: number
	/** Parent Id */
	parent_id: string | null
	/** Currency */
	currency: string
}

/** OptimizationGroupModel */
export interface OptimizationGroupModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Sales Level Id */
	sales_level_id: number
	/** Name */
	name: string
	/** Description */
	description: string | null
	/** Updated At */
	updated_at: string | null
	/** Updated By */
	updated_by: string | null
	/** Created At */
	created_at: string | null
	/** Created By */
	created_by: string | null
	/** Sales Entities */
	sales_entities: string[]
	/** Product Groups */
	product_groups: OptimizationGroupProductGroupMapping[]
	/** Pos Ids */
	pos_ids: string[]
}

/** OptimizationGroupProductGroupMapping */
export interface OptimizationGroupProductGroupMapping {
	/**
	 * Product Group Id
	 * @format uuid
	 */
	product_group_id: string
	/** Filters */
	filters?: FilterRuleModel[] | null
}

/** OptimizationGroupCreateModel */
export interface OptimizationGroupCreateModel {
	/** Sales Level Id */
	sales_level_id: number
	/** Description */
	description: string | null
	/**
	 * Sales Entities
	 * @minItems 1
	 */
	sales_entities: string[]
	/**
	 * Product Groups
	 * @minItems 1
	 */
	product_groups: OptimizationGroupProductGroupMapping[]
}

/** OptimizationGroupNameUpdateModel */
export interface OptimizationGroupNameUpdateModel {
	/** Name */
	name: string
	/** Description */
	description: string | null
}

/** OptimizationGroupFullUpdateModel */
export interface OptimizationGroupFullUpdateModel {
	/** Sales Level Id */
	sales_level_id: number
	/** Name */
	name: string
	/** Description */
	description: string | null
	/**
	 * Sales Entities
	 * @minItems 1
	 */
	sales_entities: string[]
	/**
	 * Product Groups
	 * @minItems 1
	 */
	product_groups: OptimizationGroupProductGroupMapping[]
}

/** OptimizationGroupReviewListResponse */
export interface OptimizationGroupReviewListResponse {
	/** Objects */
	objects: OptimizationGroupReviewModel[]
}

/** OptimizationGroupReviewModel */
export interface OptimizationGroupReviewModel {
	/**
	 * Iteration Id
	 * @format uuid
	 */
	iteration_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Author Id
	 * @format uuid
	 */
	author_id: string
	/** Notify Author */
	notify_author: boolean
	/** Reviewers */
	reviewers: OptimizationGroupReviewerItem[]
	/**
	 * Created Dt
	 * @format date-time
	 */
	created_dt: string
	/** Updated Dt */
	updated_dt?: string | null
}

/** OptimizationGroupReviewerItem */
export interface OptimizationGroupReviewerItem {
	/** Id */
	id: string
	/**
	 * Is Approved
	 * @default false
	 */
	is_approved?: boolean
	/** Approved Dt */
	approved_dt?: string | null
}

/** OptimizationGroupReviewCreateModel */
export interface OptimizationGroupReviewCreateModel {
	/** Notify Author */
	notify_author: boolean
	/** Reviewers */
	reviewers: OptimizationGroupReviewerItem[]
}

/** OptimizationGroupReviewUpdateModel */
export interface OptimizationGroupReviewUpdateModel {
	/**
	 * Notify Author
	 * @default false
	 */
	notify_author?: boolean
	/**
	 * Reviewers
	 * @default []
	 */
	reviewers?: OptimizationGroupReviewerItem[]
}

/** AlertModel */
export interface AlertModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Description */
	description: string
	level: AlertLevel
	/** Solution Tooltip */
	solution_tooltip: string | null
}

/** BrandModel */
export interface BrandModel {
	/** Id */
	id: string
	/** Name */
	name: string
}

/** CategoryModel */
export interface CategoryModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Parent Id */
	parent_id: string | null
}

/** ProductsQueryRequestModel */
export interface ProductsQueryRequestModel {
	/** Search */
	search?: string | null
	/** Filters */
	filters?: FilterRuleModel[] | null
	/**
	 * Limit
	 * @min 0
	 * @max 500
	 * @default 500
	 */
	limit?: number
	/**
	 * Offset
	 * @min 0
	 * @default 0
	 */
	offset?: number
	/** Order By */
	order_by?: OrderByModel[] | null
}

/** ProductsQueryResponseModel */
export interface ProductsQueryResponseModel {
	/** Total Count */
	total_count: number
	/** Total Skus */
	total_skus: number
	/** Data */
	data: ProductsQueryItemModel[]
}

/** ProductsQueryItemModel */
export interface ProductsQueryItemModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Line Id */
	line_id: string
	/** Sales Level Id */
	sales_level_id: number
	/** Sales Entity Ids */
	sales_entity_ids: string[]
	/** Sales Entity Names */
	sales_entity_names: string[]
	fields: PricingLineModel
	/** Products */
	products: ProductModel[]
}

/** PricingLineModel */
export interface PricingLineModel {
	/** Line Id */
	line_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Name */
	name: string
	/** Pos Ids */
	pos_ids: string[]
	/**
	 * Product Group Id
	 * @format uuid
	 */
	product_group_id: string
	/** Pricing Campaign Id */
	pricing_campaign_id: string | null
	/** Brands */
	brands: string[]
	/** Brand Id */
	brand_id: string
	/** Categories */
	categories: string[]
	/** Category Ids */
	category_ids: string[]
	/** Last Price */
	last_price: number
	/** Last Price Dt */
	last_price_dt: string | null
	/** Esp */
	esp: number
	/** Optimal Price */
	optimal_price: number | null
	/** Optimal Esp */
	optimal_esp: number | null
	/** Final Price */
	final_price: number | null
	/** Final Esp */
	final_esp: number | null
	/** Freeze Final Prices */
	freeze_final_prices: boolean
	/** Is Locked */
	is_locked: boolean
	/** Is Manually Locked */
	is_manually_locked: boolean
	/** Is Available */
	is_available: boolean
	/** Custom Fields */
	custom_fields: Record<string, any>
	/** Aggregated Fields */
	aggregated_fields: Record<string, any>
	/** Alerts */
	alerts: string[]
	/** Family Id */
	family_id: string
}

/** ProductModel */
export interface ProductModel {
	/** Sku */
	sku: string
	/** Line Id */
	line_id: string
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Title */
	title: string
	/** Cost */
	cost: number | null
	/** Stock */
	stock: number | null
	/** Last Stock Dt */
	last_stock_dt: string | null
	/** Custom Fields */
	custom_fields: Record<string, any>
}

/** ProductsByPCRequestModel */
export interface ProductsByPCRequestModel {
	/** Filters */
	filters?: FilterRuleModel[] | null
}

/** ProductsByPCModel */
export interface ProductsByPCModel {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Pricing Campaign Id */
	pricing_campaign_id: string | null
	/** Product Count */
	product_count: number
}

/** RawProductColumnModel */
export interface RawProductColumnModel {
	/** Name */
	name: string
	/** Type */
	type:
		'string' | 'integer' | 'number' | 'boolean' | 'array' | 'date' | 'datetime'
}

/** SavedFilterModel */
export interface SavedFilterModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	type: SavedFilterType
	/** Is Public */
	is_public: boolean
	/** Filters */
	filters: FilterRuleModel[]
	/**
	 * Created By
	 * @format uuid
	 */
	created_by: string
	/**
	 * Created At
	 * @format date-time
	 */
	created_at: string
	/** Updated By */
	updated_by?: string | null
	/** Updated At */
	updated_at?: string | null
}

/** SavedFilterCreateModel */
export interface SavedFilterCreateModel {
	/** Name */
	name: string
	type: SavedFilterType
	/** Is Public */
	is_public: boolean
	/** Filters */
	filters: FilterRuleModel[]
}

/** SavedFilterUpdateModel */
export interface SavedFilterUpdateModel {
	/** Name */
	name?: string | null
	type?: SavedFilterType | null
	/** Is Public */
	is_public?: boolean | null
	/** Filters */
	filters?: FilterRuleModel[] | null
}

/** ScheduleResponse */
export interface ScheduleModel {
	/**
	 * Id
	 * @format uuid
	 */
	id: string
	/** Name */
	name: string
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * Nearest Date
	 * @format date
	 */
	nearest_date: string
	/** Repeat */
	repeat: boolean | null
	/** Repeat Days */
	repeat_days: number[] | null
	/** Repeat Week Interval */
	repeat_week_interval: number | null
	/** Optimization Groups */
	optimization_groups: string[]
	/** Notify Users */
	notify_users: string[] | null
}

/** ScheduleCreate */
export interface CreateScheduleModel {
	/** Id */
	id?: string | null
	/**
	 * Name
	 * @minLength 1
	 */
	name: string
	/**
	 * Start Date
	 * @format date
	 */
	start_date: string
	/**
	 * Repeat
	 * @default false
	 */
	repeat?: boolean | null
	/** Repeat Days */
	repeat_days?: number[] | null
	/** Repeat Week Interval */
	repeat_week_interval?: number | null
	/**
	 * Optimization Groups
	 * @minItems 1
	 */
	optimization_groups: string[]
	/** Notify Users */
	notify_users?: string[] | null
}

/** ScheduleUpdate */
export interface UpdateScheduleModel {
	/** Id */
	id?: string | null
	/** Name */
	name?: string | null
	/** Start Date */
	start_date?: string | null
	/** Repeat */
	repeat?: boolean | null
	/** Repeat Days */
	repeat_days?: number[] | null
	/** Repeat Week Interval */
	repeat_week_interval?: number | null
	/** Optimization Groups */
	optimization_groups?: string[] | null
	/** Notify Users */
	notify_users?: string[] | null
}

/** ProductFeatureConfigWithId */
export interface ProductFeatureConfigWithId {
	/** Type */
	type: 'product_feature'
	/** Data */
	data:
		| ({
				type: 'boolean'
		  } & BooleanProductFeatureData)
		| ({
				type: 'numeric'
		  } & NumericProductFeatureData)
		| ({
				type: 'string'
		  } & StringProductFeatureData)
	/**
	 * Id
	 * @maxLength 300
	 * @pattern ^[A-Za-z][A-Za-z0-9_]*$
	 */
	id: string
}

/** NumericProductFeatureData */
export interface NumericProductFeatureData {
	/** Feature Id */
	feature_id: string
	/** Raw */
	raw?: boolean | null
	/** Type */
	type: 'numeric'
	/** Coalesce */
	coalesce?: number | null
}

/** BooleanProductFeatureData */
export interface BooleanProductFeatureData {
	/** Feature Id */
	feature_id: string
	/** Raw */
	raw?: boolean | null
	/** Type */
	type: 'boolean'
	/** Coalesce */
	coalesce?: boolean | null
	/** Truthy */
	truthy?: string | null
	/** Falsy */
	falsy?: string | null
}

/** StringProductFeatureData */
export interface StringProductFeatureData {
	/** Feature Id */
	feature_id: string
	/** Raw */
	raw?: boolean | null
	/** Type */
	type: 'string'
	/** Coalesce */
	coalesce?: string | null
}

/** SalesMetricsFeatureConfigWithId */
export interface SalesMetricsFeatureConfigWithId {
	/** Type */
	type: 'sales_metrics_feature'
	data: SalesMetricsFeatureData
	/**
	 * Id
	 * @maxLength 300
	 * @pattern ^[A-Za-z][A-Za-z0-9_]*$
	 */
	id: string
}

/** SalesMetricsFeatureData */
export interface SalesMetricsFeatureData {
	metric: SalesMetric
	delta_type: DeltaType
	/**
	 * Delta Count
	 * @min 1
	 */
	delta_count: number
}

/** ProductFeatureConfig */
export interface ProductFeatureConfig {
	/** Type */
	type: 'product_feature'
	/** Data */
	data:
		| ({
				type: 'boolean'
		  } & BooleanProductFeatureData)
		| ({
				type: 'numeric'
		  } & NumericProductFeatureData)
		| ({
				type: 'string'
		  } & StringProductFeatureData)
}

/** SalesMetricsFeatureConfig */
export interface SalesMetricsFeatureConfig {
	/** Type */
	type: 'sales_metrics_feature'
	data: SalesMetricsFeatureData
}

/** FieldSchema */
export interface FieldSchemaModel {
	/**
	 * Id
	 * @pattern ^[a-zA-Z0-9][a-zA-Z0-9_]*$
	 */
	id: string
	/** Name */
	name: string
	/** Description */
	description?: string | null
	value_type: ValueType
	value_editor_type: ValueEditorType | null
	field_type: FieldType | null
	reference?: FieldReference | null
	/** Options */
	options: Record<string, any> | null
	params: FieldParams
	config: FieldConfig
}

/** FieldReference */
export interface FieldReference {
	/** Entity */
	entity:
		| 'custom_fields'
		| 'optimization_group'
		| 'optimization'
		| 'pricing_campaign'
		| 'sales_entity'
		| 'sales_level'
		| 'alert'
		| 'category'
		| 'brand'
	/** Accessor */
	accessor: string
	/** Field */
	field?: string | null
}

/** FieldParams */
export interface FieldParams {
	/**
	 * Editable
	 * @default false
	 */
	editable?: boolean
	/**
	 * Filterable
	 * @default true
	 */
	filterable?: boolean
	/**
	 * Lockable
	 * @default true
	 */
	lockable?: boolean
	/**
	 * Locked
	 * @default false
	 */
	locked?: boolean
	/**
	 * Sortable
	 * @default true
	 */
	sortable?: boolean
	/**
	 * Searchable
	 * @default false
	 */
	searchable?: boolean
	/**
	 * Width
	 * @default 150
	 */
	width?: number
	/**
	 * Groupable
	 * @default false
	 */
	groupable?: boolean
}

/** FieldConfig */
export interface FieldConfig {
	aggregation: AggregationConfig
	/**
	 * Enum
	 * @default []
	 */
	enum?: string[]
	/** Formula */
	formula?: Record<string, any> | null
	/**
	 * Hidden On
	 * @default []
	 */
	hidden_on?: HiddenOnContext[]
	/**
	 * Order
	 * @default 10000
	 */
	order?: number
	/** Path */
	path: string
	/**
	 * Priority
	 * @default 0
	 */
	priority?: number
	/**
	 * Propagate
	 * @default false
	 */
	propagate?: boolean
	/**
	 * Stage
	 * @default "prepro"
	 */
	stage?:
		| 'prepro'
		| 'pre_init_fields'
		| 'pricing_campaign'
		| 'init_fields'
		| 'reprice'
		| 'final_fields'
	/**
	 * Db Type
	 * @default "custom_field"
	 */
	db_type?: 'core_field' | 'custom_field'
}

/** AggregationConfig */
export interface AggregationConfig {
	/** Optimization Group */
	optimization_group:
		| (
				| ({
						type: 'column'
				  } & ColumnOGAggregation)
				| ({
						type: 'custom'
				  } & FormulaOrCustomOGAggregation)
				| ({
						type: 'formula'
				  } & FormulaOrCustomOGAggregation)
		  )
		| null
	/**
	 * Pricing Line
	 * @default "first"
	 */
	pricing_line?:
		| 'sum'
		| 'range'
		| 'range:ifneed'
		| 'count'
		| 'first'
		| 'last'
		| 'max'
		| 'min'
		| 'average'
		| 'uniq:count'
		| 'empty'
		| 'priority:by:order'
		| null
}

/** FormulaOrCustomOGAggregation */
export interface FormulaOrCustomOGAggregation {
	/** Type */
	type: 'formula' | 'custom'
	/** Data */
	data: string
	/** Aggregation Scope */
	aggregation_scope: 'line' | 'og' | 'sku' | null
	/** Raw Columns */
	raw_columns: string[] | null
}

/** ColumnOGAggregation */
export interface ColumnOGAggregation {
	/** Type */
	type: 'column'
	data: ColumnOGAggregationData
	/** Aggregation Scope */
	aggregation_scope: 'line' | 'og' | 'sku' | null
}

/** ColumnOGAggregationData */
export interface ColumnOGAggregationData {
	/** Aggregation */
	aggregation: 'any' | 'max' | 'min' | 'avg'
	/** Price Absent */
	price_absent: boolean
	/** Column Name */
	column_name: string
}

/** FieldSchemaUpdateModel */
export interface FieldSchemaUpdateModel {
	/** Name */
	name?: string | null
	/** Description */
	description?: string | null
	value_type?: ValueType | null
	value_editor_type?: ValueEditorType | null
	field_type?: FieldType | null
	reference?: FieldReference | null
	/** Options */
	options?: Record<string, any> | null
	params?: FieldParams | null
	config?: FieldConfig | null
}

/** FieldSchemaBulkUpdateModel */
export interface FieldSchemaBulkUpdateModel {
	/** Name */
	name?: string | null
	/** Description */
	description?: string | null
	value_type?: ValueType | null
	value_editor_type?: ValueEditorType | null
	field_type?: FieldType | null
	reference?: FieldReference | null
	/** Options */
	options?: Record<string, any> | null
	params?: FieldParams | null
	config?: FieldConfig | null
	/** Id */
	id: string
}

/** Setting */
export interface Setting {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Type Id */
	type_id: string
	/** Body */
	body: any
}

/** SettingCreateRequestModel */
export interface SettingCreateRequestModel {
	/** Name */
	name: string
	/** Type Id */
	type_id: string
	/** Body */
	body: any
}

/** SettingType */
export interface SettingType {
	/** Id */
	id: string
	/** Schema */
	schema: Record<string, any>
}

/** Preprocessing */
export interface Preprocessing {
	/** Id */
	id: string
	/**
	 * Date
	 * @format date-time
	 */
	date: string
	/** Modes */
	modes: string[]
	/** Status */
	status: string
}

/** EmptyResponse */
export type EmptyResponse = object

/** ChatSettingsResponseModel */
export interface ChatSettingsResponseModel {
	/** Is Enabled */
	is_enabled: boolean
	/** Welcome Text */
	welcome_text: string
	/** Agents */
	agents: AgentChatSettingsModel[]
}

/** AgentChatSettingsModel */
export interface AgentChatSettingsModel {
	/** Name */
	name: string
	/** Uri */
	uri: string
	/** Is Enabled */
	is_enabled: boolean
	/** Welcome Text */
	welcome_text: string
	/** Suggestions */
	suggestions: string[]
}

/** ChatMessageRequestModel */
export interface ChatMessageRequestModel {
	/** Text */
	text: string
	/** Session Id */
	session_id: string
	context: ChatMessageContextItem
}

/** ChatMessageContextItem */
export interface ChatMessageContextItem {
	/** Optimization Group Id */
	optimization_group_id: string | null
	/** Page */
	page: string
	/** Pricing Rule Id */
	pricing_rule_id?: string | null
}

/** ChatMessageResponseModel */
export interface ChatMessageResponseModel {
	/** Id */
	id: string
	/** Text */
	text: string
	/**
	 * Artifacts
	 * @default []
	 */
	artifacts?: (
		| ({
				type: 'pricing_rule_draft'
		  } & ChatArtifactPricingRuleDraftModel)
		| ({
				type: 'video'
		  } & ChatArtifactVideoModel)
	)[]
}

/** ChatArtifactVideoModel */
export interface ChatArtifactVideoModel {
	/** Type */
	type: 'video'
	/** Id */
	id: string
}

/**
 * ChatArtifactPricingRuleDraftModel
 * A generated rule draft the frontend substitutes into the rulebuilder canvas.
 */
export interface ChatArtifactPricingRuleDraftModel {
	/** Type */
	type: 'pricing_rule_draft'
	/** Pricing Rule Id */
	pricing_rule_id: string
	/** Base Hash */
	base_hash: string
	/** Rule */
	rule: object
	/**
	 * Missing Fields
	 * @default []
	 */
	missing_fields?: string[]
}

/** ChatMessageReactionRequestModel */
export interface ChatMessageReactionRequestModel {
	/** Id */
	id: string
	/** Reaction */
	reaction: string
}

/** PromoCampaignModel */
export interface PromoCampaignModel {
	/** Id */
	id: string
	/** Name */
	name: string
	/** Description */
	description: string
	/**
	 * Date Start
	 * @format date
	 */
	date_start: string
	/**
	 * Date End
	 * @format date
	 */
	date_end: string
	/** User Created */
	user_created: string | null
	/** User Modified */
	user_modified: string | null
	source: PromoCampaignSource
	/** Is Active */
	is_active: boolean
	/**
	 * Created On
	 * @format date-time
	 */
	created_on: string
	/** Modified On */
	modified_on: string | null
	/** Pos Ids */
	pos_ids: string[]
}

/** PromoCampaignCreateModel */
export interface PromoCampaignCreateModel {
	/** Name */
	name: string
	/** Description */
	description: string
	/**
	 * Date Start
	 * @format date
	 */
	date_start: string
	/**
	 * Date End
	 * @format date
	 */
	date_end: string
	/** Pos Ids */
	pos_ids: string[]
}

/** ErrorModel */
export interface ErrorModel {
	/** Detail */
	detail: string
}

/** PromoCampaignUpdateModel */
export interface PromoCampaignUpdateModel {
	/** Name */
	name: string
	/** Description */
	description: string
	/**
	 * Date Start
	 * @format date
	 */
	date_start: string
	/**
	 * Date End
	 * @format date
	 */
	date_end: string
	/** Pos Ids */
	pos_ids: string[]
	/** Is Active */
	is_active: boolean
}

/** PromoProductModel */
export interface PromoProductModel {
	/** Sku */
	sku: string
	/** Title */
	title: string
	/** Discount Price */
	discount_price?: number | null
	/** Discount Percent */
	discount_percent?: number | null
	/** Discount Sum */
	discount_sum?: number | null
	/** Predicted Growth Rate */
	predicted_growth_rate?: number | null
}

/** Body_upload_promo_campaign_products_api_v1_promo_campaigns__promo_campaign_id__products__post */
export interface BodyUploadPromoCampaignProductsApiV1PromoCampaignsPromoCampaignIdProductsPost {
	/** File */
	file: File | Blob
}

/** UploadPromoProductsErrorModel */
export interface UploadPromoProductsErrorModel {
	detail: PromoProductFileErrorModel
}

/** PromoProductFileErrorModel */
export interface PromoProductFileErrorModel {
	/** Error */
	error?: string | null
	/**
	 * Multiple Discounts Errors
	 * @default []
	 */
	multiple_discounts_errors?: FileRowErrorModel[]
	/**
	 * Duplicated Rows Errors
	 * @default []
	 */
	duplicated_rows_errors?: FileRowErrorModel[]
	/**
	 * Validation Errors
	 * @default []
	 */
	validation_errors?: FileRowErrorModel[]
}

/** FileRowErrorModel */
export interface FileRowErrorModel {
	/** Sku */
	sku: string | null
	/** Reason */
	reason: string
}

/** InterpretationModel */
export interface InterpretationModel {
	/** Title */
	title: string
	/** Subtitle */
	subtitle: string | null
	/** Ui Group */
	ui_group: string
	/** Price Label */
	price_label: (number | null)[]
	/** Alerts */
	alerts: string[]
	/** Children */
	children: string[] | null
	/** Data */
	data: Record<string, any> | null
}

export interface CompetitiveDataPointModel {
	competitor_name: string
	availability: string
	url: string
	promo_type_id?: string
	price: number
	observed_on: string
}

export interface PriceHistoryDataPointModel {
	competitor_name?: string
	line_id: string
	sku: string
	optimization_group_id: string
	price: number
	observed_on: string
}

export interface CompetitiveDataResponseModel {
	next_page?: string
	objects?: {
		competitor_name?: string
		objects?: CompetitiveDataPointModel[]
	}[]
}

export interface PriceHistoryResponseModel {
	next_page?: string
	objects?: {
		competitive_data?: {
			competitor_name?: string
			objects?: PriceHistoryDataPointModel[]
		}[]
		prices?: PriceHistoryDataPointModel[]
	}
}

export interface CompetitorModel {
	name?: string
	competitor_id?: string
	source_id?: string
}

export interface CompetitorsResponseModel {
	next_page?: string
	objects?: CompetitorModel[]
}

export type BusinessSettingsModel = Record<string, any>

export interface StopListSettingsModel {
	/** Specific stoplist rules defined by the user */
	custom_rules: FilterRuleModel[]
	/** Default stoplist rules defined by the system */
	default_rules: Record<string, any>
}

export interface ScenarioSettingsModel {
	strategy: StrategiesSettingsModel
	stop_list: StopListSettingsModel
	business: BusinessSettingsModel
}

export interface StrategiesSettingsModel {
	demand_strategy: {
		target: string
		protect: string
	}
	markdown_strategy: {
		target?: string
	}
}

export interface PreferencesModel {
	quick_filters_keys?: string[]
}

export interface PricingCampaignSettingsModel {
	activity: ActivitySettingsModel
	product_assignments: ProductAssignmentModel
	/** @default {"engine":"ML","params":{}} */
	pricing_tactics:
		| DemandPricingTacticsModel
		| MarkdownPricingTacticsModel
		| RuleBasePricingTacticsModel
		| PromoPricingTacticsModel
	minimal_steps: MinimalStepRuleModel[]
	price_limits: PriceLimitsModel
	rounding: any
	anchoring: any
}

/**
 * @uniqueItems true
 * @default []
 */
export type ProductAssignmentModel = {
	name: string
	filters: FilterRuleModel[]
}[]

export interface MinimalStepRuleModel {
	/** @min 0 */
	min_price: number
	/** @min 0 */
	min_step_absolute: number
	/** @min 0 */
	min_step_relative: number
}

/** @default {} */
export interface PriceLimitsModel {
	/**
	 * @uniqueItems true
	 * @default [{"name":"last_price","value":-5,"type":"markup","on_violation":"correct"},{"name":"cost","value":4,"type":"markup","on_violation":"correct"}]
	 */
	lower: PriceLimitRuleModel[]
	/**
	 * @uniqueItems true
	 * @default [{"name":"last_price","value":5,"type":"markup","on_violation":"correct"}]
	 */
	upper: PriceLimitRuleModel[]
	/** @default {} */
	extra: {
		/** @default "no_reprice" */
		on_conflict: 'no_reprice' | 'lower' | 'upper'
	}
}

export interface RoundingRuleValueModel {
	min_price?: number
	params?: Record<string, any>
	strategy?: string
}

export interface PriceLimitRuleModel {
	name: string
	value: number
	/** @default "markup" */
	type?: 'markup' | 'margin' | 'absolute'
	/** @default "correct" */
	on_violation?: 'correct' | 'notify'
}

export interface MarkdownPricingTacticsModel {
	/** @default "MD" */
	engine: 'MD'
	params: {
		/**
		 * @uniqueItems false
		 * @default []
		 */
		periods: MarkdownPeriodModel[]
	}
	target_price_type: TargetPriceTypeModel
}

export interface MarkdownPeriodModel {
	/** @format date */
	start_date: string
	target: {
		name: string
		value: number
	}
}

export interface PromoPeriodModel {
	/** @format date */
	promo_start_date: string
	/** @format date */
	promo_end_date: string
	target: {
		name: string
		value: number
	}
}

export interface PromoPricingTacticsModel {
	/** @default "Promo" */
	engine: 'Promo'
	params: PromoPeriodModel
	target_price_type: TargetPriceTypeModel
}

export interface RuleBasePricingTacticsModel {
	/** @default "RB" */
	engine: 'RB'
	params: {
		rule_params: object
		rule_id: string
	}
	target_price_type: TargetPriceTypeModel
}

export interface DemandPricingTacticsModel {
	/** @default "ML" */
	engine: 'ML'
	/** @default {} */
	params: object
	target_price_type: TargetPriceTypeModel
}

/** @default {"rules":[],"on_conflict":"ignore"} */
export interface AnchoringModel {
	/** @uniqueItems true */
	rules: AnchoringRuleModel[]
	/**
	 * anchoring_on_conflict
	 * @default "ignore"
	 */
	on_conflict: 'ignore' | 'use_anchor_price'
	/**
	 * anchoring_on_anchor_locked
	 * @default "keep"
	 */
	on_anchor_locked?: 'keep' | 'ignore'
	/**
	 * anchoring_on_conflict_anchor_limits
	 * @default "ignore"
	 */
	on_conflict_anchor_limits?: 'ignore' | 'user_upper_limit' | 'user_lower_limit'
	/**
	 * rounding_limits_and_price
	 * @default "keep"
	 */
	rounding_limits_and_price?:
		| 'keep'
		| 'deactivate_rounding_anchor_limits'
		| 'deactivate_rounding_anchor_limits_and_price'
}

export interface ActivitySettingsModel {
	/** @format date */
	start_date: string
	/** @format date */
	end_date: string
	repeat_week_interval: number
	repeat_days: string[]
	inactive_strategy: string
	force_inactive: boolean
}

export interface AnchoringRuleModel {
	anchoring:
		| 'flat_anchor'
		| 'sized_anchor'
		| 'product_set'
		| 'ladder_anchor'
		| 'bundle_anchor'
	high_range: number
	/** @minLength 1 */
	high_range_behavior: 'correct' | 'highlight'
	low_range: number
	/** @minLength 1 */
	low_range_behavior: 'correct' | 'highlight'
}

export interface GetForecastParams {
	/**
	 * Optimization Group Id
	 * Optimization group identifier.
	 * @format uuid
	 */
	optimizationGroupId: string
	/**
	 * Optimization Id
	 * Optimization identifier.
	 * @format uuid
	 */
	optimizationId: string
	/**
	 * Pricing Line Id
	 * Pricing line identifier.
	 */
	pricingLineId: string
}

export interface GetSegmentationParams {
	/**
	 * Optimization Group Id
	 * Optimization group identifier.
	 * @format uuid
	 */
	optimizationGroupId: string
	/**
	 * Optimization Id
	 * Optimization identifier.
	 * @format uuid
	 */
	optimizationId: string
	/**
	 * Pricing Line Id
	 * Pricing line identifier.
	 */
	pricingLineId: string
}

export interface ActivateAppParams {
	/** App Name */
	appName: string
}

export interface DeactivateAppParams {
	/** App Name */
	appName: string
}

/** Mailing Domains */
export type UpdateMailingDomainsRequestModel = string[]

export interface LoginAuthLoginGetParams {
	/** Redirect Uri */
	redirect_uri: string
}

export interface AuthAuthAuthGetParams {
	/** Code */
	code: string
	/** Redirect Uri */
	redirect_uri: string
}

export interface GetPermissionsParams {
	/**
	 * Include Inner
	 * If to include inner permissions in the response
	 * @default true
	 */
	include_inner?: boolean
}

export interface GetRoleParams {
	/**
	 * Role Id
	 * @format uuid
	 */
	roleId: string
}

export interface UpdateRoleParams {
	/**
	 * Role Id
	 * @format uuid
	 */
	roleId: string
}

export interface DeleteRoleParams {
	/**
	 * Role Id
	 * @format uuid
	 */
	roleId: string
}

export interface GetCurrentUserPreferenceParams {
	/** Preference Type */
	preferenceType: string
}

/** Preference Value */
export type SetCurrentUserPreferenceRequestModel = any

export interface SetCurrentUserPreferenceParams {
	/** Preference Type */
	preferenceType: string
}

export interface DeleteCurrentUserPreferenceParams {
	/** Preference Type */
	preferenceType: string
}

/** Preferences Map */
export type SetCurrentUserPreferencesRequestModel = Record<string, any>

export interface GetUserHandlerParams {
	/**
	 * User Id
	 * @format uuid
	 */
	userId: string
}

export interface UpdateUserParams {
	/**
	 * User Id
	 * @format uuid
	 */
	userId: string
}

export interface DeleteUserParams {
	/**
	 * User Id
	 * @format uuid
	 */
	userId: string
}

export interface ResetPasswordParams {
	/**
	 * User Id
	 * @format uuid
	 */
	userId: string
}

export interface BiFieldsValuesParams {
	/** Bi Field */
	biField: string
}

export interface MatchedProductsParams {
	/** Optimization Group Id */
	optimization_group_id?: string | null
}

export interface GetStatisticsInternalMultipleInterpretabilityParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Optimization Ids */
	optimization_ids: string
}

export interface GetOptimizationPredictMetricsParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
}

export interface GetOptimizationPricesParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
}

export interface InternalGetAlertsInfoParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimization_group_id: string
	/** Optimization Ids */
	optimization_ids: string
}

export interface GetTicketTypesParams {
	/** Lang Code */
	lang_code: string
}

export interface GlobalPcSetGetParams {
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	globalPcSetId: string
}

export interface GlobalPcSetUpdateParams {
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	globalPcSetId: string
}

export interface GlobalPcSetDeleteParams {
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	globalPcSetId: string
}

export interface GlobalPcSetDuplicateParams {
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	globalPcSetId: string
}

export interface GlobalPcSetSetMainParams {
	/**
	 * Global Pc Set Id
	 * @format uuid
	 */
	globalPcSetId: string
}

export interface PricingCampaignListParams {
	/**
	 * Only Global
	 * If only global pricing campaigns are returned
	 * @default false
	 */
	only_global?: boolean
	/**
	 * Only Main Global
	 * If return global pricing campaigns only from main global PC set
	 * @default true
	 */
	only_main_global?: boolean
	/**
	 * Scenario Id
	 *
	 *         Scenario id for which to return pricing campaigns.
	 *         Always append global PCs.
	 *
	 */
	scenario_id?: string | null
	/**
	 * Optimization Group Id
	 *
	 *         Optimization group id for which return pricing campaigns.
	 *         Always append global PCs.
	 *
	 */
	optimization_group_id?: string | null
}

export interface PricingCampaignOverviewListParams {
	/**
	 * Only Global
	 * If only global pricing campaigns are returned
	 * @default false
	 */
	only_global?: boolean
	/**
	 * Only Main Global
	 * If return global pricing campaigns only from main global PC set
	 * @default true
	 */
	only_main_global?: boolean
	/**
	 * Scenario Id
	 *
	 *         Scenario id for which to return pricing campaigns.
	 *         Always append global PCs.
	 *
	 */
	scenario_id?: string | null
	/**
	 * Optimization Group Id
	 *
	 *         Optimization group id for which return pricing campaigns.
	 *         Always append global PCs.
	 *
	 */
	optimization_group_id?: string | null
}

export interface PricingCampaignGetParams {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricingCampaignId: string
}

export interface PricingCampaignUpdateParams {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricingCampaignId: string
}

export interface PricingCampaignDeleteParams {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricingCampaignId: string
}

export interface PricingCampaignAssignProductsParams {
	/**
	 * Pricing Campaign Id
	 * @format uuid
	 */
	pricingCampaignId: string
}

/** Pricing Campaign Ids */
export type PricingCampaignBulkDeleteRequestModel = string[]

/** Request Object */
export type PricingCampaignReorderRequestModel =
	GlobalPcSetReorderRequest | ScenarioReorderRequest

export interface PricingRuleListParams {
	/** Search */
	search?: string | null
	/** Limit */
	limit?: number | null
	/** Offset */
	offset?: number | null
}

export interface PricingRuleGetParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleUpdateParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleDeleteParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleDraftGetParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleDraftSaveParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleDraftExportParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleDraftImportParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRulePublishParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleVersionsListParams {
	/** Limit */
	limit?: number | null
	/** Offset */
	offset?: number | null
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleVersionGetParams {
	/**
	 * Pricing Rule Version Id
	 * @format uuid
	 */
	pricingRuleVersionId: string
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleVersionUpdateParams {
	/**
	 * Pricing Rule Version Id
	 * @format uuid
	 */
	pricingRuleVersionId: string
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleVersionExportParams {
	/**
	 * Pricing Rule Version Id
	 * @format uuid
	 */
	pricingRuleVersionId: string
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleVersionRestoreParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
	/**
	 * Pricing Rule Version Id
	 * @format uuid
	 */
	pricingRuleVersionId: string
}

export interface PricingRuleDuplicateParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface PricingRuleApplyParams {
	/**
	 * Pricing Rule Id
	 * @format uuid
	 */
	pricingRuleId: string
}

export interface GetScenarioRunSetParams {
	/**
	 * Scenario Run Set Id
	 * @format uuid
	 */
	scenarioRunSetId: string
}

export interface DeleteScenarioRunSetParams {
	/**
	 * Scenario Run Set Id
	 * @format uuid
	 */
	scenarioRunSetId: string
}

export interface DeleteScenarioRunParams {
	/**
	 * Scenario Run Set Id
	 * @format uuid
	 */
	scenarioRunSetId: string
	/**
	 * Scenario Run Id
	 * @format uuid
	 */
	scenarioRunId: string
}

export interface ScenariosListParams {
	/** Optimization Group Id */
	optimization_group_id?: string | null
}

export interface ScenarioGetParams {
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenarioId: string
}

export interface ScenarioUpdateParams {
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenarioId: string
}

export interface ScenarioGetMainParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface ScenarioUpdateMainParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

/** Scenario Ids */
export type DeleteScenariosBulkRequestModel = string[]

export interface ScenarioMatchedProductsParams {
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenarioId: string
}

export interface ScenarioDuplicateParams {
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenarioId: string
}

export interface ScenarioSetMainParams {
	/**
	 * Scenario Id
	 * @format uuid
	 */
	scenarioId: string
}

export interface ScenarioMainCopySettingsParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

/** Settings */
export type PriceLimitsRequestModel = Record<string, any>

/** Settings */
export type RoundingRequestModel = any[]

/** Settings */
export type AnchoringRequestModel = Record<string, any>

export interface SettingsTemplateGetParams {
	/**
	 * Settings Template Id
	 * @format uuid
	 */
	settingsTemplateId: string
}

export interface SettingsTemplateUpdateParams {
	/**
	 * Settings Template Id
	 * @format uuid
	 */
	settingsTemplateId: string
}

export interface SettingsTemplateDeleteParams {
	/**
	 * Settings Template Id
	 * @format uuid
	 */
	settingsTemplateId: string
}

export interface SettingsTemplateApplyParams {
	/**
	 * Settings Template Id
	 * @format uuid
	 */
	settingsTemplateId: string
}

export interface AnchorsSalesEntityGetParams {
	/** Optimization Group Id */
	optimizationGroupId: string
}

export interface AnchorsAnchorStrategyGetParams {
	/**
	 * Anchor Strategy Id
	 * @format uuid
	 */
	anchorStrategyId: string
}

export interface AnchorsAnchorStrategyUpdateParams {
	/**
	 * Anchor Strategy Id
	 * @format uuid
	 */
	anchorStrategyId: string
}

export interface AnchorsAnchorStrategyDeleteParams {
	/**
	 * Anchor Strategy Id
	 * @format uuid
	 */
	anchorStrategyId: string
}

export interface GetDownloadLinkExternalParams {
	/**
	 * Export Id
	 * @format uuid
	 */
	exportId: string
}

export interface DownloadExportFileParams {
	/**
	 * Export Id
	 * @format uuid
	 */
	exportId: string
}

export interface GetDownloadLinkParams {
	/**
	 * Export Id
	 * @format uuid
	 */
	exportId: string
}

export interface DeleteExportParams {
	/**
	 * Export Id
	 * @format uuid
	 */
	exportId: string
}

export interface GetCurrentOptimizationsParams {
	/** Og Id */
	og_id?: string[] | null
}

export interface GetOptimizationsParams {
	/** Id */
	id: string[]
}

export interface CreateOptimizationParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface OptimizationFinalFieldsSkuParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface OptimizationFinalFieldsFiltersParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface OptimizationProductDiffsSkuParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface OptimizationProductDiffsFiltersParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface OptimizationActionParams {
	action: OptimizationAction
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

/** Actions */
export type OptimizationBulkActionsRequestModel = OptimizationActionModel[]

/** Patches Pd */
export type OptimizationBulkFinalFieldsRequestModel = FinalFieldsPatchModel[]

export interface GetProductGroupsParams {
	/**
	 * Include Full Categories
	 * @default false
	 */
	include_full_categories?: boolean
}

export interface GetOptimizationGroupParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

/** Body */
export type UpdateOptimizationGroupRequestModel =
	OptimizationGroupNameUpdateModel | OptimizationGroupFullUpdateModel

export interface UpdateOptimizationGroupParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface DeleteOptimizationGroupParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface CreateOptimizationGroupReviewParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface UpdateOptimizationGroupReviewParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface DeleteOptimizationGroupReviewParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface ApproveOptimizationGroupReviewParams {
	/**
	 * Optimization Group Id
	 * @format uuid
	 */
	optimizationGroupId: string
}

export interface GetBrandsParams {
	/** Optimization Group Id */
	optimization_group_id?: string | null
}

export interface GetCategoriesParams {
	/** Optimization Group Id */
	optimization_group_id?: string | null
}

export interface UpdateSavedFilterParams {
	/**
	 * Saved Filter Id
	 * @format uuid
	 */
	savedFilterId: string
}

export interface DeleteSavedFilterParams {
	/**
	 * Saved Filter Id
	 * @format uuid
	 */
	savedFilterId: string
}

export interface GetScheduleParams {
	/**
	 * Schedule Id
	 * @format uuid
	 */
	scheduleId: string
}

export interface UpdateScheduleParams {
	/**
	 * Schedule Id
	 * @format uuid
	 */
	scheduleId: string
}

export interface DeleteScheduleParams {
	/**
	 * Schedule Id
	 * @format uuid
	 */
	scheduleId: string
}

/** Custom Feature Config */
export type CustomFeatureConfigCreateRequestModel =
	| ({
			type: 'product_feature'
	  } & ProductFeatureConfigWithId)
	| ({
			type: 'sales_metrics_feature'
	  } & SalesMetricsFeatureConfigWithId)

export interface CustomFeatureConfigGetParams {
	/** Id */
	id: string
}

/** Custom Feature Config */
export type CustomFeatureConfigUpdateRequestModel =
	| ({
			type: 'product_feature'
	  } & ProductFeatureConfig)
	| ({
			type: 'sales_metrics_feature'
	  } & SalesMetricsFeatureConfig)

export interface CustomFeatureConfigUpdateParams {
	/** Id */
	id: string
}

export interface CustomFeatureConfigDeleteParams {
	/** Id */
	id: string
}

/** Custom Feature Config Ids */
export type CustomFeatureConfigBulkDeleteRequestModel = string[]

export interface FieldSchemaListParams {
	/**
	 * Context
	 * @default []
	 */
	context?: HiddenOnContext[]
}

export interface FieldSchemaGetParams {
	/** Field Schema Id */
	fieldSchemaId: string
}

export interface FieldSchemaUpdateParams {
	/** Field Schema Id */
	fieldSchemaId: string
}

export interface FieldSchemaDeleteParams {
	/** Field Schema Id */
	fieldSchemaId: string
}

/** Field Schemas */
export type FieldSchemaBulkUpdateRequestModel = FieldSchemaBulkUpdateModel[]

/** Field Schemas Ids */
export type FieldSchemaBulkDeleteRequestModel = string[]

export interface PublicSettingGetParams {
	/** Setting Id */
	settingId: string
}

export interface SettingListParams {
	/** Type Id */
	type_id?: string | null
}

/** Request Body */
export type SettingRestoreRequestModel = Setting[]

export interface SettingDetailParams {
	/** Setting Id */
	settingId: string
}

export interface SettingDeleteParams {
	/** Setting Id */
	settingId: string
}

/** Request Body */
export type SettingTypeRestoreRequestModel = SettingType[]

export interface SettingTypeDetailParams {
	/** Setting Type Id */
	settingTypeId: string
}

export interface SettingTypeDeleteParams {
	/** Setting Type Id */
	settingTypeId: string
}

export interface GetPromoCampaignParams {
	/** Promo Campaign Id */
	promoCampaignId: string
}

export interface UpdatePromoCampaignParams {
	/** Promo Campaign Id */
	promoCampaignId: string
}

export interface DeletePromoCampaignParams {
	/** Promo Campaign Id */
	promoCampaignId: string
}

export interface ListPromoCampaignProductsParams {
	/** Promo Campaign Id */
	promoCampaignId: string
}

export interface UploadPromoCampaignProductsParams {
	/** Promo Campaign Id */
	promoCampaignId: string
}

export interface ListInterpretationParams {
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
	/** Optimization Group Id */
	optimization_group_id: string
	/** Line Id */
	line_id: string
}

export interface ListInterpretationDataParams {
	/**
	 * Optimization Id
	 * @format uuid
	 */
	optimization_id: string
	/** Optimization Group Id */
	optimization_group_id: string
	/** Line Id */
	line_id: string
}

export interface LogsParams {
	/** Timestamp */
	timestamp: string
	/**
	 * User Id
	 * @format uuid
	 */
	user_id?: string
	/** User Id  In */
	user_id__in?: string
	/**
	 * Email
	 * @format email
	 */
	email?: string
	/** Event Type */
	event_type?: string
	/** Event Type  In */
	event_type__in?: string
	/** Product Source */
	product_source?: string
	/**
	 * Format
	 * @default "json"
	 */
	format?: string
}

export interface ListCompetitiveDataParams {
	/** Limit */
	limit: number
	/** optimization_group_id */
	optimization_group_id: string
	/** Line id */
	line_id: string
	/** Sku */
	sku: string
	/** Order by */
	order_by: string
	/** Group by */
	group_by: string[]
	/** Observed on greater than */
	observed_on__gt: string
	/** Fields */
	fields: string[]
}

export interface ListPriceHistoryParams {
	/** Limit */
	limit: number
	/** optimization_group_id */
	optimization_group_id: string
	/** Line id */
	line_id: string
	/** Sku */
	sku: string
	/** Order by */
	order_by: string
	/** Group by */
	group_by: string[]
	/** Observed on greater than */
	observed_on__gt: string
	/** Fields */
	fields?: string[]
}

export interface ListCompetitorsParams {
	/** optimization_group_id */
	optimization_group_id?: string
	/** Order by field */
	order_by?: string
	/** Limit */
	limit: number
}

export namespace MidTermPrediction {
	/**
	 * @description Whether the service is enabled for this client and whether the predictions published here are those of the platform's current iteration. is_ready is always false when is_enabled is false.
	 * @tags mid-term-prediction
	 * @name GetStatus
	 * @summary Get service status
	 * @request GET:/api/v1/mid-term-prediction/status
	 * @secure
	 * @response `200` `StatusModel` Successful Response
	 * @response `400` `Problem` Bad Request
	 * @response `401` `Problem` Unauthorized
	 * @response `404` `Problem` Not Found
	 * @response `422` `Problem` Unprocessable Entity
	 * @response `500` `Problem` Internal Server Error
	 * @response `502` `Problem` Bad Gateway
	 */
	export namespace GetStatus {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id'?: string | null
			/** Auth-User-Email */
			'auth-user-email'?: string | null
		}
		export type ResponseBody = StatusModel
	}

	/**
	 * @description Daily sales-quantity history and forecast, the forecastability verdict and the period aggregate. Returns 200 with is_forecastable=false for blocked series.
	 * @tags mid-term-prediction
	 * @name GetForecast
	 * @summary Get the forecast for a pricing line
	 * @request GET:/api/v1/mid-term-prediction/optimization-groups/{optimization_group_id}/optimizations/{optimization_id}/pricing-lines/{pricing_line_id}/forecast
	 * @secure
	 * @response `200` `ForecastModel` Successful Response
	 * @response `400` `Problem` Bad Request
	 * @response `401` `Problem` Unauthorized
	 * @response `404` `Problem` Not Found
	 * @response `422` `Problem` Unprocessable Entity
	 * @response `500` `Problem` Internal Server Error
	 * @response `502` `Problem` Bad Gateway
	 */
	export namespace GetForecast {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * Optimization group identifier.
			 * @format uuid
			 */
			optimizationGroupId: string
			/**
			 * Optimization Id
			 * Optimization identifier.
			 * @format uuid
			 */
			optimizationId: string
			/**
			 * Pricing Line Id
			 * Pricing line identifier.
			 */
			pricingLineId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id'?: string | null
			/** Auth-User-Email */
			'auth-user-email'?: string | null
		}
		export type ResponseBody = ForecastModel
	}

	/**
	 * @description Demand-shape and lifecycle facts for the series; either segment is null when no data exists.
	 * @tags mid-term-prediction, segmentation
	 * @name GetSegmentation
	 * @summary Get the segmentation of a pricing line
	 * @request GET:/api/v1/mid-term-prediction/optimization-groups/{optimization_group_id}/optimizations/{optimization_id}/pricing-lines/{pricing_line_id}/segmentation
	 * @secure
	 * @response `200` `SegmentationModel` Successful Response
	 * @response `400` `Problem` Bad Request
	 * @response `401` `Problem` Unauthorized
	 * @response `404` `Problem` Not Found
	 * @response `422` `Problem` Unprocessable Entity
	 * @response `500` `Problem` Internal Server Error
	 * @response `502` `Problem` Bad Gateway
	 */
	export namespace GetSegmentation {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * Optimization group identifier.
			 * @format uuid
			 */
			optimizationGroupId: string
			/**
			 * Optimization Id
			 * Optimization identifier.
			 * @format uuid
			 */
			optimizationId: string
			/**
			 * Pricing Line Id
			 * Pricing line identifier.
			 */
			pricingLineId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id'?: string | null
			/** Auth-User-Email */
			'auth-user-email'?: string | null
		}
		export type ResponseBody = SegmentationModel
	}
}

export namespace Apps {
	/**
	 * No description
	 * @tags Apps
	 * @name GetApps
	 * @summary Get Apps
	 * @request GET:/api/v1/apps/
	 * @secure
	 * @response `200` `(AppModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetApps {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = AppModel[]
	}

	/**
	 * No description
	 * @tags Apps
	 * @name ActivateApp
	 * @summary Activate App
	 * @request POST:/api/v1/apps/{app_name}/activate/
	 * @secure
	 * @response `200` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ActivateApp {
		export type RequestParams = {
			/** App Name */
			appName: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Apps
	 * @name DeactivateApp
	 * @summary Deactivate App
	 * @request POST:/api/v1/apps/{app_name}/deactivate/
	 * @secure
	 * @response `200` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeactivateApp {
		export type RequestParams = {
			/** App Name */
			appName: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Apps
	 * @name GetHelpdeskOrganizationIdHandler
	 * @summary Get Helpdesk Organization Id Handler
	 * @request GET:/api/v1/apps/helpdesk-organization-id/
	 * @secure
	 * @response `200` `(string | null)` Successful Response
	 */
	export namespace GetHelpdeskOrganizationIdHandler {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = string | null
	}

	/**
	 * No description
	 * @tags Apps
	 * @name GetMailingDomains
	 * @summary Get Mailing Domains
	 * @request GET:/api/v1/apps/mailing-domains/
	 * @secure
	 * @response `200` `(string)[]` Successful Response
	 */
	export namespace GetMailingDomains {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = string[]
	}

	/**
	 * No description
	 * @tags Apps
	 * @name UpdateMailingDomains
	 * @summary Update Mailing Domains
	 * @request PUT:/api/v1/apps/mailing-domains/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateMailingDomains {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = UpdateMailingDomainsRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace Auth {
	/**
	 * No description
	 * @tags Auth
	 * @name LoginAuthLoginGet
	 * @summary Login
	 * @request GET:/auth/login/
	 * @secure
	 * @response `307` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace LoginAuthLoginGet {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Redirect Uri */
			redirect_uri: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = any
	}

	/**
	 * No description
	 * @tags Auth
	 * @name AuthAuthAuthGet
	 * @summary Auth
	 * @request GET:/auth/auth/
	 * @secure
	 * @response `200` `AccessTokenModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AuthAuthAuthGet {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Code */
			code: string
			/** Redirect Uri */
			redirect_uri: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = AccessTokenModel
	}

	/**
	 * No description
	 * @tags Auth
	 * @name RefreshTokenHandlerAuthRefreshTokenPost
	 * @summary Refresh Token Handler
	 * @request POST:/auth/refresh-token/
	 * @secure
	 * @response `200` `AccessTokenModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace RefreshTokenHandlerAuthRefreshTokenPost {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = AccessTokenModel
	}

	/**
	 * No description
	 * @tags Auth
	 * @name LogoutAuthLogoutPost
	 * @summary Logout
	 * @request POST:/auth/logout/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace LogoutAuthLogoutPost {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}
}

export namespace Permissions {
	/**
	 * No description
	 * @tags Permissions
	 * @name GetPermissions
	 * @summary Get Permissions
	 * @request GET:/api/v1/permissions/
	 * @secure
	 * @response `200` `(PermissionModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetPermissions {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Include Inner
			 * If to include inner permissions in the response
			 * @default true
			 */
			include_inner?: boolean
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PermissionModel[]
	}
}

export namespace Roles {
	/**
	 * No description
	 * @tags Roles
	 * @name GetRoles
	 * @summary Get Roles
	 * @request GET:/api/v1/roles/
	 * @secure
	 * @response `200` `(RoleModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetRoles {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = RoleModel[]
	}

	/**
	 * No description
	 * @tags Roles
	 * @name CreateRole
	 * @summary Create Role
	 * @request POST:/api/v1/roles/
	 * @secure
	 * @response `201` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateRole {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = RoleDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Roles
	 * @name GetRole
	 * @summary Get Role
	 * @request GET:/api/v1/roles/{role_id}/
	 * @secure
	 * @response `200` `RoleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetRole {
		export type RequestParams = {
			/**
			 * Role Id
			 * @format uuid
			 */
			roleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = RoleModel
	}

	/**
	 * No description
	 * @tags Roles
	 * @name UpdateRole
	 * @summary Update Role
	 * @request PATCH:/api/v1/roles/{role_id}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateRole {
		export type RequestParams = {
			/**
			 * Role Id
			 * @format uuid
			 */
			roleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = RoleUpdateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Roles
	 * @name DeleteRole
	 * @summary Delete Role
	 * @request DELETE:/api/v1/roles/{role_id}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteRole {
		export type RequestParams = {
			/**
			 * Role Id
			 * @format uuid
			 */
			roleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace Users {
	/**
	 * No description
	 * @tags Users
	 * @name GetUsers
	 * @summary Get Users
	 * @request GET:/api/v1/users/
	 * @secure
	 * @response `200` `UsersModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetUsers {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = UsersModel
	}

	/**
	 * No description
	 * @tags Users
	 * @name CreateUserHandler
	 * @summary Create User Handler
	 * @request POST:/api/v1/users/
	 * @secure
	 * @response `201` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateUserHandler {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = UserDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name ExportUsers
	 * @summary Export Users
	 * @request GET:/api/v1/users/export/
	 * @secure
	 * @response `200` `string` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ExportUsers {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = string
	}

	/**
	 * No description
	 * @tags Users
	 * @name GetCurrentUser
	 * @summary Get Current User
	 * @request GET:/api/v1/users/current/
	 * @secure
	 * @response `200` `UserModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCurrentUser {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = UserModel
	}

	/**
	 * No description
	 * @tags Users
	 * @name UpdateCurrentUser
	 * @summary Update Current User
	 * @request PATCH:/api/v1/users/current/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateCurrentUser {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = UserProfileDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name ResetCurrentUserPassword
	 * @summary Reset Current User Password
	 * @request PATCH:/api/v1/users/current/reset-password/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ResetCurrentUserPassword {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name GetCurrentUserPreferences
	 * @summary Get Current User Preferences
	 * @request GET:/api/v1/users/current/preferences/
	 * @secure
	 * @response `200` `any` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCurrentUserPreferences {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = any
	}

	/**
	 * No description
	 * @tags Users
	 * @name GetCurrentUserPreference
	 * @summary Get Current User Preference
	 * @request GET:/api/v1/users/current/preferences/{preference_type}/
	 * @secure
	 * @response `200` `any` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCurrentUserPreference {
		export type RequestParams = {
			/** Preference Type */
			preferenceType: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = any
	}

	/**
	 * No description
	 * @tags Users
	 * @name SetCurrentUserPreference
	 * @summary Set Current User Preference
	 * @request PATCH:/api/v1/users/current/preferences/{preference_type}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SetCurrentUserPreference {
		export type RequestParams = {
			/** Preference Type */
			preferenceType: string
		}
		export type RequestQuery = {}
		export type RequestBody = SetCurrentUserPreferenceRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name DeleteCurrentUserPreference
	 * @summary Delete Current User Preference
	 * @request DELETE:/api/v1/users/current/preferences/{preference_type}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteCurrentUserPreference {
		export type RequestParams = {
			/** Preference Type */
			preferenceType: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name SetCurrentUserPreferences
	 * @summary Set Current User Preferences
	 * @request PATCH:/api/v1/users/current/preferences
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SetCurrentUserPreferences {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SetCurrentUserPreferencesRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name GetUserHandler
	 * @summary Get User Handler
	 * @request GET:/api/v1/users/{user_id}/
	 * @secure
	 * @response `200` `UserModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetUserHandler {
		export type RequestParams = {
			/**
			 * User Id
			 * @format uuid
			 */
			userId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = UserModel
	}

	/**
	 * No description
	 * @tags Users
	 * @name UpdateUser
	 * @summary Update User
	 * @request PATCH:/api/v1/users/{user_id}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateUser {
		export type RequestParams = {
			/**
			 * User Id
			 * @format uuid
			 */
			userId: string
		}
		export type RequestQuery = {}
		export type RequestBody = UserDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name DeleteUser
	 * @summary Delete User
	 * @request DELETE:/api/v1/users/{user_id}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteUser {
		export type RequestParams = {
			/**
			 * User Id
			 * @format uuid
			 */
			userId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags Users
	 * @name ResetPassword
	 * @summary Reset Password
	 * @request PATCH:/api/v1/users/{user_id}/reset-password/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ResetPassword {
		export type RequestParams = {
			/**
			 * User Id
			 * @format uuid
			 */
			userId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace Bi {
	/**
	 * No description
	 * @tags bi
	 * @name ListMetrics
	 * @summary List-Metrics
	 * @request GET:/api/v1/metrics/
	 * @secure
	 * @response `200` `(Metric)[]` Successful Response
	 */
	export namespace ListMetrics {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = Metric[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name BiRevision
	 * @summary Bi-Revision
	 * @request GET:/api/v1/bi-revision/
	 * @secure
	 * @response `200` `(BIRevision | null)` Successful Response
	 */
	export namespace BiRevision {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = BIRevision | null
	}

	/**
	 * No description
	 * @tags bi
	 * @name BiFields
	 * @summary Bi-Fields
	 * @request GET:/api/v1/bi/fields
	 * @secure
	 * @response `200` `ProductDiffsModel` Successful Response
	 */
	export namespace BiFields {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ProductDiffsModel
	}

	/**
	 * No description
	 * @tags bi
	 * @name BiFieldsValues
	 * @summary Bi-Fields-Values
	 * @request GET:/api/v1/bi/fields/{bi_field}/values
	 * @secure
	 * @response `200` `((string)[] | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace BiFieldsValues {
		export type RequestParams = {
			/** Bi Field */
			biField: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = string[] | null
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetBi
	 * @summary Get-Bi
	 * @request POST:/api/v1/bi/
	 * @secure
	 * @response `200` `(BIResponse | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetBi {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BIRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = BIResponse | null
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetCpi
	 * @summary Get-Cpi
	 * @request POST:/api/v1/bi/cpi
	 * @secure
	 * @response `200` `(CPIResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCpi {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = CPIRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = CPIResponseModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetBiRevenue
	 * @summary Get-Bi-Revenue
	 * @request POST:/api/v1/bi-revenue/
	 * @secure
	 * @response `200` `BIRevenueResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetBiRevenue {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BIRevenueRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = BIRevenueResponse
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetBiImpact
	 * @summary Get-Bi-Impact
	 * @request POST:/api/v1/bi-impact
	 * @secure
	 * @response `200` `BIImpactResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetBiImpact {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BIImpactRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = BIImpactResponse
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetBiAi
	 * @summary Get-Bi-Ai
	 * @request POST:/api/v1/bi-ai/
	 * @secure
	 * @response `200` `BIAIResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetBiAi {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BIAIRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = BIAIResponse
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetOgTreeMapBySalesEntities
	 * @summary Get-Og-Tree-Map-By-Sales-Entities
	 * @request POST:/api/v1/optimization-groups-tree-map/by-sales-entities
	 * @secure
	 * @response `200` `(TreeMapSalesEntityModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOgTreeMapBySalesEntities {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = TreeMapRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = TreeMapSalesEntityModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetOgTreeMapByProductGroups
	 * @summary Get-Og-Tree-Map-By-Product-Groups
	 * @request POST:/api/v1/optimization-groups-tree-map/by-product-groups
	 * @secure
	 * @response `200` `(TreeMapProductGroupModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOgTreeMapByProductGroups {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = TreeMapRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = TreeMapProductGroupModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetStatistics
	 * @summary Get-Statistics
	 * @request POST:/api/v1/statistics
	 * @secure
	 * @response `200` `StatisticsResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetStatistics {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = StatisticsRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = StatisticsResponse
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetStatisticsRepricing
	 * @summary Get-Statistics-Repricing
	 * @request POST:/api/v1/statistics/repricing
	 * @secure
	 * @response `200` `(StatisticsRepricingResponse | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetStatisticsRepricing {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = StatisticsRepricingRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = StatisticsRepricingResponse | null
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetStatisticsInterpretability
	 * @summary Get-Statistics-Interpretability
	 * @request POST:/api/v1/statistics/interpretability
	 * @secure
	 * @response `200` `(StatisticsInterpretabilityResponse | (StatisticsInterpretabilityGroupedResponseModel)[] | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetStatisticsInterpretability {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = StatisticsInterpretabilityRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody =
			| StatisticsInterpretabilityResponse
			| StatisticsInterpretabilityGroupedResponseModel[]
			| null
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetStatisticsTargetProtectDistribution
	 * @summary Get-Statistics-Target-Protect-Distribution
	 * @request POST:/api/v1/statistics/target-protect-distribution
	 * @secure
	 * @response `200` `((TargetProtectDistributionModel)[] | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetStatisticsTargetProtectDistribution {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = StatisticsTargetProtectDistributionRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = TargetProtectDistributionModel[] | null
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetStatisticsMultipleInterpretability
	 * @summary Get-Statistics-Multiple-Interpretability
	 * @request POST:/api/v1/statistics/multiple-interpretability
	 * @secure
	 * @response `200` `(StatisticsInterpretabilityResponse)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetStatisticsMultipleInterpretability {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = StatisticsMultipleInterpretabilityRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = StatisticsInterpretabilityResponse[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetStatisticsInternalMultipleInterpretability
	 * @summary Get-Statistics-Internal-Multiple-Interpretability
	 * @request GET:/api/v1/statistics-internal/multiple-interpretability
	 * @secure
	 * @response `200` `(StatisticsInterpretabilityResponse)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetStatisticsInternalMultipleInterpretability {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimization_group_id: string
			/** Optimization Ids */
			optimization_ids: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = StatisticsInterpretabilityResponse[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetOptimizationsStatistics
	 * @summary Get-Optimizations-Statistics
	 * @request POST:/api/v1/statistics/optimizations-statistics
	 * @secure
	 * @response `200` `(OptimizationStatisticModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOptimizationsStatistics {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = StatisticsOptimizationStatisticsRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = OptimizationStatisticModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetAlertsInfo
	 * @summary Get-Alerts-Info
	 * @request POST:/api/v1/statistics/alerts-info
	 * @secure
	 * @response `200` `AlertsInfoResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetAlertsInfo {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AlertInfoRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = AlertsInfoResponseModel
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetOptimizationPredictMetrics
	 * @summary Get-Optimization-Predict-Metrics
	 * @request GET:/api/v1/statistics-internal/optimization-metrics
	 * @secure
	 * @response `200` `(PredictMetricModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOptimizationPredictMetrics {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimization_group_id: string
			/**
			 * Optimization Id
			 * @format uuid
			 */
			optimization_id: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PredictMetricModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetOptimizationPrices
	 * @summary Get-Optimization-Prices
	 * @request GET:/api/v1/statistics-internal/optimization-prices
	 * @secure
	 * @response `200` `(OptimizationPricesModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOptimizationPrices {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimization_group_id: string
			/**
			 * Optimization Id
			 * @format uuid
			 */
			optimization_id: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = OptimizationPricesModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name InternalGetAlertsInfo
	 * @summary Internal-Get-Alerts-Info
	 * @request GET:/api/v1/statistics-internal/alerts-info
	 * @secure
	 * @response `200` `(MultipleAlertInfoModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace InternalGetAlertsInfo {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimization_group_id: string
			/** Optimization Ids */
			optimization_ids: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = MultipleAlertInfoModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name InternalPricingLineSearch
	 * @summary Internal-Pricing-Line-Search
	 * @request POST:/api/v1/statistics-internal/pricing-line-search
	 * @secure
	 * @response `200` `PricingLineSearchResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace InternalPricingLineSearch {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingLineSearchRequest
		export type RequestHeaders = {}
		export type ResponseBody = PricingLineSearchResponse
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetProductsCountByEngine
	 * @summary Get counts of products grouped by engine of pricing campaign.
	 * @request POST:/api/v1/statistics/count-by-engine
	 * @secure
	 * @response `200` `(ProductsByEngineModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetProductsCountByEngine {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ProductsByEntityRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = ProductsByEngineModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetProductsCountByOptimizationStatus
	 * @summary Get counts of products grouped by status of optimization.
	 * @request POST:/api/v1/statistics/count-by-optimization-status
	 * @secure
	 * @response `200` `(ProductsByOptimizationStatusModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetProductsCountByOptimizationStatus {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ProductsByEntityRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = ProductsByOptimizationStatusModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetRepricingMetrics
	 * @summary Get current pricing metrics that don't fit other formats (average price change).
	 * @request POST:/api/v1/statistics/repricing-metrics
	 * @secure
	 * @response `200` `(RepricingMetricsModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetRepricingMetrics {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = RepricingMetricsRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = RepricingMetricsModel[]
	}

	/**
	 * No description
	 * @tags bi
	 * @name GetMultipleAlertsInfo
	 * @summary Get-Multiple-Alerts-Info
	 * @request POST:/api/v1/statistics/multiple-alerts-info
	 * @secure
	 * @response `200` `MultipleAlertsInfoResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetMultipleAlertsInfo {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = MultipleAlertInfoRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = MultipleAlertsInfoResponseModel
	}
}

export namespace MatchedProducts {
	/**
	 * No description
	 * @tags matched-products
	 * @name MatchedProducts
	 * @summary Matched-Products
	 * @request POST:/api/v1/matched-products/
	 * @secure
	 * @response `200` `MatchedProductsResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace MatchedProducts {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Optimization Group Id */
			optimization_group_id?: string | null
		}
		export type RequestBody = MatchedProductsRequest
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = MatchedProductsResponse
	}
}

export namespace Billing {
	/**
	 * No description
	 * @tags Billing
	 * @name UserCampaigns
	 * @summary User Campaigns
	 * @request GET:/api/v1/billing/user-campaigns/
	 * @secure
	 * @response `200` `(CampaignModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UserCampaigns {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = CampaignModel[]
	}

	/**
	 * No description
	 * @tags Billing
	 * @name UsageStatistics
	 * @summary Usage Statistics
	 * @request POST:/api/v1/billing/usage-statistics/
	 * @secure
	 * @response `200` `(UsageStatisticsModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UsageStatistics {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = UsageStatisticsRequestModel
		export type RequestHeaders = {
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = UsageStatisticsModel[]
	}
}

export namespace Tickets {
	/**
	 * No description
	 * @tags Tickets
	 * @name GetTicketTypes
	 * @summary Get Ticket Types
	 * @request GET:/api/v1/tickets-types
	 * @secure
	 * @response `200` `any` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetTicketTypes {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Lang Code */
			lang_code: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = any
	}

	/**
	 * No description
	 * @tags Tickets
	 * @name QueryTickets
	 * @summary Query Tickets
	 * @request POST:/api/v1/tickets/query
	 * @secure
	 * @response `200` `any` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace QueryTickets {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = TicketQueryRequest
		export type RequestHeaders = {}
		export type ResponseBody = any
	}

	/**
	 * No description
	 * @tags Tickets
	 * @name CreateTicket
	 * @summary Create Ticket
	 * @request POST:/api/v1/tickets
	 * @secure
	 * @response `200` `any` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateTicket {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BodyCreateTicketApiV1TicketsPost
		export type RequestHeaders = {
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = any
	}
}

export namespace Video {
	/**
	 * No description
	 * @tags Video
	 * @name VideosList
	 * @summary Videos-List
	 * @request GET:/api/v1/videos
	 * @secure
	 * @response `200` `(VideoModel)[]` Successful Response
	 */
	export namespace VideosList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = VideoModel[]
	}
}

export namespace GlobalPcSet {
	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetList
	 * @summary List global PC sets
	 * @request GET:/api/v1/global-pc-sets
	 * @secure
	 * @response `200` `(GlobalPCSetModel)[]` Successful Response
	 */
	export namespace GlobalPcSetList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = GlobalPCSetModel[]
	}

	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetCreate
	 * @summary Create global PC set
	 * @request POST:/api/v1/global-pc-sets
	 * @secure
	 * @response `201` `GlobalPCSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GlobalPcSetCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = GlobalPCSetCreateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = GlobalPCSetModel
	}

	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetGet
	 * @summary Get global PC set
	 * @request GET:/api/v1/global-pc-sets/{global_pc_set_id}
	 * @secure
	 * @response `200` `GlobalPCSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GlobalPcSetGet {
		export type RequestParams = {
			/**
			 * Global Pc Set Id
			 * @format uuid
			 */
			globalPcSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = GlobalPCSetModel
	}

	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetUpdate
	 * @summary Update global PC set
	 * @request PATCH:/api/v1/global-pc-sets/{global_pc_set_id}
	 * @secure
	 * @response `200` `GlobalPCSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GlobalPcSetUpdate {
		export type RequestParams = {
			/**
			 * Global Pc Set Id
			 * @format uuid
			 */
			globalPcSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = GlobalPCSetUpdateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = GlobalPCSetModel
	}

	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetDelete
	 * @summary Delete global PC set
	 * @request DELETE:/api/v1/global-pc-sets/{global_pc_set_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GlobalPcSetDelete {
		export type RequestParams = {
			/**
			 * Global Pc Set Id
			 * @format uuid
			 */
			globalPcSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetDuplicate
	 * @summary Duplicate global PC set
	 * @request POST:/api/v1/global-pc-sets/{global_pc_set_id}/duplicate
	 * @secure
	 * @response `200` `GlobalPCSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GlobalPcSetDuplicate {
		export type RequestParams = {
			/**
			 * Global Pc Set Id
			 * @format uuid
			 */
			globalPcSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = GlobalPCSetModel
	}

	/**
	 * No description
	 * @tags global-pc-set
	 * @name GlobalPcSetSetMain
	 * @summary Set main global PC set
	 * @request POST:/api/v1/global-pc-sets/{global_pc_set_id}/set-main
	 * @secure
	 * @response `200` `GlobalPCSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GlobalPcSetSetMain {
		export type RequestParams = {
			/**
			 * Global Pc Set Id
			 * @format uuid
			 */
			globalPcSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = GlobalPCSetModel
	}
}

export namespace PricingCampaign {
	/**
	 * @description List pricing campaign resources
	 * @tags pricing-campaign
	 * @name PricingCampaignList
	 * @summary List pricing campaigns
	 * @request GET:/api/v1/pricing-campaigns
	 * @secure
	 * @response `200` `(PricingCampaignModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignList {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Only Global
			 * If only global pricing campaigns are returned
			 * @default false
			 */
			only_global?: boolean
			/**
			 * Only Main Global
			 * If return global pricing campaigns only from main global PC set
			 * @default true
			 */
			only_main_global?: boolean
			/**
			 * Scenario Id
			 *
			 *         Scenario id for which to return pricing campaigns.
			 *         Always append global PCs.
			 *
			 */
			scenario_id?: string | null
			/**
			 * Optimization Group Id
			 *
			 *         Optimization group id for which return pricing campaigns.
			 *         Always append global PCs.
			 *
			 */
			optimization_group_id?: string | null
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignModel[]
	}

	/**
	 * @description Create pricing campaign resource. Combination of name and scenario_id must be unique. If `filter` is specified, products for that filter are added to the newlycreated global PC, but not local PC. They need to be added to local PC with `assign_product` separately.
	 * @tags pricing-campaign
	 * @name PricingCampaignCreate
	 * @summary Create pricing campaign
	 * @request POST:/api/v1/pricing-campaigns
	 * @secure
	 * @response `201` `PricingCampaignModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignCreateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignModel
	}

	/**
	 * @description Lightweight list of pricing campaign resources without full settings
	 * @tags pricing-campaign
	 * @name PricingCampaignOverviewList
	 * @summary List pricing campaigns (overview)
	 * @request GET:/api/v1/pricing-campaigns/overview
	 * @secure
	 * @response `200` `(PricingCampaignOverviewModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignOverviewList {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Only Global
			 * If only global pricing campaigns are returned
			 * @default false
			 */
			only_global?: boolean
			/**
			 * Only Main Global
			 * If return global pricing campaigns only from main global PC set
			 * @default true
			 */
			only_main_global?: boolean
			/**
			 * Scenario Id
			 *
			 *         Scenario id for which to return pricing campaigns.
			 *         Always append global PCs.
			 *
			 */
			scenario_id?: string | null
			/**
			 * Optimization Group Id
			 *
			 *         Optimization group id for which return pricing campaigns.
			 *         Always append global PCs.
			 *
			 */
			optimization_group_id?: string | null
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignOverviewModel[]
	}

	/**
	 * @description Get pricing campaign resource
	 * @tags pricing-campaign
	 * @name PricingCampaignGet
	 * @summary Get pricing campaign
	 * @request GET:/api/v1/pricing-campaigns/{pricing_campaign_id}
	 * @secure
	 * @response `200` `PricingCampaignModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignGet {
		export type RequestParams = {
			/**
			 * Pricing Campaign Id
			 * @format uuid
			 */
			pricingCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignModel
	}

	/**
	 * @description Update pricing campaign resource.
	 * @tags pricing-campaign
	 * @name PricingCampaignUpdate
	 * @summary Update pricing campaign
	 * @request PATCH:/api/v1/pricing-campaigns/{pricing_campaign_id}
	 * @secure
	 * @response `200` `PricingCampaignModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignUpdate {
		export type RequestParams = {
			/**
			 * Pricing Campaign Id
			 * @format uuid
			 */
			pricingCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignUpdateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignModel
	}

	/**
	 * @description Delete pricing campaign resource
	 * @tags pricing-campaign
	 * @name PricingCampaignDelete
	 * @summary Delete pricing campaign
	 * @request DELETE:/api/v1/pricing-campaigns/{pricing_campaign_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignDelete {
		export type RequestParams = {
			/**
			 * Pricing Campaign Id
			 * @format uuid
			 */
			pricingCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * @description Assign products to pricing campaign by filters. Products that were assigned previously, remain assigned. The pricing campaign can be global or local, but not dynamic.
	 * @tags pricing-campaign
	 * @name PricingCampaignAssignProducts
	 * @summary Assign products to pricing campaign by filters
	 * @request PATCH:/api/v1/pricing-campaigns/{pricing_campaign_id}/assign-products
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignAssignProducts {
		export type RequestParams = {
			/**
			 * Pricing Campaign Id
			 * @format uuid
			 */
			pricingCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignProductsFilters
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * @description Unassign products from pricing campaigns by filters. Products that meet the filter criteria are unassigned from pricing campaigns in optimization groups to which the user has access.
	 * @tags pricing-campaign
	 * @name PricingCampaignUnassignProducts
	 * @summary Unassign products from pricing campaigns by filters
	 * @request PATCH:/api/v1/pricing-campaigns/unassign-products
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignUnassignProducts {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignProductsFilters
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * @description Delete multiple pricing campaigns
	 * @tags pricing-campaign
	 * @name PricingCampaignBulkDelete
	 * @summary Bulk delete pricing campaign
	 * @request POST:/api/v1/pricing-campaigns/bulk-delete
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignBulkDelete {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignBulkDeleteRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * @description Reorder pricing campaign resources
	 * @tags pricing-campaign
	 * @name PricingCampaignReorder
	 * @summary Reorder pricing campaigns
	 * @request POST:/api/v1/pricing-campaigns/reorder
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignReorder {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignReorderRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags pricing-campaign
	 * @name PricingCampaignMatchedProductsReorder
	 * @summary Estimate products distribution after pricing campaigns reordering
	 * @request POST:/api/v1/pricing-campaigns/matched-products-reorder
	 * @secure
	 * @response `200` `(PricingCampaignMatchedProductsCountResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignMatchedProductsReorder {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignProductCountReorderRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody =
			PricingCampaignMatchedProductsCountResponseModel[]
	}

	/**
	 * No description
	 * @tags pricing-campaign
	 * @name PricingCampaignMatchedProducts
	 * @summary Estimate products distribution after updating pricing campaign
	 * @request POST:/api/v1/pricing-campaigns/matched-products
	 * @secure
	 * @response `200` `PricingCampaignMatchedProductsCountResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignMatchedProducts {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignProductCountRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignMatchedProductsCountResponseModel
	}

	/**
	 * @description Duplicate pricing campaign resources
	 * @tags pricing-campaign
	 * @name PricingCampaignsDuplicate
	 * @summary Duplicate pricing campaigns
	 * @request POST:/api/v1/pricing-campaigns/duplicate
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignsDuplicate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignDuplicateRequest
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * @description Reassign pricing campaign resources
	 * @tags pricing-campaign
	 * @name PricingCampaignsReassign
	 * @summary Reassign pricing campaigns
	 * @request POST:/api/v1/pricing-campaigns/reassign
	 * @secure
	 * @response `200` `(PricingCampaignReassignResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignsReassign {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignReassignRequest
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignReassignResponseModel[]
	}

	/**
	 * @description Export all pricing campaign settings of the user optimization groups to an xlsx file and return a signed download URL
	 * @tags pricing-campaign
	 * @name PricingCampaignSettingsExport
	 * @summary Export pricing campaign settings
	 * @request POST:/api/v1/pricing-campaigns/settings-export
	 * @secure
	 * @response `200` `PricingCampaignSettingsExportResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignSettingsExport {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignSettingsExportResponseModel
	}

	/**
	 * @description Copy settings pricing campaign resources
	 * @tags pricing-campaign
	 * @name PricingCampaignsCopySettings
	 * @summary Copy settings pricing campaigns
	 * @request POST:/api/v1/pricing-campaigns/copy-settings
	 * @secure
	 * @response `200` `(PricingCampaignCopySettingsResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace PricingCampaignsCopySettings {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingCampaignCopySettingsRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingCampaignCopySettingsResponseModel[]
	}
}

export namespace PricingRule {
	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleCatalog
	 * @summary Unified catalog of all pricing rules (system + user)
	 * @request GET:/api/v1/pricing-rules/catalog
	 * @secure
	 * @response `200` `CatalogResponseModel` Successful Response
	 */
	export namespace PricingRuleCatalog {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = CatalogResponseModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleList
	 * @summary List pricing rules
	 * @request GET:/api/v1/pricing-rules
	 * @secure
	 * @response `200` `PricingRuleListResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleList {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Search */
			search?: string | null
			/** Limit */
			limit?: number | null
			/** Offset */
			offset?: number | null
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleListResponseModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleCreate
	 * @summary Create pricing rule
	 * @request POST:/api/v1/pricing-rules
	 * @secure
	 * @response `201` `PricingRuleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PricingRuleCreateModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleGet
	 * @summary Get pricing rule
	 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}
	 * @secure
	 * @response `200` `PricingRuleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleGet {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleUpdate
	 * @summary Update pricing rule
	 * @request PATCH:/api/v1/pricing-rules/{pricing_rule_id}
	 * @secure
	 * @response `200` `PricingRuleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleUpdate {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingRuleUpdateModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleDelete
	 * @summary Archive pricing rule
	 * @request DELETE:/api/v1/pricing-rules/{pricing_rule_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleDelete {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleDraftGet
	 * @summary Get pricing rule draft
	 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/draft
	 * @secure
	 * @response `200` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleDraftGet {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleDraftSave
	 * @summary Save pricing rule draft
	 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/draft
	 * @secure
	 * @response `200` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleDraftSave {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingRuleDraftSaveModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleDraftExport
	 * @summary Export pricing rule draft body
	 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/draft/export
	 * @secure
	 * @response `200` `PricingRuleBodyModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleDraftExport {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleBodyModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleDraftImport
	 * @summary Import a JSON file into pricing rule draft
	 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/draft/import
	 * @secure
	 * @response `200` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleDraftImport {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingRuleImportForm
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRulePublish
	 * @summary Publish pricing rule draft
	 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/versions
	 * @secure
	 * @response `201` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRulePublish {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingRulePublishModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleVersionsList
	 * @summary List pricing rule published versions
	 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/versions
	 * @secure
	 * @response `200` `PricingRuleVersionListResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleVersionsList {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {
			/** Limit */
			limit?: number | null
			/** Offset */
			offset?: number | null
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleVersionListResponseModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleVersionGet
	 * @summary Get pricing rule version
	 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}
	 * @secure
	 * @response `200` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleVersionGet {
		export type RequestParams = {
			/**
			 * Pricing Rule Version Id
			 * @format uuid
			 */
			pricingRuleVersionId: string
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleVersionUpdate
	 * @summary Update pricing rule version metadata
	 * @request PATCH:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}
	 * @secure
	 * @response `200` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleVersionUpdate {
		export type RequestParams = {
			/**
			 * Pricing Rule Version Id
			 * @format uuid
			 */
			pricingRuleVersionId: string
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingRuleVersionUpdateModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleVersionExport
	 * @summary Export pricing rule version body
	 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}/export
	 * @secure
	 * @response `200` `PricingRuleBodyModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleVersionExport {
		export type RequestParams = {
			/**
			 * Pricing Rule Version Id
			 * @format uuid
			 */
			pricingRuleVersionId: string
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PricingRuleBodyModel
	}

	/**
	 * No description
	 * @tags pricing-rule
	 * @name PricingRuleVersionRestore
	 * @summary Restore a published version into the draft
	 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}/restore
	 * @secure
	 * @response `200` `PricingRuleVersionModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PricingRuleVersionRestore {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
			/**
			 * Pricing Rule Version Id
			 * @format uuid
			 */
			pricingRuleVersionId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleVersionModel
	}

	/**
 * @description The latest published version becomes both the draft and the first published version of a new rule. Intermediate version history is not copied.
 * @tags pricing-rule
 * @name PricingRuleDuplicate
 * @summary Duplicate a pricing rule from its latest published version
 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/duplicate
 * @secure
 * @response `201` `PricingRuleModel` Successful Response
 * @response `409` `(({
"code": "RULE_004"
} & PricingRuleArchivedErrorResponse) | ({
"code": "RULE_005"
} & PricingRuleNotPublishedErrorResponse))` The pricing rule is archived or has no published version
 * @response `422` `HTTPValidationError` Validation Error
*/
	export namespace PricingRuleDuplicate {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = PricingRuleModel
	}

	/**
 * @description Assigns the pricing rule to the given pricing campaigns, carrying over the parameters they already have. Parameters are matched by id and type; what has no match falls back to the parameter default. Only the latest published version can be applied. The operation is transactional — if one pricing campaign fails, nothing is applied. `force_update` cleans up settings that cannot be preserved instead of failing.
 * @tags pricing-rule
 * @name PricingRuleApply
 * @summary Apply the latest published version into pricing campaigns
 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/apply
 * @secure
 * @response `204` `void` Successful Response
 * @response `400` `PricingRuleApplyErrorResponse` Parameters that could not be preserved
 * @response `409` `(({
"code": "RULE_004"
} & PricingRuleArchivedErrorResponse) | ({
"code": "RULE_005"
} & PricingRuleNotPublishedErrorResponse))` The pricing rule is archived or has no published version
 * @response `422` `HTTPValidationError` Validation Error
 * @response `424` `FailedPendingResponse` Failure while updating optimization status
*/
	export namespace PricingRuleApply {
		export type RequestParams = {
			/**
			 * Pricing Rule Id
			 * @format uuid
			 */
			pricingRuleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PricingRuleApplyModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace ScenarioRunSets {
	/**
	 * No description
	 * @tags scenario-run-sets
	 * @name ListScenarioRunSets
	 * @summary List-Scenario-Run-Sets
	 * @request POST:/api/v1/scenario-run-sets/query
	 * @secure
	 * @response `200` `QueryScenarioRunSetResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ListScenarioRunSets {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = QueryScenarioRunSetRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = QueryScenarioRunSetResponseModel
	}

	/**
	 * No description
	 * @tags scenario-run-sets
	 * @name GetScenarioRunSet
	 * @summary Get-Scenario-Run-Set
	 * @request GET:/api/v1/scenario-run-sets/{scenario_run_set_id}
	 * @secure
	 * @response `200` `ScenarioRunSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetScenarioRunSet {
		export type RequestParams = {
			/**
			 * Scenario Run Set Id
			 * @format uuid
			 */
			scenarioRunSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ScenarioRunSetModel
	}

	/**
	 * No description
	 * @tags scenario-run-sets
	 * @name DeleteScenarioRunSet
	 * @summary Delete-Scenario-Run-Set
	 * @request DELETE:/api/v1/scenario-run-sets/{scenario_run_set_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteScenarioRunSet {
		export type RequestParams = {
			/**
			 * Scenario Run Set Id
			 * @format uuid
			 */
			scenarioRunSetId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags scenario-run-sets
	 * @name CreateScenarioRunSet
	 * @summary Create-Scenario-Run-Set
	 * @request POST:/api/v1/scenario-run-sets
	 * @secure
	 * @response `201` `ScenarioRunSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateScenarioRunSet {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ScenarioRunSetCreateModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioRunSetModel
	}

	/**
	 * No description
	 * @tags scenario-run-sets
	 * @name RestartScenarioRunSet
	 * @summary Restart-Scenario-Run-Set
	 * @request POST:/api/v1/scenario-run-sets/restart
	 * @secure
	 * @response `200` `ScenarioRunSetModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace RestartScenarioRunSet {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ScenarioRunSetRestartModel
		export type RequestHeaders = {}
		export type ResponseBody = ScenarioRunSetModel
	}

	/**
	 * No description
	 * @tags scenario-run-sets
	 * @name DeleteScenarioRun
	 * @summary Delete-Scenario-Run
	 * @request DELETE:/api/v1/scenario-run-sets/{scenario_run_set_id}/runs/{scenario_run_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteScenarioRun {
		export type RequestParams = {
			/**
			 * Scenario Run Set Id
			 * @format uuid
			 */
			scenarioRunSetId: string
			/**
			 * Scenario Run Id
			 * @format uuid
			 */
			scenarioRunId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}
}

export namespace Scenario {
	/**
	 * @description List scenario resources
	 * @tags scenario
	 * @name ScenariosQueryList
	 * @summary List scenarios
	 * @request POST:/api/v1/scenarios/query
	 * @secure
	 * @response `200` `(ScenarioModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenariosQueryList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ScenarioQueryModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel[]
	}

	/**
	 * @description List scenario resources
	 * @tags scenario
	 * @name ScenariosList
	 * @summary List scenarios
	 * @request GET:/api/v1/scenarios
	 * @secure
	 * @response `200` `(ScenarioModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenariosList {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Optimization Group Id */
			optimization_group_id?: string | null
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel[]
	}

	/**
	 * @description Create scenario resource
	 * @tags scenario
	 * @name ScenarioCreate
	 * @summary Create scenario
	 * @request POST:/api/v1/scenarios
	 * @secure
	 * @response `201` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ScenarioCreateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Get scenario resource
	 * @tags scenario
	 * @name ScenarioGet
	 * @summary Get scenario
	 * @request GET:/api/v1/scenarios/{scenario_id}
	 * @secure
	 * @response `200` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioGet {
		export type RequestParams = {
			/**
			 * Scenario Id
			 * @format uuid
			 */
			scenarioId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Update scenario resource
	 * @tags scenario
	 * @name ScenarioUpdate
	 * @summary Update scenario
	 * @request PATCH:/api/v1/scenarios/{scenario_id}
	 * @secure
	 * @response `200` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioUpdate {
		export type RequestParams = {
			/**
			 * Scenario Id
			 * @format uuid
			 */
			scenarioId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ScenarioUpdateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Get main scenario resource
	 * @tags scenario
	 * @name ScenarioGetMain
	 * @summary Get main scenario
	 * @request GET:/api/v1/scenarios/main/{optimization_group_id}
	 * @secure
	 * @response `200` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioGetMain {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Update main scenario resource
	 * @tags scenario
	 * @name ScenarioUpdateMain
	 * @summary Update main scenario
	 * @request PATCH:/api/v1/scenarios/main/{optimization_group_id}
	 * @secure
	 * @response `200` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioUpdateMain {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ScenarioUpdateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Delete scenario resources
	 * @tags scenario
	 * @name DeleteScenariosBulk
	 * @summary Delete scenarios
	 * @request POST:/api/v1/scenarios/delete
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace DeleteScenariosBulk {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = DeleteScenariosBulkRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags scenario
	 * @name ScenarioMatchedProducts
	 * @summary Get scenario stop-list matched products estimate
	 * @request POST:/api/v1/scenarios/{scenario_id}/stop-list-matched-products
	 * @secure
	 * @response `200` `ScenarioMatchedProductsCountResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioMatchedProducts {
		export type RequestParams = {
			/**
			 * Scenario Id
			 * @format uuid
			 */
			scenarioId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ScenarioUpdateDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioMatchedProductsCountResponseModel
	}

	/**
	 * @description Duplicate scenario resource
	 * @tags scenario
	 * @name ScenarioDuplicate
	 * @summary Duplicate scenario
	 * @request POST:/api/v1/scenarios/{scenario_id}/duplicate
	 * @secure
	 * @response `200` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioDuplicate {
		export type RequestParams = {
			/**
			 * Scenario Id
			 * @format uuid
			 */
			scenarioId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Set main scenario resource
	 * @tags scenario
	 * @name ScenarioSetMain
	 * @summary Set main scenario
	 * @request POST:/api/v1/scenarios/{scenario_id}/set-main
	 * @secure
	 * @response `200` `ScenarioModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioSetMain {
		export type RequestParams = {
			/**
			 * Scenario Id
			 * @format uuid
			 */
			scenarioId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ScenarioSetMainDataModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioModel
	}

	/**
	 * @description Main scenario copy settings resource
	 * @tags scenario
	 * @name ScenarioMainCopySettings
	 * @summary Main scenario copy settings
	 * @request POST:/api/v1/scenarios/main/{optimization_group_id}/copy-settings
	 * @secure
	 * @response `200` `(ScenarioMainCopySettingsResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace ScenarioMainCopySettings {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ScenarioMainCopySettings
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ScenarioMainCopySettingsResponseModel[]
	}
}

export namespace SettingsInterpretation {
	/**
	 * @description Get price limits interpretation
	 * @tags settings-interpretation
	 * @name PriceLimits
	 * @summary Get price limits interpretation
	 * @request POST:/api/v1/settings-interpretation/price-limits
	 * @secure
	 * @response `200` `SettingsInterpretationResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PriceLimits {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PriceLimitsRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = SettingsInterpretationResponseModel
	}

	/**
	 * @description Get rounding interpretation
	 * @tags settings-interpretation
	 * @name Rounding
	 * @summary Get rounding interpretation
	 * @request POST:/api/v1/settings-interpretation/rounding
	 * @secure
	 * @response `200` `SettingsInterpretationResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace Rounding {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = RoundingRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = SettingsInterpretationResponseModel
	}

	/**
	 * @description Get anchoring interpretation
	 * @tags settings-interpretation
	 * @name Anchoring
	 * @summary Get anchoring interpretation
	 * @request POST:/api/v1/settings-interpretation/anchoring
	 * @secure
	 * @response `200` `SettingsInterpretationResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace Anchoring {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchoringRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = SettingsInterpretationResponseModel
	}
}

export namespace SettingsSchemas {
	/**
	 * @description List settings schemas resources
	 * @tags settings-schemas
	 * @name SettingsSchemasList
	 * @summary List settings schemas
	 * @request GET:/api/v1/settings-schemas
	 * @secure
	 * @response `200` `ProductDiffsModel` Successful Response
	 */
	export namespace SettingsSchemasList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ProductDiffsModel
	}

	/**
	 * @description List ui schemas resources
	 * @tags settings-schemas
	 * @name UiSchemasList
	 * @summary List ui schemas
	 * @request GET:/api/v1/ui-schemas
	 * @secure
	 * @response `200` `ProductDiffsModel` Successful Response
	 */
	export namespace UiSchemasList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ProductDiffsModel
	}
}

export namespace SettingsTemplate {
	/**
	 * @description Query settings-template resource
	 * @tags settings-template
	 * @name SettingsTemplateQuery
	 * @summary Query settings-template
	 * @request POST:/api/v1/settings-templates/query
	 * @secure
	 * @response `200` `SettingsTemplateQueryResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace SettingsTemplateQuery {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingsTemplateQueryModel
		export type RequestHeaders = {}
		export type ResponseBody = SettingsTemplateQueryResponseModel
	}

	/**
	 * @description Get settings-template resource
	 * @tags settings-template
	 * @name SettingsTemplateGet
	 * @summary Get settings-template
	 * @request GET:/api/v1/settings-templates/{settings_template_id}
	 * @secure
	 * @response `200` `SettingsTemplateModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace SettingsTemplateGet {
		export type RequestParams = {
			/**
			 * Settings Template Id
			 * @format uuid
			 */
			settingsTemplateId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = SettingsTemplateModel
	}

	/**
	 * @description Update settings-template resource
	 * @tags settings-template
	 * @name SettingsTemplateUpdate
	 * @summary Update settings-template
	 * @request PATCH:/api/v1/settings-templates/{settings_template_id}
	 * @secure
	 * @response `200` `SettingsTemplateModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace SettingsTemplateUpdate {
		export type RequestParams = {
			/**
			 * Settings Template Id
			 * @format uuid
			 */
			settingsTemplateId: string
		}
		export type RequestQuery = {}
		export type RequestBody = SettingsTemplateUpdateModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = SettingsTemplateModel
	}

	/**
	 * @description Delete settings-template resource
	 * @tags settings-template
	 * @name SettingsTemplateDelete
	 * @summary Delete settings-template
	 * @request DELETE:/api/v1/settings-templates/{settings_template_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace SettingsTemplateDelete {
		export type RequestParams = {
			/**
			 * Settings Template Id
			 * @format uuid
			 */
			settingsTemplateId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * @description Create settings-template resource
	 * @tags settings-template
	 * @name SettingsTemplateCreate
	 * @summary Create settings-template
	 * @request POST:/api/v1/settings-templates
	 * @secure
	 * @response `201` `SettingsTemplateModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace SettingsTemplateCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingsTemplateCreateModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = SettingsTemplateModel
	}

	/**
	 * @description Apply settings-template resource
	 * @tags settings-template
	 * @name SettingsTemplateApply
	 * @summary Apply settings-template
	 * @request POST:/api/v1/settings-templates/{settings_template_id}/apply
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 * @response `424` `FailedPendingResponse` Failure while updating optimization status
	 */
	export namespace SettingsTemplateApply {
		export type RequestParams = {
			/**
			 * Settings Template Id
			 * @format uuid
			 */
			settingsTemplateId: string
		}
		export type RequestQuery = {}
		export type RequestBody = SettingsTemplateApplyRequestModel
		export type RequestHeaders = {
			/**
			 * Auth-User-Id
			 * @format uuid
			 */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace Anchors {
	/**
	 * @description Query anchor resources
	 * @tags anchors
	 * @name AnchorsQuery
	 * @summary Query anchors
	 * @request POST:/api/v1/anchors/query
	 * @secure
	 * @response `200` `AnchorsQueryResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsQuery {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorsQueryModel
		export type RequestHeaders = {}
		export type ResponseBody = AnchorsQueryResponseModel
	}

	/**
	 * @description Export anchor resources
	 * @tags anchors
	 * @name AnchorsExport
	 * @summary Export anchors
	 * @request POST:/api/v1/anchors/export
	 * @secure
	 * @response `200` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsExport {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorsExportModel
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * @description Get anchor alerts resources
	 * @tags anchors
	 * @name AnchorsAlerts
	 * @summary Get anchors alerts
	 * @request GET:/api/v1/anchors/alerts
	 * @secure
	 * @response `200` `(AnchorsAlertsItemModel)[]` Successful Response
	 */
	export namespace AnchorsAlerts {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = AnchorsAlertsItemModel[]
	}

	/**
	 * @description Query anchor alerts resources
	 * @tags anchors
	 * @name AnchorsAlertsInfoQuery
	 * @summary Query anchors alerts info
	 * @request POST:/api/v1/anchors/alerts-info/query
	 * @secure
	 * @response `200` `(AnchorsAlertsInfoModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAlertsInfoQuery {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorsAlertsInfoQueryModel
		export type RequestHeaders = {}
		export type ResponseBody = AnchorsAlertsInfoModel[]
	}

	/**
	 * @description Import anchor resources
	 * @tags anchors
	 * @name AnchorsImport
	 * @summary Import anchors
	 * @request POST:/api/v1/anchors/import
	 * @secure
	 * @response `200` `AnchorsUpsertResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsImport {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorImportFileForm
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = AnchorsUpsertResponseModel
	}

	/**
	 * @description Upsert anchor resources
	 * @tags anchors
	 * @name AnchorsUpsert
	 * @summary Upsert anchors
	 * @request POST:/api/v1/anchors/upsert
	 * @secure
	 * @response `200` `AnchorsUpsertResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsUpsert {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorsUpsertModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = AnchorsUpsertResponseModel
	}

	/**
	 * @description Delete anchor resources
	 * @tags anchors
	 * @name AnchorsDelete
	 * @summary Delete anchors
	 * @request POST:/api/v1/anchors/delete
	 * @secure
	 * @response `200` `AnchorsDeleteResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsDelete {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorsDeleteModel
		export type RequestHeaders = {}
		export type ResponseBody = AnchorsDeleteResponseModel
	}

	/**
	 * @description Convert Optimization Group POSes to Sales Entity
	 * @tags anchors
	 * @name AnchorsSalesEntityGet
	 * @summary Convert Optimization Group POSes to Sales Entity
	 * @request GET:/api/v1/anchors/sales-entity/{optimization_group_id}
	 * @secure
	 * @response `200` `AnchorsSalesEntityResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsSalesEntityGet {
		export type RequestParams = {
			/** Optimization Group Id */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = AnchorsSalesEntityResponseModel
	}
}

export namespace AnchorStrategies {
	/**
	 * @description Query anchor strategies resources
	 * @tags anchor-strategies
	 * @name AnchorsAnchorStrategyQuery
	 * @summary Query anchors strategies
	 * @request POST:/api/v1/anchors/anchor-strategies/query
	 * @secure
	 * @response `200` `AnchorStrategyQueryResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAnchorStrategyQuery {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorStrategyQueryModel
		export type RequestHeaders = {}
		export type ResponseBody = AnchorStrategyQueryResponseModel
	}

	/**
	 * @description Get anchor strategy resource
	 * @tags anchor-strategies
	 * @name AnchorsAnchorStrategyGet
	 * @summary Get anchor strategy
	 * @request GET:/api/v1/anchors/anchor-strategies/{anchor_strategy_id}
	 * @secure
	 * @response `200` `AnchorStrategyModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAnchorStrategyGet {
		export type RequestParams = {
			/**
			 * Anchor Strategy Id
			 * @format uuid
			 */
			anchorStrategyId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = AnchorStrategyModel
	}

	/**
	 * @description Update anchor strategy resource
	 * @tags anchor-strategies
	 * @name AnchorsAnchorStrategyUpdate
	 * @summary Update anchor strategy
	 * @request PATCH:/api/v1/anchors/anchor-strategies/{anchor_strategy_id}
	 * @secure
	 * @response `200` `AnchorStrategyModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAnchorStrategyUpdate {
		export type RequestParams = {
			/**
			 * Anchor Strategy Id
			 * @format uuid
			 */
			anchorStrategyId: string
		}
		export type RequestQuery = {}
		export type RequestBody = AnchorStrategyUpdateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = AnchorStrategyModel
	}

	/**
	 * @description Delete anchor strategy resource
	 * @tags anchor-strategies
	 * @name AnchorsAnchorStrategyDelete
	 * @summary Delete anchor strategy
	 * @request DELETE:/api/v1/anchors/anchor-strategies/{anchor_strategy_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAnchorStrategyDelete {
		export type RequestParams = {
			/**
			 * Anchor Strategy Id
			 * @format uuid
			 */
			anchorStrategyId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * @description Create anchor strategy resource
	 * @tags anchor-strategies
	 * @name AnchorsAnchorStrategyCreate
	 * @summary Create anchor strategy
	 * @request POST:/api/v1/anchors/anchor-strategies
	 * @secure
	 * @response `200` `AnchorStrategyModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAnchorStrategyCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorStrategyCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = AnchorStrategyModel
	}

	/**
	 * @description Get anchor strategy matched products resources
	 * @tags anchor-strategies
	 * @name AnchorsAnchorStrategyMatchedProducts
	 * @summary Get anchor strategy matched products
	 * @request POST:/api/v1/anchors/anchor-strategy/matched-products
	 * @secure
	 * @response `200` `(AnchorStrategyGroupMatchedModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsAnchorStrategyMatchedProducts {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorStrategyMatchedProductsRequest
		export type RequestHeaders = {}
		export type ResponseBody = AnchorStrategyGroupMatchedModel[]
	}

	/**
	 * @description Query anchor generated families resources
	 * @tags anchor-strategies
	 * @name AnchorsGeneratedFamilyQuery
	 * @summary Query anchors generated families
	 * @request POST:/api/v1/anchors/generated-families/query
	 * @secure
	 * @response `200` `AnchorGeneratedFamilyQueryResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsGeneratedFamilyQuery {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorGeneratedFamilyQueryModel
		export type RequestHeaders = {}
		export type ResponseBody = AnchorGeneratedFamilyQueryResponseModel
	}

	/**
	 * @description Review anchor generated families resources
	 * @tags anchor-strategies
	 * @name AnchorsGeneratedFamilyReview
	 * @summary Review anchors generated families
	 * @request POST:/api/v1/anchors/generated-families/review
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsGeneratedFamilyReview {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = AnchorGeneratedFamilyReviewRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = void
	}
}

export namespace ProductCatalog {
	/**
	 * @description Query product catalog resources
	 * @tags product-catalog
	 * @name AnchorsProductCatalogQuery
	 * @summary Query product catalog
	 * @request POST:/api/v1/anchors/product-catalog/query
	 * @secure
	 * @response `200` `ProductCatalogQueryResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AnchorsProductCatalogQuery {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ProductCatalogQueryModel
		export type RequestHeaders = {}
		export type ResponseBody = ProductCatalogQueryResponseModel
	}
}

export namespace Currencies {
	/**
	 * No description
	 * @tags currencies
	 * @name GetCurrencies
	 * @summary Get currencies of optimization groups available for user and the default one.
	 * @request GET:/api/v1/currencies
	 * @secure
	 * @response `200` `CurrenciesResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCurrencies {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = CurrenciesResponseModel
	}
}

export namespace ExternalExport {
	/**
	 * @description Returns a list of existing user exports
	 * @tags external-export
	 * @name ListExportsExternal
	 * @summary List all exports
	 * @request GET:/external/api/v1/exports
	 * @secure
	 * @response `200` `(ExportModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ListExportsExternal {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = ExportModel[]
	}

	/**
	 * @description Create an export task with specified columns, headers and/or filters. Starts an asynchronous task to create an export file that can be downloaded when the export status becomes `finished`.
	 * @tags external-export
	 * @name CreateExportExternal
	 * @summary Create export
	 * @request POST:/external/api/v1/exports
	 * @secure
	 * @response `201` `ExportModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateExportExternal {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ExportCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = ExportModel
	}

	/**
	 * @description Returns a signed URL to download the export file when status is `finished`. The URL expires in 5 minutes.
	 * @tags external-export
	 * @name GetDownloadLinkExternal
	 * @summary Get export download URL
	 * @request GET:/external/api/v1/exports/{export_id}/download-url
	 * @secure
	 * @response `200` `ExportDownloadUrlModel` Successful Response
	 * @response `404` `void` export is not found
	 * @response `409` `void` export is not ready
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetDownloadLinkExternal {
		export type RequestParams = {
			/**
			 * Export Id
			 * @format uuid
			 */
			exportId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ExportDownloadUrlModel
	}
}

export namespace Export {
	/**
	 * No description
	 * @tags export
	 * @name ListExports
	 * @summary List Exports
	 * @request GET:/api/v1/exports
	 * @secure
	 * @response `200` `(ExportModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ListExports {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = ExportModel[]
	}

	/**
	 * No description
	 * @tags export
	 * @name CreateExport
	 * @summary Create Export
	 * @request POST:/api/v1/exports
	 * @secure
	 * @response `201` `ExportModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateExport {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ExportCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = ExportModel
	}

	/**
	 * @description Download the export file. Deprecated in favor of `GET /exports/{export_id}/download-url`.
	 * @tags export
	 * @name DownloadExportFile
	 * @summary Download Export File
	 * @request GET:/api/v1/exports/{export_id}/download
	 * @deprecated
	 * @secure
	 * @response `200` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DownloadExportFile {
		export type RequestParams = {
			/**
			 * Export Id
			 * @format uuid
			 */
			exportId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags export
	 * @name GetDownloadLink
	 * @summary Get a signed URL to download the export file.
	 * @request GET:/api/v1/exports/{export_id}/download-url
	 * @secure
	 * @response `200` `ExportDownloadUrlModel` Successful Response
	 * @response `404` `void` export is not found
	 * @response `409` `void` export is not ready
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetDownloadLink {
		export type RequestParams = {
			/**
			 * Export Id
			 * @format uuid
			 */
			exportId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ExportDownloadUrlModel
	}

	/**
	 * No description
	 * @tags export
	 * @name DeleteExport
	 * @summary Delete Export
	 * @request DELETE:/api/v1/exports/{export_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteExport {
		export type RequestParams = {
			/**
			 * Export Id
			 * @format uuid
			 */
			exportId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags export
	 * @name GetExportTemplates
	 * @summary Get Export Templates
	 * @request GET:/api/v1/exports/templates
	 * @secure
	 * @response `200` `(ExportTemplateModel)[]` Successful Response
	 */
	export namespace GetExportTemplates {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ExportTemplateModel[]
	}
}

export namespace Optimizations {
	/**
	 * No description
	 * @tags optimizations
	 * @name GetCurrentOptimizations
	 * @summary Get list of current optimizations in project, optionally filtered by OGs.
	 * @request GET:/api/v2/current-optimizations
	 * @secure
	 * @response `200` `(OptimizationModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCurrentOptimizations {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Og Id */
			og_id?: string[] | null
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel[]
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name GetOptimizations
	 * @summary Get list of optimizations by id.
	 * @request GET:/api/v2/optimizations
	 * @secure
	 * @response `200` `(OptimizationModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOptimizations {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Id */
			id: string[]
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel[]
	}

	/**
	 * @description Create new current optimization in specific optimization group. Deprecated in favor of `reset` action.
	 * @tags optimizations
	 * @name CreateOptimization
	 * @summary Create new current optimization in specific optimization group.
	 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations
	 * @deprecated
	 * @secure
	 * @response `201` `OptimizationModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateOptimization {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationFinalFieldsSku
	 * @summary Perform sku-wise final fields update on specific optimization group
	 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/final-fields-sku
	 * @secure
	 * @response `200` `OptimizationModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationFinalFieldsSku {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = FinalFieldsListModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationFinalFieldsFilters
	 * @summary Perform filters-based final fields update on specific optimization group
	 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/final-fields-filters
	 * @secure
	 * @response `200` `(OptimizationModel | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationFinalFieldsFilters {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = FinalFieldsPatchModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel | null
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationProductDiffsSku
	 * @summary Perform sku-wise product update on specific optimization group
	 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/product-diffs-sku
	 * @secure
	 * @response `200` `(OptimizationModel | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationProductDiffsSku {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ProductDiffsModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel | null
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationProductDiffsFilters
	 * @summary Perform filters-based product update on specific optimization group
	 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/product-diffs-filters
	 * @secure
	 * @response `200` `(OptimizationModel | null)` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationProductDiffsFilters {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = ProductsUpdateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel | null
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationAction
	 * @summary Perform action on current optimization in specific optimization group
	 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/{action}
	 * @secure
	 * @response `200` `OptimizationModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationAction {
		export type RequestParams = {
			action: OptimizationAction
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationModel
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationBulkActions
	 * @summary Perform multiple optimization actions at the same time
	 * @request POST:/api/v2/optimizations/bulk-actions
	 * @secure
	 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationBulkActions {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = OptimizationBulkActionsRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationActionResponseModel[]
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationBulkProductDiffsFile
	 * @summary Perform multiple optimization product diff actions at the same time
	 * @request POST:/api/v2/optimizations/bulk-product-diffs-file
	 * @secure
	 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationBulkProductDiffsFile {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BulkProductDiffsFileForm
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationActionResponseModel[]
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name ValidateProductDiff
	 * @summary Validate product diff without taking any other action
	 * @request POST:/api/v2/optimizations/validate-product-diff
	 * @secure
	 * @response `200` `ValidateProductDiffsResponse` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ValidateProductDiff {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ValidateProductDiffsFileForm
		export type RequestHeaders = {}
		export type ResponseBody = ValidateProductDiffsResponse
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationBulkFinalFields
	 * @summary Perform bulk final fields update on matching optimization groups
	 * @request POST:/api/v2/optimizations/bulk-final-fields
	 * @secure
	 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationBulkFinalFields {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = OptimizationBulkFinalFieldsRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationActionResponseModel[]
	}

	/**
	 * No description
	 * @tags optimizations
	 * @name OptimizationBulkFinalFieldsFile
	 * @summary Perform bulk final fields update from file on matching optimization groups
	 * @request POST:/api/v2/optimizations/bulk-final-fields-file
	 * @secure
	 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace OptimizationBulkFinalFieldsFile {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = BulkFinalFieldsFileForm
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationActionResponseModel[]
	}
}

export namespace OptimizationGroups {
	/**
	 * No description
	 * @tags optimization-groups
	 * @name GetProductGroups
	 * @summary Get list of product groups available in project.
	 * @request GET:/api/v2/product-groups
	 * @secure
	 * @response `200` `(ProductGroupModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetProductGroups {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Include Full Categories
			 * @default false
			 */
			include_full_categories?: boolean
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ProductGroupModel[]
	}

	/**
	 * No description
	 * @tags optimization-groups
	 * @name GetSalesEntities
	 * @summary Get list of sales entities in project.
	 * @request GET:/api/v2/sales-entities
	 * @secure
	 * @response `200` `SalesEntitiesResponseModel` Successful Response
	 */
	export namespace GetSalesEntities {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = SalesEntitiesResponseModel
	}

	/**
	 * No description
	 * @tags optimization-groups
	 * @name GetOptimizationGroups
	 * @summary Get list of optimization groups available for user in project.
	 * @request GET:/api/v2/optimization-groups
	 * @secure
	 * @response `200` `(OptimizationGroupModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOptimizationGroups {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupModel[]
	}

	/**
	 * No description
	 * @tags optimization-groups
	 * @name CreateOptimizationGroup
	 * @summary Create new optimization group in project.
	 * @request POST:/api/v2/optimization-groups
	 * @secure
	 * @response `200` `OptimizationGroupModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateOptimizationGroup {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = OptimizationGroupCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupModel
	}

	/**
	 * No description
	 * @tags optimization-groups
	 * @name GetOptimizationGroup
	 * @summary Get specific optimization group in project.
	 * @request GET:/api/v2/optimization-groups/{optimization_group_id}
	 * @secure
	 * @response `200` `OptimizationGroupModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetOptimizationGroup {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupModel
	}

	/**
	 * No description
	 * @tags optimization-groups
	 * @name UpdateOptimizationGroup
	 * @summary Update existing optimization group in project.
	 * @request PATCH:/api/v2/optimization-groups/{optimization_group_id}
	 * @secure
	 * @response `200` `OptimizationGroupModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateOptimizationGroup {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = UpdateOptimizationGroupRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupModel
	}

	/**
	 * No description
	 * @tags optimization-groups
	 * @name DeleteOptimizationGroup
	 * @summary Delete optimization group in project (actually marks inactive).
	 * @request DELETE:/api/v2/optimization-groups/{optimization_group_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteOptimizationGroup {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace Reviews {
	/**
	 * No description
	 * @tags reviews
	 * @name ListOptimizationGroupsReviews
	 * @summary List all reviews for the current iteration.
	 * @request GET:/api/v1/optimization-groups/reviews
	 * @secure
	 * @response `200` `OptimizationGroupReviewListResponse` Successful Response
	 */
	export namespace ListOptimizationGroupsReviews {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = OptimizationGroupReviewListResponse
	}

	/**
	 * No description
	 * @tags reviews
	 * @name CreateOptimizationGroupReview
	 * @summary Create a review for an optimization group.
	 * @request POST:/api/v1/optimization-groups/{optimization_group_id}/reviews
	 * @secure
	 * @response `201` `OptimizationGroupReviewModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateOptimizationGroupReview {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = OptimizationGroupReviewCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupReviewModel
	}

	/**
	 * No description
	 * @tags reviews
	 * @name UpdateOptimizationGroupReview
	 * @summary Update a review for an optimization group.
	 * @request PATCH:/api/v1/optimization-groups/{optimization_group_id}/reviews
	 * @secure
	 * @response `200` `OptimizationGroupReviewModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateOptimizationGroupReview {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = OptimizationGroupReviewUpdateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupReviewModel
	}

	/**
	 * No description
	 * @tags reviews
	 * @name DeleteOptimizationGroupReview
	 * @summary Delete a review for an optimization group.
	 * @request DELETE:/api/v1/optimization-groups/{optimization_group_id}/reviews
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteOptimizationGroupReview {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags reviews
	 * @name ApproveOptimizationGroupReview
	 * @summary Approve a review as a reviewer.
	 * @request POST:/api/v1/optimization-groups/{optimization_group_id}/reviews/approve
	 * @secure
	 * @response `200` `OptimizationGroupReviewModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ApproveOptimizationGroupReview {
		export type RequestParams = {
			/**
			 * Optimization Group Id
			 * @format uuid
			 */
			optimizationGroupId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = OptimizationGroupReviewModel
	}
}

export namespace Products {
	/**
	 * No description
	 * @tags products
	 * @name GetAlerts
	 * @summary Get list of product alerts in project.
	 * @request GET:/api/v2/alerts
	 * @secure
	 * @response `200` `(AlertModel)[]` Successful Response
	 */
	export namespace GetAlerts {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = AlertModel[]
	}

	/**
	 * No description
	 * @tags products
	 * @name GetBrands
	 * @summary Get brands for selected OG / all OGs
	 * @request GET:/api/v2/brands
	 * @secure
	 * @response `200` `(BrandModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetBrands {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Optimization Group Id */
			optimization_group_id?: string | null
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = BrandModel[]
	}

	/**
	 * No description
	 * @tags products
	 * @name GetCategories
	 * @summary Get categories for selected OG / all OGs
	 * @request GET:/api/v2/categories
	 * @secure
	 * @response `200` `(CategoryModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetCategories {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Optimization Group Id */
			optimization_group_id?: string | null
		}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = CategoryModel[]
	}

	/**
	 * No description
	 * @tags products
	 * @name QueryProducts
	 * @summary Get pricing lines accounting for filters, search, order and limits
	 * @request POST:/api/v2/products/query
	 * @secure
	 * @response `200` `ProductsQueryResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace QueryProducts {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ProductsQueryRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ProductsQueryResponseModel
	}

	/**
	 * No description
	 * @tags products
	 * @name GetProductsCountByPc
	 * @summary Get counts of products grouped by optimization_group_id and pricing_campaign_id.
	 * @request POST:/api/v2/products-count-by-pc
	 * @secure
	 * @response `200` `(ProductsByPCModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetProductsCountByPc {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ProductsByPCRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ProductsByPCModel[]
	}
}

export namespace RawProduct {
	/**
	 * No description
	 * @tags raw-product
	 * @name GetRawProductColumns
	 * @summary Get columns (name and type) of the ClickHouse raw_product table.
	 * @request GET:/api/v2/raw-product/columns
	 * @secure
	 * @response `200` `(RawProductColumnModel)[]` Successful Response
	 */
	export namespace GetRawProductColumns {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = RawProductColumnModel[]
	}
}

export namespace SavedFilters {
	/**
	 * No description
	 * @tags saved-filters
	 * @name GetSavedFilters
	 * @summary Get all public and personal saved filters in project.
	 * @request GET:/api/v2/saved-filters
	 * @secure
	 * @response `200` `(SavedFilterModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetSavedFilters {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = SavedFilterModel[]
	}

	/**
	 * No description
	 * @tags saved-filters
	 * @name CreateSavedFilter
	 * @summary Create saved filter in project.
	 * @request POST:/api/v2/saved-filters
	 * @secure
	 * @response `201` `SavedFilterModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateSavedFilter {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SavedFilterCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = SavedFilterModel
	}

	/**
	 * No description
	 * @tags saved-filters
	 * @name UpdateSavedFilter
	 * @summary Update saved filter in project.
	 * @request PATCH:/api/v2/saved-filters/{saved_filter_id}
	 * @secure
	 * @response `200` `any` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateSavedFilter {
		export type RequestParams = {
			/**
			 * Saved Filter Id
			 * @format uuid
			 */
			savedFilterId: string
		}
		export type RequestQuery = {}
		export type RequestBody = SavedFilterUpdateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = any
	}

	/**
	 * No description
	 * @tags saved-filters
	 * @name DeleteSavedFilter
	 * @summary Delete saved filter in project.
	 * @request DELETE:/api/v2/saved-filters/{saved_filter_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteSavedFilter {
		export type RequestParams = {
			/**
			 * Saved Filter Id
			 * @format uuid
			 */
			savedFilterId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace Schedules {
	/**
	 * No description
	 * @tags schedules
	 * @name ListSchedules
	 * @summary List all schedules.
	 * @request GET:/api/v1/schedules
	 * @secure
	 * @response `200` `(ScheduleModel)[]` Successful Response
	 */
	export namespace ListSchedules {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ScheduleModel[]
	}

	/**
	 * No description
	 * @tags schedules
	 * @name CreateSchedule
	 * @summary Create a schedule for optimization groups.
	 * @request POST:/api/v1/schedules
	 * @secure
	 * @response `201` `ScheduleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateSchedule {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = CreateScheduleModel
		export type RequestHeaders = {}
		export type ResponseBody = ScheduleModel
	}

	/**
	 * No description
	 * @tags schedules
	 * @name ListSchedules2
	 * @summary List Schedules
	 * @request GET:/api/v1/schedules/
	 * @originalName listSchedules
	 * @duplicate
	 * @secure
	 * @response `200` `(ScheduleModel)[]` Successful Response
	 */
	export namespace ListSchedules2 {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ScheduleModel[]
	}

	/**
	 * No description
	 * @tags schedules
	 * @name CreateSchedule2
	 * @summary Create Schedule
	 * @request POST:/api/v1/schedules/
	 * @originalName createSchedule
	 * @duplicate
	 * @secure
	 * @response `201` `ScheduleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreateSchedule2 {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = CreateScheduleModel
		export type RequestHeaders = {}
		export type ResponseBody = ScheduleModel
	}

	/**
	 * No description
	 * @tags schedules
	 * @name GetSchedule
	 * @summary Get schedule for optimization groups.
	 * @request GET:/api/v1/schedules/{schedule_id}
	 * @secure
	 * @response `200` `ScheduleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetSchedule {
		export type RequestParams = {
			/**
			 * Schedule Id
			 * @format uuid
			 */
			scheduleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ScheduleModel
	}

	/**
	 * No description
	 * @tags schedules
	 * @name UpdateSchedule
	 * @summary Update schedule for optimization groups.
	 * @request PATCH:/api/v1/schedules/{schedule_id}
	 * @secure
	 * @response `200` `ScheduleModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdateSchedule {
		export type RequestParams = {
			/**
			 * Schedule Id
			 * @format uuid
			 */
			scheduleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = UpdateScheduleModel
		export type RequestHeaders = {}
		export type ResponseBody = ScheduleModel
	}

	/**
	 * No description
	 * @tags schedules
	 * @name DeleteSchedule
	 * @summary Delete schedule for optimization groups.
	 * @request DELETE:/api/v1/schedules/{schedule_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeleteSchedule {
		export type RequestParams = {
			/**
			 * Schedule Id
			 * @format uuid
			 */
			scheduleId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}
}

export namespace CustomFeatureConfig {
	/**
 * No description
 * @tags custom-feature-config
 * @name CustomFeatureConfigList
 * @summary Custom-Feature-Config-List
 * @request GET:/api/v1/custom-feature-configs
 * @secure
 * @response `200` `((({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId)))[]` Successful Response
*/
	export namespace CustomFeatureConfigList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = (
			| ({
					type: 'product_feature'
			  } & ProductFeatureConfigWithId)
			| ({
					type: 'sales_metrics_feature'
			  } & SalesMetricsFeatureConfigWithId)
		)[]
	}

	/**
 * No description
 * @tags custom-feature-config
 * @name CustomFeatureConfigCreate
 * @summary Custom-Feature-Config-Create
 * @request POST:/api/v1/custom-feature-configs
 * @secure
 * @response `201` `(({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId))` Successful Response
 * @response `409` `void` Custom feature config already exists: `{id}`
 * @response `422` `HTTPValidationError` Validation Error
*/
	export namespace CustomFeatureConfigCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = CustomFeatureConfigCreateRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody =
			| ({
					type: 'product_feature'
			  } & ProductFeatureConfigWithId)
			| ({
					type: 'sales_metrics_feature'
			  } & SalesMetricsFeatureConfigWithId)
	}

	/**
 * No description
 * @tags custom-feature-config
 * @name CustomFeatureConfigGet
 * @summary Custom-Feature-Config-Get
 * @request GET:/api/v1/custom-feature-configs/{id}
 * @secure
 * @response `200` `(({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId))` Successful Response
 * @response `404` `void` Custom feature config not found: `{id}`
 * @response `422` `HTTPValidationError` Validation Error
*/
	export namespace CustomFeatureConfigGet {
		export type RequestParams = {
			/** Id */
			id: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody =
			| ({
					type: 'product_feature'
			  } & ProductFeatureConfigWithId)
			| ({
					type: 'sales_metrics_feature'
			  } & SalesMetricsFeatureConfigWithId)
	}

	/**
 * No description
 * @tags custom-feature-config
 * @name CustomFeatureConfigUpdate
 * @summary Custom-Feature-Config-Update
 * @request PATCH:/api/v1/custom-feature-configs/{id}
 * @secure
 * @response `200` `(({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId))` Successful Response
 * @response `404` `void` Custom feature config not found: `{id}`
 * @response `422` `HTTPValidationError` Validation Error
*/
	export namespace CustomFeatureConfigUpdate {
		export type RequestParams = {
			/** Id */
			id: string
		}
		export type RequestQuery = {}
		export type RequestBody = CustomFeatureConfigUpdateRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody =
			| ({
					type: 'product_feature'
			  } & ProductFeatureConfigWithId)
			| ({
					type: 'sales_metrics_feature'
			  } & SalesMetricsFeatureConfigWithId)
	}

	/**
	 * No description
	 * @tags custom-feature-config
	 * @name CustomFeatureConfigDelete
	 * @summary Custom-Feature-Config-Delete
	 * @request DELETE:/api/v1/custom-feature-configs/{id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `404` `void` Custom feature config not found: `{id}`
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CustomFeatureConfigDelete {
		export type RequestParams = {
			/** Id */
			id: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags custom-feature-config
	 * @name CustomFeatureConfigBulkDelete
	 * @summary Custom-Feature-Config-Bulk-Delete
	 * @request POST:/api/v1/custom-feature-configs/bulk-delete
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CustomFeatureConfigBulkDelete {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = CustomFeatureConfigBulkDeleteRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace FieldSchema {
	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaList
	 * @summary Field-Schema-List
	 * @request GET:/api/v1/field-schemas
	 * @secure
	 * @response `200` `(FieldSchemaModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaList {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Context
			 * @default []
			 */
			context?: HiddenOnContext[]
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = FieldSchemaModel[]
	}

	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaCreate
	 * @summary Field-Schema-Create
	 * @request POST:/api/v1/field-schemas
	 * @secure
	 * @response `201` `FieldSchemaModel` Successful Response
	 * @response `409` `void` Field schema already exists: `{id}`
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = FieldSchemaModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = FieldSchemaModel
	}

	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaGet
	 * @summary Field-Schema-Get
	 * @request GET:/api/v1/field-schemas/{field_schema_id}
	 * @secure
	 * @response `200` `FieldSchemaModel` Successful Response
	 * @response `404` `void` Field schema not found: `{field_schema_id}`
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaGet {
		export type RequestParams = {
			/** Field Schema Id */
			fieldSchemaId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = FieldSchemaModel
	}

	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaUpdate
	 * @summary Field-Schema-Update
	 * @request PATCH:/api/v1/field-schemas/{field_schema_id}
	 * @secure
	 * @response `200` `FieldSchemaModel` Successful Response
	 * @response `404` `void` Field schema not found: {id}
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaUpdate {
		export type RequestParams = {
			/** Field Schema Id */
			fieldSchemaId: string
		}
		export type RequestQuery = {}
		export type RequestBody = FieldSchemaUpdateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = FieldSchemaModel
	}

	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaDelete
	 * @summary Field-Schema-Delete
	 * @request DELETE:/api/v1/field-schemas/{field_schema_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `404` `void` Field schema not found: `{field_schema_id}`
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaDelete {
		export type RequestParams = {
			/** Field Schema Id */
			fieldSchemaId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaBulkUpdate
	 * @summary Field-Schema-Bulk-Update
	 * @request POST:/api/v1/field-schemas/bulk-update
	 * @secure
	 * @response `200` `(FieldSchemaModel)[]` Successful Response
	 * @response `404` `void` Field schema(s) not found: {ids}
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaBulkUpdate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = FieldSchemaBulkUpdateRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = FieldSchemaModel[]
	}

	/**
	 * No description
	 * @tags field-schema
	 * @name FieldSchemaBulkDelete
	 * @summary Field-Schema-Bulk-Delete
	 * @request POST:/api/v1/field-schemas/bulk-delete
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace FieldSchemaBulkDelete {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = FieldSchemaBulkDeleteRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace PublicSetting {
	/**
	 * No description
	 * @tags public-setting
	 * @name PublicSettingGet
	 * @summary Public-Setting-Get
	 * @request GET:/api/v1/public-settings/{setting_id}
	 * @secure
	 * @response `200` `Setting` Successful Response
	 * @response `404` `void` Setting not found: `{setting_id}`
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace PublicSettingGet {
		export type RequestParams = {
			/** Setting Id */
			settingId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = Setting
	}
}

export namespace Setting {
	/**
	 * No description
	 * @tags setting
	 * @name SettingList
	 * @summary Setting-List
	 * @request GET:/api/v1/setting
	 * @secure
	 * @response `200` `(Setting)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingList {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Type Id */
			type_id?: string | null
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = Setting[]
	}

	/**
	 * No description
	 * @tags setting
	 * @name SettingCreate
	 * @summary Setting-Create
	 * @request POST:/api/v1/setting
	 * @secure
	 * @response `201` `Setting` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingCreateRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = Setting
	}

	/**
	 * No description
	 * @tags setting
	 * @name SettingUpdate
	 * @summary Setting-Update
	 * @request PATCH:/api/v1/setting
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingUpdate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = Setting
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags setting
	 * @name SettingRestore
	 * @summary Setting-Restore
	 * @request PUT:/api/v1/setting
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingRestore {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingRestoreRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags setting
	 * @name SettingDetail
	 * @summary Setting-Detail
	 * @request GET:/api/v1/setting/{setting_id}
	 * @secure
	 * @response `200` `Setting` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingDetail {
		export type RequestParams = {
			/** Setting Id */
			settingId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = Setting
	}

	/**
	 * No description
	 * @tags setting
	 * @name SettingDelete
	 * @summary Setting-Delete
	 * @request DELETE:/api/v1/setting/{setting_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingDelete {
		export type RequestParams = {
			/** Setting Id */
			settingId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}
}

export namespace SettingType {
	/**
	 * No description
	 * @tags setting-type
	 * @name SettingTypeList
	 * @summary Setting-Type-List
	 * @request GET:/api/v1/setting-type
	 * @secure
	 * @response `200` `(SettingType)[]` Successful Response
	 */
	export namespace SettingTypeList {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = SettingType[]
	}

	/**
	 * No description
	 * @tags setting-type
	 * @name SettingTypeRestore
	 * @summary Setting-Type-Restore
	 * @request PUT:/api/v1/setting-type
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingTypeRestore {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingTypeRestoreRequestModel
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags setting-type
	 * @name SettingTypeCreate
	 * @summary Setting-Type-Create
	 * @request POST:/api/v1/setting-type
	 * @secure
	 * @response `201` `SettingType` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingTypeCreate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingType
		export type RequestHeaders = {}
		export type ResponseBody = SettingType
	}

	/**
	 * No description
	 * @tags setting-type
	 * @name SettingTypeUpdate
	 * @summary Setting-Type-Update
	 * @request PATCH:/api/v1/setting-type
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingTypeUpdate {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = SettingType
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags setting-type
	 * @name SettingTypeDetail
	 * @summary Setting-Type-Detail
	 * @request GET:/api/v1/setting-type/{setting_type_id}
	 * @secure
	 * @response `200` `SettingType` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingTypeDetail {
		export type RequestParams = {
			/** Setting Type Id */
			settingTypeId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = SettingType
	}

	/**
	 * No description
	 * @tags setting-type
	 * @name SettingTypeDelete
	 * @summary Setting-Type-Delete
	 * @request DELETE:/api/v1/setting-type/{setting_type_id}
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace SettingTypeDelete {
		export type RequestParams = {
			/** Setting Type Id */
			settingTypeId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}
}

export namespace Api {
	/**
	 * No description
	 * @name GetPreprocessingOld
	 * @summary Get-Preprocessing-Old
	 * @request GET:/api/v1/preprocessing/
	 * @secure
	 * @response `200` `(Preprocessing | EmptyResponse)` Successful Response
	 */
	export namespace GetPreprocessingOld {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = Preprocessing | EmptyResponse
	}

	/**
	 * No description
	 * @name GetPreprocessing
	 * @summary Get-Preprocessing
	 * @request GET:/api/v1/preprocessing
	 * @secure
	 * @response `200` `(Preprocessing | EmptyResponse)` Successful Response
	 */
	export namespace GetPreprocessing {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = Preprocessing | EmptyResponse
	}

	/**
	 * No description
	 * @name ListInterpretation
	 * @summary List Interpretation
	 * @request GET:/api/v1/repricing-interpretation/
	 * @secure
	 * @response `200` `(InterpretationModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ListInterpretation {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Optimization Id
			 * @format uuid
			 */
			optimization_id: string
			/** Optimization Group Id */
			optimization_group_id: string
			/** Line Id */
			line_id: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = InterpretationModel[]
	}

	/**
	 * No description
	 * @name ListInterpretationData
	 * @summary List Interpretation Data
	 * @request GET:/api/v1/repricing-interpretation-data/
	 * @secure
	 * @response `200` `ProductDiffsModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ListInterpretationData {
		export type RequestParams = {}
		export type RequestQuery = {
			/**
			 * Optimization Id
			 * @format uuid
			 */
			optimization_id: string
			/** Optimization Group Id */
			optimization_group_id: string
			/** Line Id */
			line_id: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ProductDiffsModel
	}

	/**
	 * No description
	 * @name Logs
	 * @summary Logs
	 * @request GET:/api/v1/user-activity-logs/
	 * @secure
	 * @response `200` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace Logs {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Timestamp */
			timestamp: string
			/**
			 * User Id
			 * @format uuid
			 */
			user_id?: string
			/** User Id  In */
			user_id__in?: string
			/**
			 * Email
			 * @format email
			 */
			email?: string
			/** Event Type */
			event_type?: string
			/** Event Type  In */
			event_type__in?: string
			/** Product Source */
			product_source?: string
			/**
			 * Format
			 * @default "json"
			 */
			format?: string
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @name EventTypes
	 * @summary Event Types
	 * @request GET:/api/v1/user-activity-logs/event-types/
	 * @secure
	 * @response `200` `any` Successful Response
	 */
	export namespace EventTypes {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = any
	}
}

export namespace Assistant {
	/**
	 * No description
	 * @tags assistant
	 * @name AssistantChatSettingsGet
	 * @summary Assistant-Chat-Settings-Get
	 * @request GET:/api/v1/assistant/chat/settings
	 * @secure
	 * @response `200` `ChatSettingsResponseModel` Successful Response
	 */
	export namespace AssistantChatSettingsGet {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = ChatSettingsResponseModel
	}

	/**
	 * No description
	 * @tags assistant
	 * @name AssistantChatMessagePostBi
	 * @summary Assistant-Chat-Message-Post-Bi
	 * @request POST:/api/v1/assistant/chat/business-intelligence
	 * @secure
	 * @response `200` `ChatMessageResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AssistantChatMessagePostBi {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ChatMessageRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ChatMessageResponseModel
	}

	/**
	 * No description
	 * @tags assistant
	 * @name AssistantChatMessagePostInterpretation
	 * @summary Assistant-Chat-Message-Post-Interpretation
	 * @request POST:/api/v1/assistant/chat/price-interpretation
	 * @secure
	 * @response `200` `ChatMessageResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AssistantChatMessagePostInterpretation {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ChatMessageRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ChatMessageResponseModel
	}

	/**
	 * No description
	 * @tags assistant
	 * @name AssistantChatMessagePostNavigation
	 * @summary Assistant-Chat-Message-Post-Navigation
	 * @request POST:/api/v1/assistant/chat/ai-navigation
	 * @secure
	 * @response `200` `ChatMessageResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AssistantChatMessagePostNavigation {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ChatMessageRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ChatMessageResponseModel
	}

	/**
	 * No description
	 * @tags assistant
	 * @name AssistantChatMessagePostPricingRule
	 * @summary Assistant-Chat-Message-Post-Pricing-Rule
	 * @request POST:/api/v1/assistant/chat/pricing-rule
	 * @secure
	 * @response `200` `ChatMessageResponseModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AssistantChatMessagePostPricingRule {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ChatMessageRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = ChatMessageResponseModel
	}

	/**
	 * No description
	 * @tags assistant
	 * @name AssistantChatReactionPost
	 * @summary Assistant-Chat-Reaction-Post
	 * @request POST:/api/v1/assistant/chat/reaction
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace AssistantChatReactionPost {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = ChatMessageReactionRequestModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
			/** Auth-User-Email */
			'auth-user-email': string
		}
		export type ResponseBody = void
	}
}

export namespace PromoCampaigns {
	/**
	 * No description
	 * @tags promo-campaigns
	 * @name ListPromoCampaigns
	 * @summary List Promo Campaigns
	 * @request GET:/api/v1/promo-campaigns/
	 * @secure
	 * @response `200` `(PromoCampaignModel)[]` Successful Response
	 */
	export namespace ListPromoCampaigns {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PromoCampaignModel[]
	}

	/**
	 * No description
	 * @tags promo-campaigns
	 * @name CreatePromoCampaign
	 * @summary Create Promo Campaign
	 * @request POST:/api/v1/promo-campaigns/
	 * @secure
	 * @response `201` `PromoCampaignModel` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace CreatePromoCampaign {
		export type RequestParams = {}
		export type RequestQuery = {}
		export type RequestBody = PromoCampaignCreateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = PromoCampaignModel
	}

	/**
	 * No description
	 * @tags promo-campaigns
	 * @name GetPromoCampaign
	 * @summary Get Promo Campaign
	 * @request GET:/api/v1/promo-campaigns/{promo_campaign_id}/
	 * @secure
	 * @response `200` `PromoCampaignModel` Successful Response
	 * @response `404` `ErrorModel` Not Found
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace GetPromoCampaign {
		export type RequestParams = {
			/** Promo Campaign Id */
			promoCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PromoCampaignModel
	}

	/**
	 * No description
	 * @tags promo-campaigns
	 * @name UpdatePromoCampaign
	 * @summary Update Promo Campaign
	 * @request PATCH:/api/v1/promo-campaigns/{promo_campaign_id}/
	 * @secure
	 * @response `200` `PromoCampaignModel` Successful Response
	 * @response `403` `ErrorModel` Forbidden
	 * @response `404` `ErrorModel` Not Found
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UpdatePromoCampaign {
		export type RequestParams = {
			/** Promo Campaign Id */
			promoCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = PromoCampaignUpdateModel
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = PromoCampaignModel
	}

	/**
	 * No description
	 * @tags promo-campaigns
	 * @name DeletePromoCampaign
	 * @summary Delete Promo Campaign
	 * @request DELETE:/api/v1/promo-campaigns/{promo_campaign_id}/
	 * @secure
	 * @response `204` `void` Successful Response
	 * @response `403` `ErrorModel` Forbidden
	 * @response `404` `ErrorModel` Not Found
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace DeletePromoCampaign {
		export type RequestParams = {
			/** Promo Campaign Id */
			promoCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = void
	}

	/**
	 * No description
	 * @tags promo-campaigns
	 * @name ListPromoCampaignProducts
	 * @summary List Promo Campaign Products
	 * @request GET:/api/v1/promo-campaigns/{promo_campaign_id}/products/
	 * @secure
	 * @response `200` `(PromoProductModel)[]` Successful Response
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace ListPromoCampaignProducts {
		export type RequestParams = {
			/** Promo Campaign Id */
			promoCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PromoProductModel[]
	}

	/**
	 * No description
	 * @tags promo-campaigns
	 * @name UploadPromoCampaignProducts
	 * @summary Upload Promo Campaign Products
	 * @request POST:/api/v1/promo-campaigns/{promo_campaign_id}/products/
	 * @secure
	 * @response `201` `any` Successful Response
	 * @response `400` `UploadPromoProductsErrorModel` Bad Request
	 * @response `403` `ErrorModel` Forbidden
	 * @response `404` `ErrorModel` Not Found
	 * @response `422` `HTTPValidationError` Validation Error
	 */
	export namespace UploadPromoCampaignProducts {
		export type RequestParams = {
			/** Promo Campaign Id */
			promoCampaignId: string
		}
		export type RequestQuery = {}
		export type RequestBody =
			BodyUploadPromoCampaignProductsApiV1PromoCampaignsPromoCampaignIdProductsPost
		export type RequestHeaders = {
			/** Auth-User-Id */
			'auth-user-id': string
		}
		export type ResponseBody = any
	}
}

export namespace Cd {
	/**
	 * No description
	 * @tags cd
	 * @name ListCompetitiveData
	 * @summary Get competitive data
	 * @request GET:/api/v1/competitive-data/
	 * @secure
	 * @response `200` `CompetitiveDataResponseModel` Successful Response
	 */
	export namespace ListCompetitiveData {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Limit */
			limit: number
			/** optimization_group_id */
			optimization_group_id: string
			/** Line id */
			line_id: string
			/** Sku */
			sku: string
			/** Order by */
			order_by: string
			/** Group by */
			group_by: string[]
			/** Observed on greater than */
			observed_on__gt: string
			/** Fields */
			fields: string[]
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = CompetitiveDataResponseModel
	}

	/**
	 * No description
	 * @tags cd
	 * @name ListPriceHistory
	 * @summary Get price history
	 * @request GET:/api/v1/price-history/
	 * @secure
	 * @response `200` `PriceHistoryResponseModel` Successful Response
	 */
	export namespace ListPriceHistory {
		export type RequestParams = {}
		export type RequestQuery = {
			/** Limit */
			limit: number
			/** optimization_group_id */
			optimization_group_id: string
			/** Line id */
			line_id: string
			/** Sku */
			sku: string
			/** Order by */
			order_by: string
			/** Group by */
			group_by: string[]
			/** Observed on greater than */
			observed_on__gt: string
			/** Fields */
			fields?: string[]
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = PriceHistoryResponseModel
	}

	/**
	 * No description
	 * @tags cd
	 * @name ListCompetitors
	 * @summary Get competitors
	 * @request GET:/api/v1/competitors/
	 * @secure
	 * @response `200` `CompetitorsResponseModel` Successful Response
	 */
	export namespace ListCompetitors {
		export type RequestParams = {}
		export type RequestQuery = {
			/** optimization_group_id */
			optimization_group_id?: string
			/** Order by field */
			order_by?: string
			/** Limit */
			limit: number
		}
		export type RequestBody = never
		export type RequestHeaders = {}
		export type ResponseBody = CompetitorsResponseModel
	}
}

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<
	AxiosRequestConfig,
	'data' | 'params' | 'url' | 'responseType'
> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean
	/** request path */
	path: string
	/** content type of request body */
	type?: ContentType
	/** query params */
	query?: QueryParamsType
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseType
	/** request body */
	body?: unknown
}

export type RequestParams = Omit<
	FullRequestParams,
	'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<
	AxiosRequestConfig,
	'data' | 'cancelToken'
> {
	securityWorker?: (
		securityData: SecurityDataType | null
	) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
	secure?: boolean
	format?: ResponseType
}

export enum ContentType {
	Json = 'application/json',
	JsonApi = 'application/vnd.api+json',
	FormData = 'multipart/form-data',
	UrlEncoded = 'application/x-www-form-urlencoded',
	Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
	public instance: AxiosInstance
	private securityData: SecurityDataType | null = null
	private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
	private secure?: boolean
	private format?: ResponseType

	constructor({
		securityWorker,
		secure,
		format,
		...axiosConfig
	}: ApiConfig<SecurityDataType> = {}) {
		this.instance = axios.create({
			...axiosConfig,
			baseURL: axiosConfig.baseURL || '',
		})
		this.secure = secure
		this.format = format
		this.securityWorker = securityWorker
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data
	}

	protected mergeRequestParams(
		params1: AxiosRequestConfig,
		params2?: AxiosRequestConfig
	): AxiosRequestConfig {
		const method = params1.method || (params2 && params2.method)

		return {
			...this.instance.defaults,
			...params1,
			...(params2 || {}),
			headers: {
				...((method &&
					this.instance.defaults.headers[
						method.toLowerCase() as keyof HeadersDefaults
					]) ||
					{}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		}
	}

	protected stringifyFormItem(formItem: unknown) {
		if (typeof formItem === 'object' && formItem !== null) {
			return JSON.stringify(formItem)
		} else {
			return `${formItem}`
		}
	}

	protected createFormData(input: Record<string, unknown>): FormData {
		if (input instanceof FormData) {
			return input
		}
		return Object.keys(input || {}).reduce((formData, key) => {
			const property = input[key]
			const propertyContent: any[] =
				property instanceof Array ? property : [property]

			for (const formItem of propertyContent) {
				const isFileType = formItem instanceof Blob || formItem instanceof File
				formData.append(
					key,
					isFileType ? formItem : this.stringifyFormItem(formItem)
				)
			}

			return formData
		}, new FormData())
	}

	public request = async <T = any, _E = any>({
		secure,
		path,
		type,
		query,
		format,
		body,
		...params
	}: FullRequestParams): Promise<T> => {
		const secureParams =
			((typeof secure === 'boolean' ? secure : this.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{}
		const requestParams = this.mergeRequestParams(params, secureParams)
		const responseFormat = format || this.format || undefined

		if (
			type === ContentType.FormData &&
			body &&
			body !== null &&
			typeof body === 'object'
		) {
			body = this.createFormData(body as Record<string, unknown>)
		}

		if (
			type === ContentType.Text &&
			body &&
			body !== null &&
			typeof body !== 'string'
		) {
			body = JSON.stringify(body)
		}

		return this.instance
			.request({
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type ? { 'Content-Type': type } : {}),
				},
				params: query,
				responseType: responseFormat,
				data: body,
				url: path,
			})
			.then((response) => response.data)
	}
}

/**
 * @title Competera Pricing Platform API
 * @version 1.0.0
 * @contact Competera Support <support@competera.net>
 *
 *
 * Welcome to the **Competera Pricing Platform API** reference.
 *
 * This page is the interactive reference for the platform's internal HTTP API. It is assembled at
 * request time from the live OpenAPI schema of every platform service, so it always reflects what is
 * actually deployed — there is no second, out-of-date copy to maintain.
 *
 * **How to use this page**
 *
 * * The expandable sections below — **Getting started**, **Authentication**, **Conventions**,
 *   **Examples** and **Troubleshooting** — cover the cross-cutting basics. Start here if the platform
 *   API is new to you.
 * * Further down, every endpoint is listed and grouped by tag. Expand any one to see its parameters,
 *   request and response schemas, and example payloads.
 *
 * <details>
 * <summary><strong>Getting started</strong></summary>
 *
 * Each platform service owns part of the API surface and publishes its own OpenAPI schema. This page
 * merges them into a single document so you can search the whole platform in one place instead of
 * hunting through per-service docs.
 *
 * 1. **Know your base URL.** Everything lives under `https://<client>.competera.net`. The host encodes
 *    the tenant, so a call against one client's host never reaches another's data.
 * 2. **Get a token.** Every endpoint here is authenticated. See **Authentication**.
 * 3. **Find what you need.** Use the search box, or scan the tag groups below.
 * 4. **Read the operation.** Expand an endpoint to see its parameters, request body and responses.
 *    For each body you get an **Example Value** (a ready-to-read sample) and a **Schema** view listing
 *    every field with its type; toggle between them with the **Schema / Example Value** switch.
 *
 * **What this page is not.** It documents the API, not the product. Endpoints appear here because a
 * service publishes them, which is not the same as their being intended for general use — some are
 * admin or internal-maintenance routes. If an endpoint is not already used by the frontend and its
 * purpose is not obvious, ask the owning team before building on it.
 *
 * </details>
 *
 * <details>
 * <summary><strong>Authentication</strong></summary>
 *
 * The platform uses **OIDC via Keycloak**. The browser performs the login redirect; your code then
 * exchanges a refresh cookie for a short-lived **access token** (a JWT) and sends it as a bearer token
 * on every API call.
 *
 * **1. Log in.** Send the browser to `/auth/login`, passing the URL you want to land back on:
 *
 * ```
 * GET /auth/login?redirect_uri=https://<client>.competera.net/auth/callback
 * ```
 *
 * This responds `307` and redirects to Keycloak. After the user signs in, Keycloak redirects back with
 * a `code`, which is handed to:
 *
 * ```
 * GET /auth/auth?code=<code>&redirect_uri=<the same redirect_uri>
 * ```
 *
 * That sets an httpOnly `refresh_token` cookie on the domain.
 *
 * **2. Exchange the cookie for an access token.** The cookie is not sent automatically by a
 * cross-origin `fetch`, so the request must opt in to credentials:
 *
 * ```js
 * const { data } = await axios.post('/auth/refresh-token/', null, { withCredentials: true })
 * // -> { "access_token": "eyJhbGciOi..." }
 * ```
 *
 * **3. Call the API.** Put the access token in the `Authorization` header:
 *
 * ```
 * Authorization: Bearer <access_token>
 * ```
 *
 * **4. Refresh on `401`.** Access tokens are short-lived. When any call returns `401`, call
 * `POST /auth/refresh-token/` again, replace the stored token and retry the original request once.
 * The frontend's axios client already does this centrally, queueing concurrent requests behind a
 * single refresh so a burst of `401`s triggers one refresh rather than many.
 *
 * **5. Log out.** `POST /auth/logout/` clears the refresh cookie and returns `204`.
 *
 * Note the trailing slashes on `/auth/refresh-token/` and `/auth/logout/` — these routes are declared
 * with them, and omitting one costs you a redirect.
 *
 * </details>
 *
 * <details>
 * <summary><strong>Conventions</strong></summary>
 *
 * * Requests and responses are JSON (`Content-Type: application/json`).
 * * Timestamps are ISO-8601, e.g. `2026-06-10T14:30:00Z`.
 * * **Two API versions coexist.** Some resources are served under both `/api/v1/...` and
 *   `/api/v2/...`. They are not aliases — the v2 route is usually the newer shape. Check both before
 *   assuming which one you want.
 * * **Filtering and large queries go in a POST body.** Rather than encoding complex filters into the
 *   query string, many list endpoints expose a companion `POST .../query` route that takes filters,
 *   field selection and ordering as JSON. `POST /api/v1/scenarios/query` and
 *   `POST /api/v1/tickets/query` follow this pattern.
 * * **Paging** uses `limit` and `offset` query parameters; list responses carry a `total` alongside
 *   the page of results.
 * * Trailing slashes are significant — some routes declare them, some do not. Copy the path exactly as
 *   it appears in this document.
 *
 * </details>
 *
 * <details>
 * <summary><strong>Examples</strong></summary>
 *
 * A short end-to-end walkthrough. Replace `<client>` with your tenant host.
 *
 * **1. Get an access token** (assuming you already hold a `refresh_token` cookie from the login
 * redirect):
 *
 * ```bash
 * ACCESS_TOKEN=$(curl -s -X POST "https://<client>.competera.net/auth/refresh-token/" \
 *      --cookie "refresh_token=$REFRESH_TOKEN" | jq -r .access_token)
 * ```
 *
 * **2. A simple `GET`** — list the optimization groups you can see:
 *
 * ```bash
 * curl -H "Authorization: Bearer $ACCESS_TOKEN" \
 *      "https://<client>.competera.net/api/v1/optimization-groups"
 * ```
 *
 * **3. A filtered `POST .../query`** — the pattern most list endpoints use for anything non-trivial:
 *
 * ```bash
 * curl -X POST -H "Authorization: Bearer $ACCESS_TOKEN" \
 *      -H "Content-Type: application/json" \
 *      "https://<client>.competera.net/api/v1/scenarios/query?limit=20&offset=0" \
 *      -d '{}'
 * ```
 *
 * The exact filter grammar, the fields you may order by and the response shape are documented on each
 * operation below — expand the one you are calling rather than guessing from this example.
 *
 * </details>
 *
 * <details>
 * <summary><strong>Troubleshooting</strong></summary>
 *
 * Errors use standard HTTP status codes with a JSON body:
 *
 * ```json
 * { "detail": "Human-readable message" }
 * ```
 *
 * | Status | Meaning | What to do |
 * |--------|---------|------------|
 * | `400` / `422` | Invalid request — bad parameters or body | Read `detail`; for `422` it names the offending field |
 * | `401` | Missing, malformed or expired access token | Refresh the token and retry once — see **Authentication** |
 * | `403` | Authenticated, but your role lacks the permission | Not retryable; check the user's role |
 * | `404` | No such resource, or not visible to this tenant | Check the path, the ids, and that you are on the right host |
 * | `502` | Service rolling or briefly unavailable | Safe to retry with a short backoff; the frontend client already retries these automatically |
 * | `5xx` | Server error | Retry once with backoff; if it persists it is ours, not yours |
 *
 * **If an endpoint is missing from this page,** its service either failed to respond when the page was
 * built or does not publish a schema. Reload; if it is still absent, the owning service is likely down.
 *
 * **If a request body does not match what the endpoint accepts,** note that a handful of schema names
 * collide between services and the merge keeps the first definition it sees. Where this page and a
 * service's own `/docs` disagree, the service's own page wins.
 *
 * </details>
 */
export class Api<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	midTermPrediction = {
		/**
		 * @description Whether the service is enabled for this client and whether the predictions published here are those of the platform's current iteration. is_ready is always false when is_enabled is false.
		 *
		 * @tags mid-term-prediction
		 * @name GetStatus
		 * @summary Get service status
		 * @request GET:/api/v1/mid-term-prediction/status
		 * @secure
		 * @response `200` `StatusModel` Successful Response
		 * @response `400` `Problem` Bad Request
		 * @response `401` `Problem` Unauthorized
		 * @response `404` `Problem` Not Found
		 * @response `422` `Problem` Unprocessable Entity
		 * @response `500` `Problem` Internal Server Error
		 * @response `502` `Problem` Bad Gateway
		 */
		getStatus: (params: RequestParams = {}) =>
			this.request<StatusModel, Problem>({
				path: `/api/v1/mid-term-prediction/status`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Daily sales-quantity history and forecast, the forecastability verdict and the period aggregate. Returns 200 with is_forecastable=false for blocked series.
		 *
		 * @tags mid-term-prediction
		 * @name GetForecast
		 * @summary Get the forecast for a pricing line
		 * @request GET:/api/v1/mid-term-prediction/optimization-groups/{optimization_group_id}/optimizations/{optimization_id}/pricing-lines/{pricing_line_id}/forecast
		 * @secure
		 * @response `200` `ForecastModel` Successful Response
		 * @response `400` `Problem` Bad Request
		 * @response `401` `Problem` Unauthorized
		 * @response `404` `Problem` Not Found
		 * @response `422` `Problem` Unprocessable Entity
		 * @response `500` `Problem` Internal Server Error
		 * @response `502` `Problem` Bad Gateway
		 */
		getForecast: (
			{ optimizationGroupId, optimizationId, pricingLineId }: GetForecastParams,
			params: RequestParams = {}
		) =>
			this.request<ForecastModel, Problem>({
				path: `/api/v1/mid-term-prediction/optimization-groups/${optimizationGroupId}/optimizations/${optimizationId}/pricing-lines/${pricingLineId}/forecast`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Demand-shape and lifecycle facts for the series; either segment is null when no data exists.
		 *
		 * @tags mid-term-prediction, segmentation
		 * @name GetSegmentation
		 * @summary Get the segmentation of a pricing line
		 * @request GET:/api/v1/mid-term-prediction/optimization-groups/{optimization_group_id}/optimizations/{optimization_id}/pricing-lines/{pricing_line_id}/segmentation
		 * @secure
		 * @response `200` `SegmentationModel` Successful Response
		 * @response `400` `Problem` Bad Request
		 * @response `401` `Problem` Unauthorized
		 * @response `404` `Problem` Not Found
		 * @response `422` `Problem` Unprocessable Entity
		 * @response `500` `Problem` Internal Server Error
		 * @response `502` `Problem` Bad Gateway
		 */
		getSegmentation: (
			{
				optimizationGroupId,
				optimizationId,
				pricingLineId,
			}: GetSegmentationParams,
			params: RequestParams = {}
		) =>
			this.request<SegmentationModel, Problem>({
				path: `/api/v1/mid-term-prediction/optimization-groups/${optimizationGroupId}/optimizations/${optimizationId}/pricing-lines/${pricingLineId}/segmentation`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	apps = {
		/**
		 * No description
		 *
		 * @tags Apps
		 * @name GetApps
		 * @summary Get Apps
		 * @request GET:/api/v1/apps/
		 * @secure
		 * @response `200` `(AppModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getApps: (params: RequestParams = {}) =>
			this.request<AppModel[], HTTPValidationError>({
				path: `/api/v1/apps/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Apps
		 * @name ActivateApp
		 * @summary Activate App
		 * @request POST:/api/v1/apps/{app_name}/activate/
		 * @secure
		 * @response `200` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		activateApp: ({ appName }: ActivateAppParams, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/apps/${appName}/activate/`,
				method: 'POST',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Apps
		 * @name DeactivateApp
		 * @summary Deactivate App
		 * @request POST:/api/v1/apps/{app_name}/deactivate/
		 * @secure
		 * @response `200` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deactivateApp: (
			{ appName }: DeactivateAppParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/apps/${appName}/deactivate/`,
				method: 'POST',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Apps
		 * @name GetHelpdeskOrganizationIdHandler
		 * @summary Get Helpdesk Organization Id Handler
		 * @request GET:/api/v1/apps/helpdesk-organization-id/
		 * @secure
		 * @response `200` `(string | null)` Successful Response
		 */
		getHelpdeskOrganizationIdHandler: (params: RequestParams = {}) =>
			this.request<string | null, any>({
				path: `/api/v1/apps/helpdesk-organization-id/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Apps
		 * @name GetMailingDomains
		 * @summary Get Mailing Domains
		 * @request GET:/api/v1/apps/mailing-domains/
		 * @secure
		 * @response `200` `(string)[]` Successful Response
		 */
		getMailingDomains: (params: RequestParams = {}) =>
			this.request<string[], any>({
				path: `/api/v1/apps/mailing-domains/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Apps
		 * @name UpdateMailingDomains
		 * @summary Update Mailing Domains
		 * @request PUT:/api/v1/apps/mailing-domains/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateMailingDomains: (
			data: UpdateMailingDomainsRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/apps/mailing-domains/`,
				method: 'PUT',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	auth = {
		/**
		 * No description
		 *
		 * @tags Auth
		 * @name LoginAuthLoginGet
		 * @summary Login
		 * @request GET:/auth/login/
		 * @secure
		 * @response `307` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		loginAuthLoginGet: (
			query: LoginAuthLoginGetParams,
			params: RequestParams = {}
		) =>
			this.request<any, void | HTTPValidationError>({
				path: `/auth/login/`,
				method: 'GET',
				query: query,
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Auth
		 * @name AuthAuthAuthGet
		 * @summary Auth
		 * @request GET:/auth/auth/
		 * @secure
		 * @response `200` `AccessTokenModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		authAuthAuthGet: (
			query: AuthAuthAuthGetParams,
			params: RequestParams = {}
		) =>
			this.request<AccessTokenModel, HTTPValidationError>({
				path: `/auth/auth/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Auth
		 * @name RefreshTokenHandlerAuthRefreshTokenPost
		 * @summary Refresh Token Handler
		 * @request POST:/auth/refresh-token/
		 * @secure
		 * @response `200` `AccessTokenModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		refreshTokenHandlerAuthRefreshTokenPost: (params: RequestParams = {}) =>
			this.request<AccessTokenModel, HTTPValidationError>({
				path: `/auth/refresh-token/`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Auth
		 * @name LogoutAuthLogoutPost
		 * @summary Logout
		 * @request POST:/auth/logout/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		logoutAuthLogoutPost: (params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/auth/logout/`,
				method: 'POST',
				secure: true,
				...params,
			}),
	}
	permissions = {
		/**
		 * No description
		 *
		 * @tags Permissions
		 * @name GetPermissions
		 * @summary Get Permissions
		 * @request GET:/api/v1/permissions/
		 * @secure
		 * @response `200` `(PermissionModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getPermissions: (
			query: GetPermissionsParams = {},
			params: RequestParams = {}
		) =>
			this.request<PermissionModel[], HTTPValidationError>({
				path: `/api/v1/permissions/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),
	}
	roles = {
		/**
		 * No description
		 *
		 * @tags Roles
		 * @name GetRoles
		 * @summary Get Roles
		 * @request GET:/api/v1/roles/
		 * @secure
		 * @response `200` `(RoleModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getRoles: (params: RequestParams = {}) =>
			this.request<RoleModel[], HTTPValidationError>({
				path: `/api/v1/roles/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Roles
		 * @name CreateRole
		 * @summary Create Role
		 * @request POST:/api/v1/roles/
		 * @secure
		 * @response `201` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createRole: (data: RoleDataModel, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/roles/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Roles
		 * @name GetRole
		 * @summary Get Role
		 * @request GET:/api/v1/roles/{role_id}/
		 * @secure
		 * @response `200` `RoleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getRole: ({ roleId }: GetRoleParams, params: RequestParams = {}) =>
			this.request<RoleModel, HTTPValidationError>({
				path: `/api/v1/roles/${roleId}/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Roles
		 * @name UpdateRole
		 * @summary Update Role
		 * @request PATCH:/api/v1/roles/{role_id}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateRole: (
			{ roleId }: UpdateRoleParams,
			data: RoleUpdateDataModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/roles/${roleId}/`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Roles
		 * @name DeleteRole
		 * @summary Delete Role
		 * @request DELETE:/api/v1/roles/{role_id}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteRole: ({ roleId }: DeleteRoleParams, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/roles/${roleId}/`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	users = {
		/**
		 * No description
		 *
		 * @tags Users
		 * @name GetUsers
		 * @summary Get Users
		 * @request GET:/api/v1/users/
		 * @secure
		 * @response `200` `UsersModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getUsers: (params: RequestParams = {}) =>
			this.request<UsersModel, HTTPValidationError>({
				path: `/api/v1/users/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name CreateUserHandler
		 * @summary Create User Handler
		 * @request POST:/api/v1/users/
		 * @secure
		 * @response `201` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createUserHandler: (data: UserDataModel, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name ExportUsers
		 * @summary Export Users
		 * @request GET:/api/v1/users/export/
		 * @secure
		 * @response `200` `string` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		exportUsers: (params: RequestParams = {}) =>
			this.request<string, HTTPValidationError>({
				path: `/api/v1/users/export/`,
				method: 'GET',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name GetCurrentUser
		 * @summary Get Current User
		 * @request GET:/api/v1/users/current/
		 * @secure
		 * @response `200` `UserModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCurrentUser: (params: RequestParams = {}) =>
			this.request<UserModel, HTTPValidationError>({
				path: `/api/v1/users/current/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name UpdateCurrentUser
		 * @summary Update Current User
		 * @request PATCH:/api/v1/users/current/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateCurrentUser: (
			data: UserProfileDataModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/current/`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name ResetCurrentUserPassword
		 * @summary Reset Current User Password
		 * @request PATCH:/api/v1/users/current/reset-password/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		resetCurrentUserPassword: (params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/current/reset-password/`,
				method: 'PATCH',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name GetCurrentUserPreferences
		 * @summary Get Current User Preferences
		 * @request GET:/api/v1/users/current/preferences/
		 * @secure
		 * @response `200` `any` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCurrentUserPreferences: (params: RequestParams = {}) =>
			this.request<any, HTTPValidationError>({
				path: `/api/v1/users/current/preferences/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name GetCurrentUserPreference
		 * @summary Get Current User Preference
		 * @request GET:/api/v1/users/current/preferences/{preference_type}/
		 * @secure
		 * @response `200` `any` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCurrentUserPreference: (
			{ preferenceType }: GetCurrentUserPreferenceParams,
			params: RequestParams = {}
		) =>
			this.request<any, HTTPValidationError>({
				path: `/api/v1/users/current/preferences/${preferenceType}/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name SetCurrentUserPreference
		 * @summary Set Current User Preference
		 * @request PATCH:/api/v1/users/current/preferences/{preference_type}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		setCurrentUserPreference: (
			{ preferenceType }: SetCurrentUserPreferenceParams,
			data: SetCurrentUserPreferenceRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/current/preferences/${preferenceType}/`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name DeleteCurrentUserPreference
		 * @summary Delete Current User Preference
		 * @request DELETE:/api/v1/users/current/preferences/{preference_type}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteCurrentUserPreference: (
			{ preferenceType }: DeleteCurrentUserPreferenceParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/current/preferences/${preferenceType}/`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name SetCurrentUserPreferences
		 * @summary Set Current User Preferences
		 * @request PATCH:/api/v1/users/current/preferences
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		setCurrentUserPreferences: (
			data: SetCurrentUserPreferencesRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/current/preferences`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name GetUserHandler
		 * @summary Get User Handler
		 * @request GET:/api/v1/users/{user_id}/
		 * @secure
		 * @response `200` `UserModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getUserHandler: (
			{ userId }: GetUserHandlerParams,
			params: RequestParams = {}
		) =>
			this.request<UserModel, HTTPValidationError>({
				path: `/api/v1/users/${userId}/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name UpdateUser
		 * @summary Update User
		 * @request PATCH:/api/v1/users/{user_id}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateUser: (
			{ userId }: UpdateUserParams,
			data: UserDataModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/${userId}/`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name DeleteUser
		 * @summary Delete User
		 * @request DELETE:/api/v1/users/{user_id}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteUser: ({ userId }: DeleteUserParams, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/${userId}/`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Users
		 * @name ResetPassword
		 * @summary Reset Password
		 * @request PATCH:/api/v1/users/{user_id}/reset-password/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		resetPassword: (
			{ userId }: ResetPasswordParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/users/${userId}/reset-password/`,
				method: 'PATCH',
				secure: true,
				...params,
			}),
	}
	bi = {
		/**
		 * No description
		 *
		 * @tags bi
		 * @name ListMetrics
		 * @summary List-Metrics
		 * @request GET:/api/v1/metrics/
		 * @secure
		 * @response `200` `(Metric)[]` Successful Response
		 */
		listMetrics: (params: RequestParams = {}) =>
			this.request<Metric[], any>({
				path: `/api/v1/metrics/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name BiRevision
		 * @summary Bi-Revision
		 * @request GET:/api/v1/bi-revision/
		 * @secure
		 * @response `200` `(BIRevision | null)` Successful Response
		 */
		biRevision: (params: RequestParams = {}) =>
			this.request<BIRevision | null, any>({
				path: `/api/v1/bi-revision/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name BiFields
		 * @summary Bi-Fields
		 * @request GET:/api/v1/bi/fields
		 * @secure
		 * @response `200` `ProductDiffsModel` Successful Response
		 */
		biFields: (params: RequestParams = {}) =>
			this.request<ProductDiffsModel, any>({
				path: `/api/v1/bi/fields`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name BiFieldsValues
		 * @summary Bi-Fields-Values
		 * @request GET:/api/v1/bi/fields/{bi_field}/values
		 * @secure
		 * @response `200` `((string)[] | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		biFieldsValues: (
			{ biField }: BiFieldsValuesParams,
			params: RequestParams = {}
		) =>
			this.request<string[] | null, HTTPValidationError>({
				path: `/api/v1/bi/fields/${biField}/values`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetBi
		 * @summary Get-Bi
		 * @request POST:/api/v1/bi/
		 * @secure
		 * @response `200` `(BIResponse | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getBi: (data: BIRequest, params: RequestParams = {}) =>
			this.request<BIResponse | null, HTTPValidationError>({
				path: `/api/v1/bi/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetCpi
		 * @summary Get-Cpi
		 * @request POST:/api/v1/bi/cpi
		 * @secure
		 * @response `200` `(CPIResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCpi: (data: CPIRequestModel, params: RequestParams = {}) =>
			this.request<CPIResponseModel[], HTTPValidationError>({
				path: `/api/v1/bi/cpi`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetBiRevenue
		 * @summary Get-Bi-Revenue
		 * @request POST:/api/v1/bi-revenue/
		 * @secure
		 * @response `200` `BIRevenueResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getBiRevenue: (data: BIRevenueRequest, params: RequestParams = {}) =>
			this.request<BIRevenueResponse, HTTPValidationError>({
				path: `/api/v1/bi-revenue/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetBiImpact
		 * @summary Get-Bi-Impact
		 * @request POST:/api/v1/bi-impact
		 * @secure
		 * @response `200` `BIImpactResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getBiImpact: (data: BIImpactRequest, params: RequestParams = {}) =>
			this.request<BIImpactResponse, HTTPValidationError>({
				path: `/api/v1/bi-impact`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetBiAi
		 * @summary Get-Bi-Ai
		 * @request POST:/api/v1/bi-ai/
		 * @secure
		 * @response `200` `BIAIResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getBiAi: (data: BIAIRequest, params: RequestParams = {}) =>
			this.request<BIAIResponse, HTTPValidationError>({
				path: `/api/v1/bi-ai/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetOgTreeMapBySalesEntities
		 * @summary Get-Og-Tree-Map-By-Sales-Entities
		 * @request POST:/api/v1/optimization-groups-tree-map/by-sales-entities
		 * @secure
		 * @response `200` `(TreeMapSalesEntityModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOgTreeMapBySalesEntities: (
			data: TreeMapRequestModel,
			params: RequestParams = {}
		) =>
			this.request<TreeMapSalesEntityModel[], HTTPValidationError>({
				path: `/api/v1/optimization-groups-tree-map/by-sales-entities`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetOgTreeMapByProductGroups
		 * @summary Get-Og-Tree-Map-By-Product-Groups
		 * @request POST:/api/v1/optimization-groups-tree-map/by-product-groups
		 * @secure
		 * @response `200` `(TreeMapProductGroupModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOgTreeMapByProductGroups: (
			data: TreeMapRequestModel,
			params: RequestParams = {}
		) =>
			this.request<TreeMapProductGroupModel[], HTTPValidationError>({
				path: `/api/v1/optimization-groups-tree-map/by-product-groups`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetStatistics
		 * @summary Get-Statistics
		 * @request POST:/api/v1/statistics
		 * @secure
		 * @response `200` `StatisticsResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getStatistics: (data: StatisticsRequest, params: RequestParams = {}) =>
			this.request<StatisticsResponse, HTTPValidationError>({
				path: `/api/v1/statistics`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetStatisticsRepricing
		 * @summary Get-Statistics-Repricing
		 * @request POST:/api/v1/statistics/repricing
		 * @secure
		 * @response `200` `(StatisticsRepricingResponse | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getStatisticsRepricing: (
			data: StatisticsRepricingRequest,
			params: RequestParams = {}
		) =>
			this.request<StatisticsRepricingResponse | null, HTTPValidationError>({
				path: `/api/v1/statistics/repricing`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetStatisticsInterpretability
		 * @summary Get-Statistics-Interpretability
		 * @request POST:/api/v1/statistics/interpretability
		 * @secure
		 * @response `200` `(StatisticsInterpretabilityResponse | (StatisticsInterpretabilityGroupedResponseModel)[] | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getStatisticsInterpretability: (
			data: StatisticsInterpretabilityRequest,
			params: RequestParams = {}
		) =>
			this.request<
				| StatisticsInterpretabilityResponse
				| StatisticsInterpretabilityGroupedResponseModel[]
				| null,
				HTTPValidationError
			>({
				path: `/api/v1/statistics/interpretability`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetStatisticsTargetProtectDistribution
		 * @summary Get-Statistics-Target-Protect-Distribution
		 * @request POST:/api/v1/statistics/target-protect-distribution
		 * @secure
		 * @response `200` `((TargetProtectDistributionModel)[] | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getStatisticsTargetProtectDistribution: (
			data: StatisticsTargetProtectDistributionRequest,
			params: RequestParams = {}
		) =>
			this.request<
				TargetProtectDistributionModel[] | null,
				HTTPValidationError
			>({
				path: `/api/v1/statistics/target-protect-distribution`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetStatisticsMultipleInterpretability
		 * @summary Get-Statistics-Multiple-Interpretability
		 * @request POST:/api/v1/statistics/multiple-interpretability
		 * @secure
		 * @response `200` `(StatisticsInterpretabilityResponse)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getStatisticsMultipleInterpretability: (
			data: StatisticsMultipleInterpretabilityRequest,
			params: RequestParams = {}
		) =>
			this.request<StatisticsInterpretabilityResponse[], HTTPValidationError>({
				path: `/api/v1/statistics/multiple-interpretability`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetStatisticsInternalMultipleInterpretability
		 * @summary Get-Statistics-Internal-Multiple-Interpretability
		 * @request GET:/api/v1/statistics-internal/multiple-interpretability
		 * @secure
		 * @response `200` `(StatisticsInterpretabilityResponse)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getStatisticsInternalMultipleInterpretability: (
			query: GetStatisticsInternalMultipleInterpretabilityParams,
			params: RequestParams = {}
		) =>
			this.request<StatisticsInterpretabilityResponse[], HTTPValidationError>({
				path: `/api/v1/statistics-internal/multiple-interpretability`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetOptimizationsStatistics
		 * @summary Get-Optimizations-Statistics
		 * @request POST:/api/v1/statistics/optimizations-statistics
		 * @secure
		 * @response `200` `(OptimizationStatisticModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOptimizationsStatistics: (
			data: StatisticsOptimizationStatisticsRequest,
			params: RequestParams = {}
		) =>
			this.request<OptimizationStatisticModel[], HTTPValidationError>({
				path: `/api/v1/statistics/optimizations-statistics`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetAlertsInfo
		 * @summary Get-Alerts-Info
		 * @request POST:/api/v1/statistics/alerts-info
		 * @secure
		 * @response `200` `AlertsInfoResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getAlertsInfo: (data: AlertInfoRequestModel, params: RequestParams = {}) =>
			this.request<AlertsInfoResponseModel, HTTPValidationError>({
				path: `/api/v1/statistics/alerts-info`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetOptimizationPredictMetrics
		 * @summary Get-Optimization-Predict-Metrics
		 * @request GET:/api/v1/statistics-internal/optimization-metrics
		 * @secure
		 * @response `200` `(PredictMetricModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOptimizationPredictMetrics: (
			query: GetOptimizationPredictMetricsParams,
			params: RequestParams = {}
		) =>
			this.request<PredictMetricModel[], HTTPValidationError>({
				path: `/api/v1/statistics-internal/optimization-metrics`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetOptimizationPrices
		 * @summary Get-Optimization-Prices
		 * @request GET:/api/v1/statistics-internal/optimization-prices
		 * @secure
		 * @response `200` `(OptimizationPricesModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOptimizationPrices: (
			query: GetOptimizationPricesParams,
			params: RequestParams = {}
		) =>
			this.request<OptimizationPricesModel[], HTTPValidationError>({
				path: `/api/v1/statistics-internal/optimization-prices`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name InternalGetAlertsInfo
		 * @summary Internal-Get-Alerts-Info
		 * @request GET:/api/v1/statistics-internal/alerts-info
		 * @secure
		 * @response `200` `(MultipleAlertInfoModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		internalGetAlertsInfo: (
			query: InternalGetAlertsInfoParams,
			params: RequestParams = {}
		) =>
			this.request<MultipleAlertInfoModel[], HTTPValidationError>({
				path: `/api/v1/statistics-internal/alerts-info`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name InternalPricingLineSearch
		 * @summary Internal-Pricing-Line-Search
		 * @request POST:/api/v1/statistics-internal/pricing-line-search
		 * @secure
		 * @response `200` `PricingLineSearchResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		internalPricingLineSearch: (
			data: PricingLineSearchRequest,
			params: RequestParams = {}
		) =>
			this.request<PricingLineSearchResponse, HTTPValidationError>({
				path: `/api/v1/statistics-internal/pricing-line-search`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetProductsCountByEngine
		 * @summary Get counts of products grouped by engine of pricing campaign.
		 * @request POST:/api/v1/statistics/count-by-engine
		 * @secure
		 * @response `200` `(ProductsByEngineModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getProductsCountByEngine: (
			data: ProductsByEntityRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ProductsByEngineModel[], HTTPValidationError>({
				path: `/api/v1/statistics/count-by-engine`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetProductsCountByOptimizationStatus
		 * @summary Get counts of products grouped by status of optimization.
		 * @request POST:/api/v1/statistics/count-by-optimization-status
		 * @secure
		 * @response `200` `(ProductsByOptimizationStatusModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getProductsCountByOptimizationStatus: (
			data: ProductsByEntityRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ProductsByOptimizationStatusModel[], HTTPValidationError>({
				path: `/api/v1/statistics/count-by-optimization-status`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetRepricingMetrics
		 * @summary Get current pricing metrics that don't fit other formats (average price change).
		 * @request POST:/api/v1/statistics/repricing-metrics
		 * @secure
		 * @response `200` `(RepricingMetricsModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getRepricingMetrics: (
			data: RepricingMetricsRequestModel,
			params: RequestParams = {}
		) =>
			this.request<RepricingMetricsModel[], HTTPValidationError>({
				path: `/api/v1/statistics/repricing-metrics`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags bi
		 * @name GetMultipleAlertsInfo
		 * @summary Get-Multiple-Alerts-Info
		 * @request POST:/api/v1/statistics/multiple-alerts-info
		 * @secure
		 * @response `200` `MultipleAlertsInfoResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getMultipleAlertsInfo: (
			data: MultipleAlertInfoRequestModel,
			params: RequestParams = {}
		) =>
			this.request<MultipleAlertsInfoResponseModel, HTTPValidationError>({
				path: `/api/v1/statistics/multiple-alerts-info`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	matchedProducts = {
		/**
		 * No description
		 *
		 * @tags matched-products
		 * @name MatchedProducts
		 * @summary Matched-Products
		 * @request POST:/api/v1/matched-products/
		 * @secure
		 * @response `200` `MatchedProductsResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		matchedProducts: (
			query: MatchedProductsParams = {},
			data: MatchedProductsRequest,
			params: RequestParams = {}
		) =>
			this.request<MatchedProductsResponse, HTTPValidationError>({
				path: `/api/v1/matched-products/`,
				method: 'POST',
				query: query,
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	billing = {
		/**
		 * No description
		 *
		 * @tags Billing
		 * @name UserCampaigns
		 * @summary User Campaigns
		 * @request GET:/api/v1/billing/user-campaigns/
		 * @secure
		 * @response `200` `(CampaignModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		userCampaigns: (params: RequestParams = {}) =>
			this.request<CampaignModel[], HTTPValidationError>({
				path: `/api/v1/billing/user-campaigns/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Billing
		 * @name UsageStatistics
		 * @summary Usage Statistics
		 * @request POST:/api/v1/billing/usage-statistics/
		 * @secure
		 * @response `200` `(UsageStatisticsModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		usageStatistics: (
			data: UsageStatisticsRequestModel,
			params: RequestParams = {}
		) =>
			this.request<UsageStatisticsModel[], HTTPValidationError>({
				path: `/api/v1/billing/usage-statistics/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	tickets = {
		/**
		 * No description
		 *
		 * @tags Tickets
		 * @name GetTicketTypes
		 * @summary Get Ticket Types
		 * @request GET:/api/v1/tickets-types
		 * @secure
		 * @response `200` `any` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getTicketTypes: (query: GetTicketTypesParams, params: RequestParams = {}) =>
			this.request<any, HTTPValidationError>({
				path: `/api/v1/tickets-types`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Tickets
		 * @name QueryTickets
		 * @summary Query Tickets
		 * @request POST:/api/v1/tickets/query
		 * @secure
		 * @response `200` `any` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		queryTickets: (data: TicketQueryRequest, params: RequestParams = {}) =>
			this.request<any, HTTPValidationError>({
				path: `/api/v1/tickets/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Tickets
		 * @name CreateTicket
		 * @summary Create Ticket
		 * @request POST:/api/v1/tickets
		 * @secure
		 * @response `200` `any` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createTicket: (
			data: BodyCreateTicketApiV1TicketsPost,
			params: RequestParams = {}
		) =>
			this.request<any, HTTPValidationError>({
				path: `/api/v1/tickets`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),
	}
	video = {
		/**
		 * No description
		 *
		 * @tags Video
		 * @name VideosList
		 * @summary Videos-List
		 * @request GET:/api/v1/videos
		 * @secure
		 * @response `200` `(VideoModel)[]` Successful Response
		 */
		videosList: (params: RequestParams = {}) =>
			this.request<VideoModel[], any>({
				path: `/api/v1/videos`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	globalPcSet = {
		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetList
		 * @summary List global PC sets
		 * @request GET:/api/v1/global-pc-sets
		 * @secure
		 * @response `200` `(GlobalPCSetModel)[]` Successful Response
		 */
		globalPcSetList: (params: RequestParams = {}) =>
			this.request<GlobalPCSetModel[], any>({
				path: `/api/v1/global-pc-sets`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetCreate
		 * @summary Create global PC set
		 * @request POST:/api/v1/global-pc-sets
		 * @secure
		 * @response `201` `GlobalPCSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		globalPcSetCreate: (
			data: GlobalPCSetCreateDataModel,
			params: RequestParams = {}
		) =>
			this.request<GlobalPCSetModel, HTTPValidationError>({
				path: `/api/v1/global-pc-sets`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetGet
		 * @summary Get global PC set
		 * @request GET:/api/v1/global-pc-sets/{global_pc_set_id}
		 * @secure
		 * @response `200` `GlobalPCSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		globalPcSetGet: (
			{ globalPcSetId }: GlobalPcSetGetParams,
			params: RequestParams = {}
		) =>
			this.request<GlobalPCSetModel, HTTPValidationError>({
				path: `/api/v1/global-pc-sets/${globalPcSetId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetUpdate
		 * @summary Update global PC set
		 * @request PATCH:/api/v1/global-pc-sets/{global_pc_set_id}
		 * @secure
		 * @response `200` `GlobalPCSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		globalPcSetUpdate: (
			{ globalPcSetId }: GlobalPcSetUpdateParams,
			data: GlobalPCSetUpdateDataModel,
			params: RequestParams = {}
		) =>
			this.request<GlobalPCSetModel, HTTPValidationError>({
				path: `/api/v1/global-pc-sets/${globalPcSetId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetDelete
		 * @summary Delete global PC set
		 * @request DELETE:/api/v1/global-pc-sets/{global_pc_set_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		globalPcSetDelete: (
			{ globalPcSetId }: GlobalPcSetDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/global-pc-sets/${globalPcSetId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetDuplicate
		 * @summary Duplicate global PC set
		 * @request POST:/api/v1/global-pc-sets/{global_pc_set_id}/duplicate
		 * @secure
		 * @response `200` `GlobalPCSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		globalPcSetDuplicate: (
			{ globalPcSetId }: GlobalPcSetDuplicateParams,
			params: RequestParams = {}
		) =>
			this.request<GlobalPCSetModel, HTTPValidationError>({
				path: `/api/v1/global-pc-sets/${globalPcSetId}/duplicate`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags global-pc-set
		 * @name GlobalPcSetSetMain
		 * @summary Set main global PC set
		 * @request POST:/api/v1/global-pc-sets/{global_pc_set_id}/set-main
		 * @secure
		 * @response `200` `GlobalPCSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		globalPcSetSetMain: (
			{ globalPcSetId }: GlobalPcSetSetMainParams,
			params: RequestParams = {}
		) =>
			this.request<GlobalPCSetModel, HTTPValidationError>({
				path: `/api/v1/global-pc-sets/${globalPcSetId}/set-main`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	pricingCampaign = {
		/**
		 * @description List pricing campaign resources
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignList
		 * @summary List pricing campaigns
		 * @request GET:/api/v1/pricing-campaigns
		 * @secure
		 * @response `200` `(PricingCampaignModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignList: (
			query: PricingCampaignListParams = {},
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Create pricing campaign resource. Combination of name and scenario_id must be unique. If `filter` is specified, products for that filter are added to the newlycreated global PC, but not local PC. They need to be added to local PC with `assign_product` separately.
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignCreate
		 * @summary Create pricing campaign
		 * @request POST:/api/v1/pricing-campaigns
		 * @secure
		 * @response `201` `PricingCampaignModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignCreate: (
			data: PricingCampaignCreateDataModel,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Lightweight list of pricing campaign resources without full settings
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignOverviewList
		 * @summary List pricing campaigns (overview)
		 * @request GET:/api/v1/pricing-campaigns/overview
		 * @secure
		 * @response `200` `(PricingCampaignOverviewModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignOverviewList: (
			query: PricingCampaignOverviewListParams = {},
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignOverviewModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/overview`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get pricing campaign resource
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignGet
		 * @summary Get pricing campaign
		 * @request GET:/api/v1/pricing-campaigns/{pricing_campaign_id}
		 * @secure
		 * @response `200` `PricingCampaignModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignGet: (
			{ pricingCampaignId }: PricingCampaignGetParams,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/${pricingCampaignId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Update pricing campaign resource.
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignUpdate
		 * @summary Update pricing campaign
		 * @request PATCH:/api/v1/pricing-campaigns/{pricing_campaign_id}
		 * @secure
		 * @response `200` `PricingCampaignModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignUpdate: (
			{ pricingCampaignId }: PricingCampaignUpdateParams,
			data: PricingCampaignUpdateDataModel,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/${pricingCampaignId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Delete pricing campaign resource
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignDelete
		 * @summary Delete pricing campaign
		 * @request DELETE:/api/v1/pricing-campaigns/{pricing_campaign_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignDelete: (
			{ pricingCampaignId }: PricingCampaignDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/pricing-campaigns/${pricingCampaignId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * @description Assign products to pricing campaign by filters. Products that were assigned previously, remain assigned. The pricing campaign can be global or local, but not dynamic.
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignAssignProducts
		 * @summary Assign products to pricing campaign by filters
		 * @request PATCH:/api/v1/pricing-campaigns/{pricing_campaign_id}/assign-products
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignAssignProducts: (
			{ pricingCampaignId }: PricingCampaignAssignProductsParams,
			data: PricingCampaignProductsFilters,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/pricing-campaigns/${pricingCampaignId}/assign-products`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Unassign products from pricing campaigns by filters. Products that meet the filter criteria are unassigned from pricing campaigns in optimization groups to which the user has access.
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignUnassignProducts
		 * @summary Unassign products from pricing campaigns by filters
		 * @request PATCH:/api/v1/pricing-campaigns/unassign-products
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignUnassignProducts: (
			data: PricingCampaignProductsFilters,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/pricing-campaigns/unassign-products`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Delete multiple pricing campaigns
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignBulkDelete
		 * @summary Bulk delete pricing campaign
		 * @request POST:/api/v1/pricing-campaigns/bulk-delete
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignBulkDelete: (
			data: PricingCampaignBulkDeleteRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/pricing-campaigns/bulk-delete`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Reorder pricing campaign resources
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignReorder
		 * @summary Reorder pricing campaigns
		 * @request POST:/api/v1/pricing-campaigns/reorder
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignReorder: (
			data: PricingCampaignReorderRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/pricing-campaigns/reorder`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignMatchedProductsReorder
		 * @summary Estimate products distribution after pricing campaigns reordering
		 * @request POST:/api/v1/pricing-campaigns/matched-products-reorder
		 * @secure
		 * @response `200` `(PricingCampaignMatchedProductsCountResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignMatchedProductsReorder: (
			data: PricingCampaignProductCountReorderRequestModel,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignMatchedProductsCountResponseModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/matched-products-reorder`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignMatchedProducts
		 * @summary Estimate products distribution after updating pricing campaign
		 * @request POST:/api/v1/pricing-campaigns/matched-products
		 * @secure
		 * @response `200` `PricingCampaignMatchedProductsCountResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignMatchedProducts: (
			data: PricingCampaignProductCountRequestModel,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignMatchedProductsCountResponseModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/matched-products`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Duplicate pricing campaign resources
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignsDuplicate
		 * @summary Duplicate pricing campaigns
		 * @request POST:/api/v1/pricing-campaigns/duplicate
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignsDuplicate: (
			data: PricingCampaignDuplicateRequest,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/pricing-campaigns/duplicate`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Reassign pricing campaign resources
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignsReassign
		 * @summary Reassign pricing campaigns
		 * @request POST:/api/v1/pricing-campaigns/reassign
		 * @secure
		 * @response `200` `(PricingCampaignReassignResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignsReassign: (
			data: PricingCampaignReassignRequest,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignReassignResponseModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/reassign`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Export all pricing campaign settings of the user optimization groups to an xlsx file and return a signed download URL
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignSettingsExport
		 * @summary Export pricing campaign settings
		 * @request POST:/api/v1/pricing-campaigns/settings-export
		 * @secure
		 * @response `200` `PricingCampaignSettingsExportResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignSettingsExport: (params: RequestParams = {}) =>
			this.request<
				PricingCampaignSettingsExportResponseModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/settings-export`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Copy settings pricing campaign resources
		 *
		 * @tags pricing-campaign
		 * @name PricingCampaignsCopySettings
		 * @summary Copy settings pricing campaigns
		 * @request POST:/api/v1/pricing-campaigns/copy-settings
		 * @secure
		 * @response `200` `(PricingCampaignCopySettingsResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		pricingCampaignsCopySettings: (
			data: PricingCampaignCopySettingsRequestModel,
			params: RequestParams = {}
		) =>
			this.request<
				PricingCampaignCopySettingsResponseModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/pricing-campaigns/copy-settings`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	pricingRule = {
		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleCatalog
		 * @summary Unified catalog of all pricing rules (system + user)
		 * @request GET:/api/v1/pricing-rules/catalog
		 * @secure
		 * @response `200` `CatalogResponseModel` Successful Response
		 */
		pricingRuleCatalog: (params: RequestParams = {}) =>
			this.request<CatalogResponseModel, any>({
				path: `/api/v1/pricing-rules/catalog`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleList
		 * @summary List pricing rules
		 * @request GET:/api/v1/pricing-rules
		 * @secure
		 * @response `200` `PricingRuleListResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleList: (
			query: PricingRuleListParams = {},
			params: RequestParams = {}
		) =>
			this.request<PricingRuleListResponseModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleCreate
		 * @summary Create pricing rule
		 * @request POST:/api/v1/pricing-rules
		 * @secure
		 * @response `201` `PricingRuleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleCreate: (
			data: PricingRuleCreateModel,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleGet
		 * @summary Get pricing rule
		 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}
		 * @secure
		 * @response `200` `PricingRuleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleGet: (
			{ pricingRuleId }: PricingRuleGetParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleUpdate
		 * @summary Update pricing rule
		 * @request PATCH:/api/v1/pricing-rules/{pricing_rule_id}
		 * @secure
		 * @response `200` `PricingRuleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleUpdate: (
			{ pricingRuleId }: PricingRuleUpdateParams,
			data: PricingRuleUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleDelete
		 * @summary Archive pricing rule
		 * @request DELETE:/api/v1/pricing-rules/{pricing_rule_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleDelete: (
			{ pricingRuleId }: PricingRuleDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleDraftGet
		 * @summary Get pricing rule draft
		 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/draft
		 * @secure
		 * @response `200` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleDraftGet: (
			{ pricingRuleId }: PricingRuleDraftGetParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/draft`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleDraftSave
		 * @summary Save pricing rule draft
		 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/draft
		 * @secure
		 * @response `200` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleDraftSave: (
			{ pricingRuleId }: PricingRuleDraftSaveParams,
			data: PricingRuleDraftSaveModel,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/draft`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleDraftExport
		 * @summary Export pricing rule draft body
		 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/draft/export
		 * @secure
		 * @response `200` `PricingRuleBodyModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleDraftExport: (
			{ pricingRuleId }: PricingRuleDraftExportParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleBodyModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/draft/export`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleDraftImport
		 * @summary Import a JSON file into pricing rule draft
		 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/draft/import
		 * @secure
		 * @response `200` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleDraftImport: (
			{ pricingRuleId }: PricingRuleDraftImportParams,
			data: PricingRuleImportForm,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/draft/import`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRulePublish
		 * @summary Publish pricing rule draft
		 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/versions
		 * @secure
		 * @response `201` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRulePublish: (
			{ pricingRuleId }: PricingRulePublishParams,
			data: PricingRulePublishModel,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/versions`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleVersionsList
		 * @summary List pricing rule published versions
		 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/versions
		 * @secure
		 * @response `200` `PricingRuleVersionListResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleVersionsList: (
			{ pricingRuleId, ...query }: PricingRuleVersionsListParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionListResponseModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/versions`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleVersionGet
		 * @summary Get pricing rule version
		 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}
		 * @secure
		 * @response `200` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleVersionGet: (
			{ pricingRuleVersionId, pricingRuleId }: PricingRuleVersionGetParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/versions/${pricingRuleVersionId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleVersionUpdate
		 * @summary Update pricing rule version metadata
		 * @request PATCH:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}
		 * @secure
		 * @response `200` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleVersionUpdate: (
			{ pricingRuleVersionId, pricingRuleId }: PricingRuleVersionUpdateParams,
			data: PricingRuleVersionUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/versions/${pricingRuleVersionId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleVersionExport
		 * @summary Export pricing rule version body
		 * @request GET:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}/export
		 * @secure
		 * @response `200` `PricingRuleBodyModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleVersionExport: (
			{ pricingRuleVersionId, pricingRuleId }: PricingRuleVersionExportParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleBodyModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/versions/${pricingRuleVersionId}/export`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags pricing-rule
		 * @name PricingRuleVersionRestore
		 * @summary Restore a published version into the draft
		 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/versions/{pricing_rule_version_id}/restore
		 * @secure
		 * @response `200` `PricingRuleVersionModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		pricingRuleVersionRestore: (
			{ pricingRuleId, pricingRuleVersionId }: PricingRuleVersionRestoreParams,
			params: RequestParams = {}
		) =>
			this.request<PricingRuleVersionModel, HTTPValidationError>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/versions/${pricingRuleVersionId}/restore`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
 * @description The latest published version becomes both the draft and the first published version of a new rule. Intermediate version history is not copied.
 *
 * @tags pricing-rule
 * @name PricingRuleDuplicate
 * @summary Duplicate a pricing rule from its latest published version
 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/duplicate
 * @secure
 * @response `201` `PricingRuleModel` Successful Response
 * @response `409` `(({
"code": "RULE_004"
} & PricingRuleArchivedErrorResponse) | ({
"code": "RULE_005"
} & PricingRuleNotPublishedErrorResponse))` The pricing rule is archived or has no published version
 * @response `422` `HTTPValidationError` Validation Error
 */
		pricingRuleDuplicate: (
			{ pricingRuleId }: PricingRuleDuplicateParams,
			params: RequestParams = {}
		) =>
			this.request<
				PricingRuleModel,
				| (
						| ({
								code: 'RULE_004'
						  } & PricingRuleArchivedErrorResponse)
						| ({
								code: 'RULE_005'
						  } & PricingRuleNotPublishedErrorResponse)
				  )
				| HTTPValidationError
			>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/duplicate`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
 * @description Assigns the pricing rule to the given pricing campaigns, carrying over the parameters they already have. Parameters are matched by id and type; what has no match falls back to the parameter default. Only the latest published version can be applied. The operation is transactional — if one pricing campaign fails, nothing is applied. `force_update` cleans up settings that cannot be preserved instead of failing.
 *
 * @tags pricing-rule
 * @name PricingRuleApply
 * @summary Apply the latest published version into pricing campaigns
 * @request POST:/api/v1/pricing-rules/{pricing_rule_id}/apply
 * @secure
 * @response `204` `void` Successful Response
 * @response `400` `PricingRuleApplyErrorResponse` Parameters that could not be preserved
 * @response `409` `(({
"code": "RULE_004"
} & PricingRuleArchivedErrorResponse) | ({
"code": "RULE_005"
} & PricingRuleNotPublishedErrorResponse))` The pricing rule is archived or has no published version
 * @response `422` `HTTPValidationError` Validation Error
 * @response `424` `FailedPendingResponse` Failure while updating optimization status
 */
		pricingRuleApply: (
			{ pricingRuleId }: PricingRuleApplyParams,
			data: PricingRuleApplyModel,
			params: RequestParams = {}
		) =>
			this.request<
				void,
				| PricingRuleApplyErrorResponse
				| (
						| ({
								code: 'RULE_004'
						  } & PricingRuleArchivedErrorResponse)
						| ({
								code: 'RULE_005'
						  } & PricingRuleNotPublishedErrorResponse)
				  )
				| HTTPValidationError
				| FailedPendingResponse
			>({
				path: `/api/v1/pricing-rules/${pricingRuleId}/apply`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	scenarioRunSets = {
		/**
		 * No description
		 *
		 * @tags scenario-run-sets
		 * @name ListScenarioRunSets
		 * @summary List-Scenario-Run-Sets
		 * @request POST:/api/v1/scenario-run-sets/query
		 * @secure
		 * @response `200` `QueryScenarioRunSetResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		listScenarioRunSets: (
			data: QueryScenarioRunSetRequestModel,
			params: RequestParams = {}
		) =>
			this.request<QueryScenarioRunSetResponseModel, HTTPValidationError>({
				path: `/api/v1/scenario-run-sets/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags scenario-run-sets
		 * @name GetScenarioRunSet
		 * @summary Get-Scenario-Run-Set
		 * @request GET:/api/v1/scenario-run-sets/{scenario_run_set_id}
		 * @secure
		 * @response `200` `ScenarioRunSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getScenarioRunSet: (
			{ scenarioRunSetId }: GetScenarioRunSetParams,
			params: RequestParams = {}
		) =>
			this.request<ScenarioRunSetModel, HTTPValidationError>({
				path: `/api/v1/scenario-run-sets/${scenarioRunSetId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags scenario-run-sets
		 * @name DeleteScenarioRunSet
		 * @summary Delete-Scenario-Run-Set
		 * @request DELETE:/api/v1/scenario-run-sets/{scenario_run_set_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteScenarioRunSet: (
			{ scenarioRunSetId }: DeleteScenarioRunSetParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/scenario-run-sets/${scenarioRunSetId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags scenario-run-sets
		 * @name CreateScenarioRunSet
		 * @summary Create-Scenario-Run-Set
		 * @request POST:/api/v1/scenario-run-sets
		 * @secure
		 * @response `201` `ScenarioRunSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createScenarioRunSet: (
			data: ScenarioRunSetCreateModel,
			params: RequestParams = {}
		) =>
			this.request<ScenarioRunSetModel, HTTPValidationError>({
				path: `/api/v1/scenario-run-sets`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags scenario-run-sets
		 * @name RestartScenarioRunSet
		 * @summary Restart-Scenario-Run-Set
		 * @request POST:/api/v1/scenario-run-sets/restart
		 * @secure
		 * @response `200` `ScenarioRunSetModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		restartScenarioRunSet: (
			data: ScenarioRunSetRestartModel,
			params: RequestParams = {}
		) =>
			this.request<ScenarioRunSetModel, HTTPValidationError>({
				path: `/api/v1/scenario-run-sets/restart`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags scenario-run-sets
		 * @name DeleteScenarioRun
		 * @summary Delete-Scenario-Run
		 * @request DELETE:/api/v1/scenario-run-sets/{scenario_run_set_id}/runs/{scenario_run_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteScenarioRun: (
			{ scenarioRunSetId, scenarioRunId }: DeleteScenarioRunParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/scenario-run-sets/${scenarioRunSetId}/runs/${scenarioRunId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	scenario = {
		/**
		 * @description List scenario resources
		 *
		 * @tags scenario
		 * @name ScenariosQueryList
		 * @summary List scenarios
		 * @request POST:/api/v1/scenarios/query
		 * @secure
		 * @response `200` `(ScenarioModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenariosQueryList: (
			data: ScenarioQueryModel,
			params: RequestParams = {}
		) =>
			this.request<
				ScenarioModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/scenarios/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description List scenario resources
		 *
		 * @tags scenario
		 * @name ScenariosList
		 * @summary List scenarios
		 * @request GET:/api/v1/scenarios
		 * @secure
		 * @response `200` `(ScenarioModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenariosList: (
			query: ScenariosListParams = {},
			params: RequestParams = {}
		) =>
			this.request<
				ScenarioModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/scenarios`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Create scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioCreate
		 * @summary Create scenario
		 * @request POST:/api/v1/scenarios
		 * @secure
		 * @response `201` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioCreate: (
			data: ScenarioCreateDataModel,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioGet
		 * @summary Get scenario
		 * @request GET:/api/v1/scenarios/{scenario_id}
		 * @secure
		 * @response `200` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioGet: (
			{ scenarioId }: ScenarioGetParams,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/${scenarioId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Update scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioUpdate
		 * @summary Update scenario
		 * @request PATCH:/api/v1/scenarios/{scenario_id}
		 * @secure
		 * @response `200` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioUpdate: (
			{ scenarioId }: ScenarioUpdateParams,
			data: ScenarioUpdateDataModel,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/${scenarioId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get main scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioGetMain
		 * @summary Get main scenario
		 * @request GET:/api/v1/scenarios/main/{optimization_group_id}
		 * @secure
		 * @response `200` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioGetMain: (
			{ optimizationGroupId }: ScenarioGetMainParams,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/main/${optimizationGroupId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Update main scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioUpdateMain
		 * @summary Update main scenario
		 * @request PATCH:/api/v1/scenarios/main/{optimization_group_id}
		 * @secure
		 * @response `200` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioUpdateMain: (
			{ optimizationGroupId }: ScenarioUpdateMainParams,
			data: ScenarioUpdateDataModel,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/main/${optimizationGroupId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Delete scenario resources
		 *
		 * @tags scenario
		 * @name DeleteScenariosBulk
		 * @summary Delete scenarios
		 * @request POST:/api/v1/scenarios/delete
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		deleteScenariosBulk: (
			data: DeleteScenariosBulkRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/delete`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags scenario
		 * @name ScenarioMatchedProducts
		 * @summary Get scenario stop-list matched products estimate
		 * @request POST:/api/v1/scenarios/{scenario_id}/stop-list-matched-products
		 * @secure
		 * @response `200` `ScenarioMatchedProductsCountResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioMatchedProducts: (
			{ scenarioId }: ScenarioMatchedProductsParams,
			data: ScenarioUpdateDataModel,
			params: RequestParams = {}
		) =>
			this.request<
				ScenarioMatchedProductsCountResponseModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/scenarios/${scenarioId}/stop-list-matched-products`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Duplicate scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioDuplicate
		 * @summary Duplicate scenario
		 * @request POST:/api/v1/scenarios/{scenario_id}/duplicate
		 * @secure
		 * @response `200` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioDuplicate: (
			{ scenarioId }: ScenarioDuplicateParams,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/${scenarioId}/duplicate`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Set main scenario resource
		 *
		 * @tags scenario
		 * @name ScenarioSetMain
		 * @summary Set main scenario
		 * @request POST:/api/v1/scenarios/{scenario_id}/set-main
		 * @secure
		 * @response `200` `ScenarioModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioSetMain: (
			{ scenarioId }: ScenarioSetMainParams,
			data: ScenarioSetMainDataModel,
			params: RequestParams = {}
		) =>
			this.request<ScenarioModel, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/scenarios/${scenarioId}/set-main`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Main scenario copy settings resource
		 *
		 * @tags scenario
		 * @name ScenarioMainCopySettings
		 * @summary Main scenario copy settings
		 * @request POST:/api/v1/scenarios/main/{optimization_group_id}/copy-settings
		 * @secure
		 * @response `200` `(ScenarioMainCopySettingsResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		scenarioMainCopySettings: (
			{ optimizationGroupId }: ScenarioMainCopySettingsParams,
			data: ScenarioMainCopySettings,
			params: RequestParams = {}
		) =>
			this.request<
				ScenarioMainCopySettingsResponseModel[],
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/scenarios/main/${optimizationGroupId}/copy-settings`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	settingsInterpretation = {
		/**
		 * @description Get price limits interpretation
		 *
		 * @tags settings-interpretation
		 * @name PriceLimits
		 * @summary Get price limits interpretation
		 * @request POST:/api/v1/settings-interpretation/price-limits
		 * @secure
		 * @response `200` `SettingsInterpretationResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		priceLimits: (data: PriceLimitsRequestModel, params: RequestParams = {}) =>
			this.request<SettingsInterpretationResponseModel, HTTPValidationError>({
				path: `/api/v1/settings-interpretation/price-limits`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get rounding interpretation
		 *
		 * @tags settings-interpretation
		 * @name Rounding
		 * @summary Get rounding interpretation
		 * @request POST:/api/v1/settings-interpretation/rounding
		 * @secure
		 * @response `200` `SettingsInterpretationResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		rounding: (data: RoundingRequestModel, params: RequestParams = {}) =>
			this.request<SettingsInterpretationResponseModel, HTTPValidationError>({
				path: `/api/v1/settings-interpretation/rounding`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get anchoring interpretation
		 *
		 * @tags settings-interpretation
		 * @name Anchoring
		 * @summary Get anchoring interpretation
		 * @request POST:/api/v1/settings-interpretation/anchoring
		 * @secure
		 * @response `200` `SettingsInterpretationResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchoring: (data: AnchoringRequestModel, params: RequestParams = {}) =>
			this.request<SettingsInterpretationResponseModel, HTTPValidationError>({
				path: `/api/v1/settings-interpretation/anchoring`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	settingsSchemas = {
		/**
		 * @description List settings schemas resources
		 *
		 * @tags settings-schemas
		 * @name SettingsSchemasList
		 * @summary List settings schemas
		 * @request GET:/api/v1/settings-schemas
		 * @secure
		 * @response `200` `ProductDiffsModel` Successful Response
		 */
		settingsSchemasList: (params: RequestParams = {}) =>
			this.request<ProductDiffsModel, any>({
				path: `/api/v1/settings-schemas`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description List ui schemas resources
		 *
		 * @tags settings-schemas
		 * @name UiSchemasList
		 * @summary List ui schemas
		 * @request GET:/api/v1/ui-schemas
		 * @secure
		 * @response `200` `ProductDiffsModel` Successful Response
		 */
		uiSchemasList: (params: RequestParams = {}) =>
			this.request<ProductDiffsModel, any>({
				path: `/api/v1/ui-schemas`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	settingsTemplate = {
		/**
		 * @description Query settings-template resource
		 *
		 * @tags settings-template
		 * @name SettingsTemplateQuery
		 * @summary Query settings-template
		 * @request POST:/api/v1/settings-templates/query
		 * @secure
		 * @response `200` `SettingsTemplateQueryResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		settingsTemplateQuery: (
			data: SettingsTemplateQueryModel,
			params: RequestParams = {}
		) =>
			this.request<
				SettingsTemplateQueryResponseModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/settings-templates/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get settings-template resource
		 *
		 * @tags settings-template
		 * @name SettingsTemplateGet
		 * @summary Get settings-template
		 * @request GET:/api/v1/settings-templates/{settings_template_id}
		 * @secure
		 * @response `200` `SettingsTemplateModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		settingsTemplateGet: (
			{ settingsTemplateId }: SettingsTemplateGetParams,
			params: RequestParams = {}
		) =>
			this.request<
				SettingsTemplateModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/settings-templates/${settingsTemplateId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Update settings-template resource
		 *
		 * @tags settings-template
		 * @name SettingsTemplateUpdate
		 * @summary Update settings-template
		 * @request PATCH:/api/v1/settings-templates/{settings_template_id}
		 * @secure
		 * @response `200` `SettingsTemplateModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		settingsTemplateUpdate: (
			{ settingsTemplateId }: SettingsTemplateUpdateParams,
			data: SettingsTemplateUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<
				SettingsTemplateModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/settings-templates/${settingsTemplateId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Delete settings-template resource
		 *
		 * @tags settings-template
		 * @name SettingsTemplateDelete
		 * @summary Delete settings-template
		 * @request DELETE:/api/v1/settings-templates/{settings_template_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		settingsTemplateDelete: (
			{ settingsTemplateId }: SettingsTemplateDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/settings-templates/${settingsTemplateId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * @description Create settings-template resource
		 *
		 * @tags settings-template
		 * @name SettingsTemplateCreate
		 * @summary Create settings-template
		 * @request POST:/api/v1/settings-templates
		 * @secure
		 * @response `201` `SettingsTemplateModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		settingsTemplateCreate: (
			data: SettingsTemplateCreateModel,
			params: RequestParams = {}
		) =>
			this.request<
				SettingsTemplateModel,
				HTTPValidationError | FailedPendingResponse
			>({
				path: `/api/v1/settings-templates`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Apply settings-template resource
		 *
		 * @tags settings-template
		 * @name SettingsTemplateApply
		 * @summary Apply settings-template
		 * @request POST:/api/v1/settings-templates/{settings_template_id}/apply
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 * @response `424` `FailedPendingResponse` Failure while updating optimization status
		 */
		settingsTemplateApply: (
			{ settingsTemplateId }: SettingsTemplateApplyParams,
			data: SettingsTemplateApplyRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError | FailedPendingResponse>({
				path: `/api/v1/settings-templates/${settingsTemplateId}/apply`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	anchors = {
		/**
		 * @description Query anchor resources
		 *
		 * @tags anchors
		 * @name AnchorsQuery
		 * @summary Query anchors
		 * @request POST:/api/v1/anchors/query
		 * @secure
		 * @response `200` `AnchorsQueryResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsQuery: (data: AnchorsQueryModel, params: RequestParams = {}) =>
			this.request<AnchorsQueryResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Export anchor resources
		 *
		 * @tags anchors
		 * @name AnchorsExport
		 * @summary Export anchors
		 * @request POST:/api/v1/anchors/export
		 * @secure
		 * @response `200` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsExport: (data: AnchorsExportModel, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/anchors/export`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * @description Get anchor alerts resources
		 *
		 * @tags anchors
		 * @name AnchorsAlerts
		 * @summary Get anchors alerts
		 * @request GET:/api/v1/anchors/alerts
		 * @secure
		 * @response `200` `(AnchorsAlertsItemModel)[]` Successful Response
		 */
		anchorsAlerts: (params: RequestParams = {}) =>
			this.request<AnchorsAlertsItemModel[], any>({
				path: `/api/v1/anchors/alerts`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Query anchor alerts resources
		 *
		 * @tags anchors
		 * @name AnchorsAlertsInfoQuery
		 * @summary Query anchors alerts info
		 * @request POST:/api/v1/anchors/alerts-info/query
		 * @secure
		 * @response `200` `(AnchorsAlertsInfoModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAlertsInfoQuery: (
			data: AnchorsAlertsInfoQueryModel,
			params: RequestParams = {}
		) =>
			this.request<AnchorsAlertsInfoModel[], HTTPValidationError>({
				path: `/api/v1/anchors/alerts-info/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Import anchor resources
		 *
		 * @tags anchors
		 * @name AnchorsImport
		 * @summary Import anchors
		 * @request POST:/api/v1/anchors/import
		 * @secure
		 * @response `200` `AnchorsUpsertResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsImport: (data: AnchorImportFileForm, params: RequestParams = {}) =>
			this.request<AnchorsUpsertResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/import`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),

		/**
		 * @description Upsert anchor resources
		 *
		 * @tags anchors
		 * @name AnchorsUpsert
		 * @summary Upsert anchors
		 * @request POST:/api/v1/anchors/upsert
		 * @secure
		 * @response `200` `AnchorsUpsertResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsUpsert: (data: AnchorsUpsertModel, params: RequestParams = {}) =>
			this.request<AnchorsUpsertResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/upsert`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Delete anchor resources
		 *
		 * @tags anchors
		 * @name AnchorsDelete
		 * @summary Delete anchors
		 * @request POST:/api/v1/anchors/delete
		 * @secure
		 * @response `200` `AnchorsDeleteResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsDelete: (data: AnchorsDeleteModel, params: RequestParams = {}) =>
			this.request<AnchorsDeleteResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/delete`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Convert Optimization Group POSes to Sales Entity
		 *
		 * @tags anchors
		 * @name AnchorsSalesEntityGet
		 * @summary Convert Optimization Group POSes to Sales Entity
		 * @request GET:/api/v1/anchors/sales-entity/{optimization_group_id}
		 * @secure
		 * @response `200` `AnchorsSalesEntityResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsSalesEntityGet: (
			{ optimizationGroupId }: AnchorsSalesEntityGetParams,
			params: RequestParams = {}
		) =>
			this.request<AnchorsSalesEntityResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/sales-entity/${optimizationGroupId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	anchorStrategies = {
		/**
		 * @description Query anchor strategies resources
		 *
		 * @tags anchor-strategies
		 * @name AnchorsAnchorStrategyQuery
		 * @summary Query anchors strategies
		 * @request POST:/api/v1/anchors/anchor-strategies/query
		 * @secure
		 * @response `200` `AnchorStrategyQueryResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAnchorStrategyQuery: (
			data: AnchorStrategyQueryModel,
			params: RequestParams = {}
		) =>
			this.request<AnchorStrategyQueryResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/anchor-strategies/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get anchor strategy resource
		 *
		 * @tags anchor-strategies
		 * @name AnchorsAnchorStrategyGet
		 * @summary Get anchor strategy
		 * @request GET:/api/v1/anchors/anchor-strategies/{anchor_strategy_id}
		 * @secure
		 * @response `200` `AnchorStrategyModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAnchorStrategyGet: (
			{ anchorStrategyId }: AnchorsAnchorStrategyGetParams,
			params: RequestParams = {}
		) =>
			this.request<AnchorStrategyModel, HTTPValidationError>({
				path: `/api/v1/anchors/anchor-strategies/${anchorStrategyId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Update anchor strategy resource
		 *
		 * @tags anchor-strategies
		 * @name AnchorsAnchorStrategyUpdate
		 * @summary Update anchor strategy
		 * @request PATCH:/api/v1/anchors/anchor-strategies/{anchor_strategy_id}
		 * @secure
		 * @response `200` `AnchorStrategyModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAnchorStrategyUpdate: (
			{ anchorStrategyId }: AnchorsAnchorStrategyUpdateParams,
			data: AnchorStrategyUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<AnchorStrategyModel, HTTPValidationError>({
				path: `/api/v1/anchors/anchor-strategies/${anchorStrategyId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Delete anchor strategy resource
		 *
		 * @tags anchor-strategies
		 * @name AnchorsAnchorStrategyDelete
		 * @summary Delete anchor strategy
		 * @request DELETE:/api/v1/anchors/anchor-strategies/{anchor_strategy_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAnchorStrategyDelete: (
			{ anchorStrategyId }: AnchorsAnchorStrategyDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/anchors/anchor-strategies/${anchorStrategyId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * @description Create anchor strategy resource
		 *
		 * @tags anchor-strategies
		 * @name AnchorsAnchorStrategyCreate
		 * @summary Create anchor strategy
		 * @request POST:/api/v1/anchors/anchor-strategies
		 * @secure
		 * @response `200` `AnchorStrategyModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAnchorStrategyCreate: (
			data: AnchorStrategyCreateModel,
			params: RequestParams = {}
		) =>
			this.request<AnchorStrategyModel, HTTPValidationError>({
				path: `/api/v1/anchors/anchor-strategies`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Get anchor strategy matched products resources
		 *
		 * @tags anchor-strategies
		 * @name AnchorsAnchorStrategyMatchedProducts
		 * @summary Get anchor strategy matched products
		 * @request POST:/api/v1/anchors/anchor-strategy/matched-products
		 * @secure
		 * @response `200` `(AnchorStrategyGroupMatchedModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsAnchorStrategyMatchedProducts: (
			data: AnchorStrategyMatchedProductsRequest,
			params: RequestParams = {}
		) =>
			this.request<AnchorStrategyGroupMatchedModel[], HTTPValidationError>({
				path: `/api/v1/anchors/anchor-strategy/matched-products`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Query anchor generated families resources
		 *
		 * @tags anchor-strategies
		 * @name AnchorsGeneratedFamilyQuery
		 * @summary Query anchors generated families
		 * @request POST:/api/v1/anchors/generated-families/query
		 * @secure
		 * @response `200` `AnchorGeneratedFamilyQueryResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsGeneratedFamilyQuery: (
			data: AnchorGeneratedFamilyQueryModel,
			params: RequestParams = {}
		) =>
			this.request<
				AnchorGeneratedFamilyQueryResponseModel,
				HTTPValidationError
			>({
				path: `/api/v1/anchors/generated-families/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Review anchor generated families resources
		 *
		 * @tags anchor-strategies
		 * @name AnchorsGeneratedFamilyReview
		 * @summary Review anchors generated families
		 * @request POST:/api/v1/anchors/generated-families/review
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsGeneratedFamilyReview: (
			data: AnchorGeneratedFamilyReviewRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/anchors/generated-families/review`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	productCatalog = {
		/**
		 * @description Query product catalog resources
		 *
		 * @tags product-catalog
		 * @name AnchorsProductCatalogQuery
		 * @summary Query product catalog
		 * @request POST:/api/v1/anchors/product-catalog/query
		 * @secure
		 * @response `200` `ProductCatalogQueryResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		anchorsProductCatalogQuery: (
			data: ProductCatalogQueryModel,
			params: RequestParams = {}
		) =>
			this.request<ProductCatalogQueryResponseModel, HTTPValidationError>({
				path: `/api/v1/anchors/product-catalog/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	currencies = {
		/**
		 * No description
		 *
		 * @tags currencies
		 * @name GetCurrencies
		 * @summary Get currencies of optimization groups available for user and the default one.
		 * @request GET:/api/v1/currencies
		 * @secure
		 * @response `200` `CurrenciesResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCurrencies: (params: RequestParams = {}) =>
			this.request<CurrenciesResponseModel, HTTPValidationError>({
				path: `/api/v1/currencies`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	externalExport = {
		/**
		 * @description Returns a list of existing user exports
		 *
		 * @tags external-export
		 * @name ListExportsExternal
		 * @summary List all exports
		 * @request GET:/external/api/v1/exports
		 * @secure
		 * @response `200` `(ExportModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		listExportsExternal: (params: RequestParams = {}) =>
			this.request<ExportModel[], HTTPValidationError>({
				path: `/external/api/v1/exports`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Create an export task with specified columns, headers and/or filters. Starts an asynchronous task to create an export file that can be downloaded when the export status becomes `finished`.
		 *
		 * @tags external-export
		 * @name CreateExportExternal
		 * @summary Create export
		 * @request POST:/external/api/v1/exports
		 * @secure
		 * @response `201` `ExportModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createExportExternal: (
			data: ExportCreateModel,
			params: RequestParams = {}
		) =>
			this.request<ExportModel, HTTPValidationError>({
				path: `/external/api/v1/exports`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Returns a signed URL to download the export file when status is `finished`. The URL expires in 5 minutes.
		 *
		 * @tags external-export
		 * @name GetDownloadLinkExternal
		 * @summary Get export download URL
		 * @request GET:/external/api/v1/exports/{export_id}/download-url
		 * @secure
		 * @response `200` `ExportDownloadUrlModel` Successful Response
		 * @response `404` `void` export is not found
		 * @response `409` `void` export is not ready
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getDownloadLinkExternal: (
			{ exportId }: GetDownloadLinkExternalParams,
			params: RequestParams = {}
		) =>
			this.request<ExportDownloadUrlModel, void | HTTPValidationError>({
				path: `/external/api/v1/exports/${exportId}/download-url`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	export = {
		/**
		 * No description
		 *
		 * @tags export
		 * @name ListExports
		 * @summary List Exports
		 * @request GET:/api/v1/exports
		 * @secure
		 * @response `200` `(ExportModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		listExports: (params: RequestParams = {}) =>
			this.request<ExportModel[], HTTPValidationError>({
				path: `/api/v1/exports`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags export
		 * @name CreateExport
		 * @summary Create Export
		 * @request POST:/api/v1/exports
		 * @secure
		 * @response `201` `ExportModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createExport: (data: ExportCreateModel, params: RequestParams = {}) =>
			this.request<ExportModel, HTTPValidationError>({
				path: `/api/v1/exports`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * @description Download the export file. Deprecated in favor of `GET /exports/{export_id}/download-url`.
		 *
		 * @tags export
		 * @name DownloadExportFile
		 * @summary Download Export File
		 * @request GET:/api/v1/exports/{export_id}/download
		 * @deprecated
		 * @secure
		 * @response `200` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		downloadExportFile: (
			{ exportId }: DownloadExportFileParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/exports/${exportId}/download`,
				method: 'GET',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags export
		 * @name GetDownloadLink
		 * @summary Get a signed URL to download the export file.
		 * @request GET:/api/v1/exports/{export_id}/download-url
		 * @secure
		 * @response `200` `ExportDownloadUrlModel` Successful Response
		 * @response `404` `void` export is not found
		 * @response `409` `void` export is not ready
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getDownloadLink: (
			{ exportId }: GetDownloadLinkParams,
			params: RequestParams = {}
		) =>
			this.request<ExportDownloadUrlModel, void | HTTPValidationError>({
				path: `/api/v1/exports/${exportId}/download-url`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags export
		 * @name DeleteExport
		 * @summary Delete Export
		 * @request DELETE:/api/v1/exports/{export_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteExport: (
			{ exportId }: DeleteExportParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/exports/${exportId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags export
		 * @name GetExportTemplates
		 * @summary Get Export Templates
		 * @request GET:/api/v1/exports/templates
		 * @secure
		 * @response `200` `(ExportTemplateModel)[]` Successful Response
		 */
		getExportTemplates: (params: RequestParams = {}) =>
			this.request<ExportTemplateModel[], any>({
				path: `/api/v1/exports/templates`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	optimizations = {
		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name GetCurrentOptimizations
		 * @summary Get list of current optimizations in project, optionally filtered by OGs.
		 * @request GET:/api/v2/current-optimizations
		 * @secure
		 * @response `200` `(OptimizationModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCurrentOptimizations: (
			query: GetCurrentOptimizationsParams = {},
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel[], HTTPValidationError>({
				path: `/api/v2/current-optimizations`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name GetOptimizations
		 * @summary Get list of optimizations by id.
		 * @request GET:/api/v2/optimizations
		 * @secure
		 * @response `200` `(OptimizationModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOptimizations: (
			query: GetOptimizationsParams,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel[], HTTPValidationError>({
				path: `/api/v2/optimizations`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * @description Create new current optimization in specific optimization group. Deprecated in favor of `reset` action.
		 *
		 * @tags optimizations
		 * @name CreateOptimization
		 * @summary Create new current optimization in specific optimization group.
		 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations
		 * @deprecated
		 * @secure
		 * @response `201` `OptimizationModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createOptimization: (
			{ optimizationGroupId }: CreateOptimizationParams,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}/optimizations`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationFinalFieldsSku
		 * @summary Perform sku-wise final fields update on specific optimization group
		 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/final-fields-sku
		 * @secure
		 * @response `200` `OptimizationModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationFinalFieldsSku: (
			{ optimizationGroupId }: OptimizationFinalFieldsSkuParams,
			data: FinalFieldsListModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}/optimizations/final-fields-sku`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationFinalFieldsFilters
		 * @summary Perform filters-based final fields update on specific optimization group
		 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/final-fields-filters
		 * @secure
		 * @response `200` `(OptimizationModel | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationFinalFieldsFilters: (
			{ optimizationGroupId }: OptimizationFinalFieldsFiltersParams,
			data: FinalFieldsPatchModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel | null, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}/optimizations/final-fields-filters`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationProductDiffsSku
		 * @summary Perform sku-wise product update on specific optimization group
		 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/product-diffs-sku
		 * @secure
		 * @response `200` `(OptimizationModel | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationProductDiffsSku: (
			{ optimizationGroupId }: OptimizationProductDiffsSkuParams,
			data: ProductDiffsModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel | null, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}/optimizations/product-diffs-sku`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationProductDiffsFilters
		 * @summary Perform filters-based product update on specific optimization group
		 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/product-diffs-filters
		 * @secure
		 * @response `200` `(OptimizationModel | null)` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationProductDiffsFilters: (
			{ optimizationGroupId }: OptimizationProductDiffsFiltersParams,
			data: ProductsUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel | null, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}/optimizations/product-diffs-filters`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationAction
		 * @summary Perform action on current optimization in specific optimization group
		 * @request POST:/api/v2/optimization-groups/{optimization_group_id}/optimizations/{action}
		 * @secure
		 * @response `200` `OptimizationModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationAction: (
			{ action, optimizationGroupId }: OptimizationActionParams,
			params: RequestParams = {}
		) =>
			this.request<OptimizationModel, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}/optimizations/${action}`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationBulkActions
		 * @summary Perform multiple optimization actions at the same time
		 * @request POST:/api/v2/optimizations/bulk-actions
		 * @secure
		 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationBulkActions: (
			data: OptimizationBulkActionsRequestModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationActionResponseModel[], HTTPValidationError>({
				path: `/api/v2/optimizations/bulk-actions`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationBulkProductDiffsFile
		 * @summary Perform multiple optimization product diff actions at the same time
		 * @request POST:/api/v2/optimizations/bulk-product-diffs-file
		 * @secure
		 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationBulkProductDiffsFile: (
			data: BulkProductDiffsFileForm,
			params: RequestParams = {}
		) =>
			this.request<OptimizationActionResponseModel[], HTTPValidationError>({
				path: `/api/v2/optimizations/bulk-product-diffs-file`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name ValidateProductDiff
		 * @summary Validate product diff without taking any other action
		 * @request POST:/api/v2/optimizations/validate-product-diff
		 * @secure
		 * @response `200` `ValidateProductDiffsResponse` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		validateProductDiff: (
			data: ValidateProductDiffsFileForm,
			params: RequestParams = {}
		) =>
			this.request<ValidateProductDiffsResponse, HTTPValidationError>({
				path: `/api/v2/optimizations/validate-product-diff`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationBulkFinalFields
		 * @summary Perform bulk final fields update on matching optimization groups
		 * @request POST:/api/v2/optimizations/bulk-final-fields
		 * @secure
		 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationBulkFinalFields: (
			data: OptimizationBulkFinalFieldsRequestModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationActionResponseModel[], HTTPValidationError>({
				path: `/api/v2/optimizations/bulk-final-fields`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimizations
		 * @name OptimizationBulkFinalFieldsFile
		 * @summary Perform bulk final fields update from file on matching optimization groups
		 * @request POST:/api/v2/optimizations/bulk-final-fields-file
		 * @secure
		 * @response `200` `(OptimizationActionResponseModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		optimizationBulkFinalFieldsFile: (
			data: BulkFinalFieldsFileForm,
			params: RequestParams = {}
		) =>
			this.request<OptimizationActionResponseModel[], HTTPValidationError>({
				path: `/api/v2/optimizations/bulk-final-fields-file`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),
	}
	optimizationGroups = {
		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name GetProductGroups
		 * @summary Get list of product groups available in project.
		 * @request GET:/api/v2/product-groups
		 * @secure
		 * @response `200` `(ProductGroupModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getProductGroups: (
			query: GetProductGroupsParams = {},
			params: RequestParams = {}
		) =>
			this.request<ProductGroupModel[], HTTPValidationError>({
				path: `/api/v2/product-groups`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name GetSalesEntities
		 * @summary Get list of sales entities in project.
		 * @request GET:/api/v2/sales-entities
		 * @secure
		 * @response `200` `SalesEntitiesResponseModel` Successful Response
		 */
		getSalesEntities: (params: RequestParams = {}) =>
			this.request<SalesEntitiesResponseModel, any>({
				path: `/api/v2/sales-entities`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name GetOptimizationGroups
		 * @summary Get list of optimization groups available for user in project.
		 * @request GET:/api/v2/optimization-groups
		 * @secure
		 * @response `200` `(OptimizationGroupModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOptimizationGroups: (params: RequestParams = {}) =>
			this.request<OptimizationGroupModel[], HTTPValidationError>({
				path: `/api/v2/optimization-groups`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name CreateOptimizationGroup
		 * @summary Create new optimization group in project.
		 * @request POST:/api/v2/optimization-groups
		 * @secure
		 * @response `200` `OptimizationGroupModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createOptimizationGroup: (
			data: OptimizationGroupCreateModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationGroupModel, HTTPValidationError>({
				path: `/api/v2/optimization-groups`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name GetOptimizationGroup
		 * @summary Get specific optimization group in project.
		 * @request GET:/api/v2/optimization-groups/{optimization_group_id}
		 * @secure
		 * @response `200` `OptimizationGroupModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getOptimizationGroup: (
			{ optimizationGroupId }: GetOptimizationGroupParams,
			params: RequestParams = {}
		) =>
			this.request<OptimizationGroupModel, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name UpdateOptimizationGroup
		 * @summary Update existing optimization group in project.
		 * @request PATCH:/api/v2/optimization-groups/{optimization_group_id}
		 * @secure
		 * @response `200` `OptimizationGroupModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateOptimizationGroup: (
			{ optimizationGroupId }: UpdateOptimizationGroupParams,
			data: UpdateOptimizationGroupRequestModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationGroupModel, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags optimization-groups
		 * @name DeleteOptimizationGroup
		 * @summary Delete optimization group in project (actually marks inactive).
		 * @request DELETE:/api/v2/optimization-groups/{optimization_group_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteOptimizationGroup: (
			{ optimizationGroupId }: DeleteOptimizationGroupParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v2/optimization-groups/${optimizationGroupId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	reviews = {
		/**
		 * No description
		 *
		 * @tags reviews
		 * @name ListOptimizationGroupsReviews
		 * @summary List all reviews for the current iteration.
		 * @request GET:/api/v1/optimization-groups/reviews
		 * @secure
		 * @response `200` `OptimizationGroupReviewListResponse` Successful Response
		 */
		listOptimizationGroupsReviews: (params: RequestParams = {}) =>
			this.request<OptimizationGroupReviewListResponse, any>({
				path: `/api/v1/optimization-groups/reviews`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags reviews
		 * @name CreateOptimizationGroupReview
		 * @summary Create a review for an optimization group.
		 * @request POST:/api/v1/optimization-groups/{optimization_group_id}/reviews
		 * @secure
		 * @response `201` `OptimizationGroupReviewModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createOptimizationGroupReview: (
			{ optimizationGroupId }: CreateOptimizationGroupReviewParams,
			data: OptimizationGroupReviewCreateModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationGroupReviewModel, HTTPValidationError>({
				path: `/api/v1/optimization-groups/${optimizationGroupId}/reviews`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags reviews
		 * @name UpdateOptimizationGroupReview
		 * @summary Update a review for an optimization group.
		 * @request PATCH:/api/v1/optimization-groups/{optimization_group_id}/reviews
		 * @secure
		 * @response `200` `OptimizationGroupReviewModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateOptimizationGroupReview: (
			{ optimizationGroupId }: UpdateOptimizationGroupReviewParams,
			data: OptimizationGroupReviewUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<OptimizationGroupReviewModel, HTTPValidationError>({
				path: `/api/v1/optimization-groups/${optimizationGroupId}/reviews`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags reviews
		 * @name DeleteOptimizationGroupReview
		 * @summary Delete a review for an optimization group.
		 * @request DELETE:/api/v1/optimization-groups/{optimization_group_id}/reviews
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteOptimizationGroupReview: (
			{ optimizationGroupId }: DeleteOptimizationGroupReviewParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/optimization-groups/${optimizationGroupId}/reviews`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags reviews
		 * @name ApproveOptimizationGroupReview
		 * @summary Approve a review as a reviewer.
		 * @request POST:/api/v1/optimization-groups/{optimization_group_id}/reviews/approve
		 * @secure
		 * @response `200` `OptimizationGroupReviewModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		approveOptimizationGroupReview: (
			{ optimizationGroupId }: ApproveOptimizationGroupReviewParams,
			params: RequestParams = {}
		) =>
			this.request<OptimizationGroupReviewModel, HTTPValidationError>({
				path: `/api/v1/optimization-groups/${optimizationGroupId}/reviews/approve`,
				method: 'POST',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	products = {
		/**
		 * No description
		 *
		 * @tags products
		 * @name GetAlerts
		 * @summary Get list of product alerts in project.
		 * @request GET:/api/v2/alerts
		 * @secure
		 * @response `200` `(AlertModel)[]` Successful Response
		 */
		getAlerts: (params: RequestParams = {}) =>
			this.request<AlertModel[], any>({
				path: `/api/v2/alerts`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags products
		 * @name GetBrands
		 * @summary Get brands for selected OG / all OGs
		 * @request GET:/api/v2/brands
		 * @secure
		 * @response `200` `(BrandModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getBrands: (query: GetBrandsParams = {}, params: RequestParams = {}) =>
			this.request<BrandModel[], HTTPValidationError>({
				path: `/api/v2/brands`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags products
		 * @name GetCategories
		 * @summary Get categories for selected OG / all OGs
		 * @request GET:/api/v2/categories
		 * @secure
		 * @response `200` `(CategoryModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getCategories: (
			query: GetCategoriesParams = {},
			params: RequestParams = {}
		) =>
			this.request<CategoryModel[], HTTPValidationError>({
				path: `/api/v2/categories`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags products
		 * @name QueryProducts
		 * @summary Get pricing lines accounting for filters, search, order and limits
		 * @request POST:/api/v2/products/query
		 * @secure
		 * @response `200` `ProductsQueryResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		queryProducts: (
			data: ProductsQueryRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ProductsQueryResponseModel, HTTPValidationError>({
				path: `/api/v2/products/query`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags products
		 * @name GetProductsCountByPc
		 * @summary Get counts of products grouped by optimization_group_id and pricing_campaign_id.
		 * @request POST:/api/v2/products-count-by-pc
		 * @secure
		 * @response `200` `(ProductsByPCModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getProductsCountByPc: (
			data: ProductsByPCRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ProductsByPCModel[], HTTPValidationError>({
				path: `/api/v2/products-count-by-pc`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),
	}
	rawProduct = {
		/**
		 * No description
		 *
		 * @tags raw-product
		 * @name GetRawProductColumns
		 * @summary Get columns (name and type) of the ClickHouse raw_product table.
		 * @request GET:/api/v2/raw-product/columns
		 * @secure
		 * @response `200` `(RawProductColumnModel)[]` Successful Response
		 */
		getRawProductColumns: (params: RequestParams = {}) =>
			this.request<RawProductColumnModel[], any>({
				path: `/api/v2/raw-product/columns`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	savedFilters = {
		/**
		 * No description
		 *
		 * @tags saved-filters
		 * @name GetSavedFilters
		 * @summary Get all public and personal saved filters in project.
		 * @request GET:/api/v2/saved-filters
		 * @secure
		 * @response `200` `(SavedFilterModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getSavedFilters: (params: RequestParams = {}) =>
			this.request<SavedFilterModel[], HTTPValidationError>({
				path: `/api/v2/saved-filters`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags saved-filters
		 * @name CreateSavedFilter
		 * @summary Create saved filter in project.
		 * @request POST:/api/v2/saved-filters
		 * @secure
		 * @response `201` `SavedFilterModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createSavedFilter: (
			data: SavedFilterCreateModel,
			params: RequestParams = {}
		) =>
			this.request<SavedFilterModel, HTTPValidationError>({
				path: `/api/v2/saved-filters`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags saved-filters
		 * @name UpdateSavedFilter
		 * @summary Update saved filter in project.
		 * @request PATCH:/api/v2/saved-filters/{saved_filter_id}
		 * @secure
		 * @response `200` `any` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateSavedFilter: (
			{ savedFilterId }: UpdateSavedFilterParams,
			data: SavedFilterUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<any, HTTPValidationError>({
				path: `/api/v2/saved-filters/${savedFilterId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags saved-filters
		 * @name DeleteSavedFilter
		 * @summary Delete saved filter in project.
		 * @request DELETE:/api/v2/saved-filters/{saved_filter_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteSavedFilter: (
			{ savedFilterId }: DeleteSavedFilterParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v2/saved-filters/${savedFilterId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	schedules = {
		/**
		 * No description
		 *
		 * @tags schedules
		 * @name ListSchedules
		 * @summary List all schedules.
		 * @request GET:/api/v1/schedules
		 * @secure
		 * @response `200` `(ScheduleModel)[]` Successful Response
		 */
		listSchedules: (params: RequestParams = {}) =>
			this.request<ScheduleModel[], any>({
				path: `/api/v1/schedules`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags schedules
		 * @name CreateSchedule
		 * @summary Create a schedule for optimization groups.
		 * @request POST:/api/v1/schedules
		 * @secure
		 * @response `201` `ScheduleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createSchedule: (data: CreateScheduleModel, params: RequestParams = {}) =>
			this.request<ScheduleModel, HTTPValidationError>({
				path: `/api/v1/schedules`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags schedules
		 * @name ListSchedules2
		 * @summary List Schedules
		 * @request GET:/api/v1/schedules/
		 * @originalName listSchedules
		 * @duplicate
		 * @secure
		 * @response `200` `(ScheduleModel)[]` Successful Response
		 */
		listSchedules2: (params: RequestParams = {}) =>
			this.request<ScheduleModel[], any>({
				path: `/api/v1/schedules/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags schedules
		 * @name CreateSchedule2
		 * @summary Create Schedule
		 * @request POST:/api/v1/schedules/
		 * @originalName createSchedule
		 * @duplicate
		 * @secure
		 * @response `201` `ScheduleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createSchedule2: (data: CreateScheduleModel, params: RequestParams = {}) =>
			this.request<ScheduleModel, HTTPValidationError>({
				path: `/api/v1/schedules/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags schedules
		 * @name GetSchedule
		 * @summary Get schedule for optimization groups.
		 * @request GET:/api/v1/schedules/{schedule_id}
		 * @secure
		 * @response `200` `ScheduleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getSchedule: (
			{ scheduleId }: GetScheduleParams,
			params: RequestParams = {}
		) =>
			this.request<ScheduleModel, HTTPValidationError>({
				path: `/api/v1/schedules/${scheduleId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags schedules
		 * @name UpdateSchedule
		 * @summary Update schedule for optimization groups.
		 * @request PATCH:/api/v1/schedules/{schedule_id}
		 * @secure
		 * @response `200` `ScheduleModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updateSchedule: (
			{ scheduleId }: UpdateScheduleParams,
			data: UpdateScheduleModel,
			params: RequestParams = {}
		) =>
			this.request<ScheduleModel, HTTPValidationError>({
				path: `/api/v1/schedules/${scheduleId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags schedules
		 * @name DeleteSchedule
		 * @summary Delete schedule for optimization groups.
		 * @request DELETE:/api/v1/schedules/{schedule_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deleteSchedule: (
			{ scheduleId }: DeleteScheduleParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/schedules/${scheduleId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	customFeatureConfig = {
		/**
 * No description
 *
 * @tags custom-feature-config
 * @name CustomFeatureConfigList
 * @summary Custom-Feature-Config-List
 * @request GET:/api/v1/custom-feature-configs
 * @secure
 * @response `200` `((({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId)))[]` Successful Response
 */
		customFeatureConfigList: (params: RequestParams = {}) =>
			this.request<
				(
					| ({
							type: 'product_feature'
					  } & ProductFeatureConfigWithId)
					| ({
							type: 'sales_metrics_feature'
					  } & SalesMetricsFeatureConfigWithId)
				)[],
				any
			>({
				path: `/api/v1/custom-feature-configs`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
 * No description
 *
 * @tags custom-feature-config
 * @name CustomFeatureConfigCreate
 * @summary Custom-Feature-Config-Create
 * @request POST:/api/v1/custom-feature-configs
 * @secure
 * @response `201` `(({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId))` Successful Response
 * @response `409` `void` Custom feature config already exists: `{id}`
 * @response `422` `HTTPValidationError` Validation Error
 */
		customFeatureConfigCreate: (
			data: CustomFeatureConfigCreateRequestModel,
			params: RequestParams = {}
		) =>
			this.request<
				| ({
						type: 'product_feature'
				  } & ProductFeatureConfigWithId)
				| ({
						type: 'sales_metrics_feature'
				  } & SalesMetricsFeatureConfigWithId),
				void | HTTPValidationError
			>({
				path: `/api/v1/custom-feature-configs`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
 * No description
 *
 * @tags custom-feature-config
 * @name CustomFeatureConfigGet
 * @summary Custom-Feature-Config-Get
 * @request GET:/api/v1/custom-feature-configs/{id}
 * @secure
 * @response `200` `(({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId))` Successful Response
 * @response `404` `void` Custom feature config not found: `{id}`
 * @response `422` `HTTPValidationError` Validation Error
 */
		customFeatureConfigGet: (
			{ id }: CustomFeatureConfigGetParams,
			params: RequestParams = {}
		) =>
			this.request<
				| ({
						type: 'product_feature'
				  } & ProductFeatureConfigWithId)
				| ({
						type: 'sales_metrics_feature'
				  } & SalesMetricsFeatureConfigWithId),
				void | HTTPValidationError
			>({
				path: `/api/v1/custom-feature-configs/${id}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
 * No description
 *
 * @tags custom-feature-config
 * @name CustomFeatureConfigUpdate
 * @summary Custom-Feature-Config-Update
 * @request PATCH:/api/v1/custom-feature-configs/{id}
 * @secure
 * @response `200` `(({
"type": "product_feature"
} & ProductFeatureConfigWithId) | ({
"type": "sales_metrics_feature"
} & SalesMetricsFeatureConfigWithId))` Successful Response
 * @response `404` `void` Custom feature config not found: `{id}`
 * @response `422` `HTTPValidationError` Validation Error
 */
		customFeatureConfigUpdate: (
			{ id }: CustomFeatureConfigUpdateParams,
			data: CustomFeatureConfigUpdateRequestModel,
			params: RequestParams = {}
		) =>
			this.request<
				| ({
						type: 'product_feature'
				  } & ProductFeatureConfigWithId)
				| ({
						type: 'sales_metrics_feature'
				  } & SalesMetricsFeatureConfigWithId),
				void | HTTPValidationError
			>({
				path: `/api/v1/custom-feature-configs/${id}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags custom-feature-config
		 * @name CustomFeatureConfigDelete
		 * @summary Custom-Feature-Config-Delete
		 * @request DELETE:/api/v1/custom-feature-configs/{id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `404` `void` Custom feature config not found: `{id}`
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		customFeatureConfigDelete: (
			{ id }: CustomFeatureConfigDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, void | HTTPValidationError>({
				path: `/api/v1/custom-feature-configs/${id}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags custom-feature-config
		 * @name CustomFeatureConfigBulkDelete
		 * @summary Custom-Feature-Config-Bulk-Delete
		 * @request POST:/api/v1/custom-feature-configs/bulk-delete
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		customFeatureConfigBulkDelete: (
			data: CustomFeatureConfigBulkDeleteRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/custom-feature-configs/bulk-delete`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	fieldSchema = {
		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaList
		 * @summary Field-Schema-List
		 * @request GET:/api/v1/field-schemas
		 * @secure
		 * @response `200` `(FieldSchemaModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaList: (
			query: FieldSchemaListParams = {},
			params: RequestParams = {}
		) =>
			this.request<FieldSchemaModel[], HTTPValidationError>({
				path: `/api/v1/field-schemas`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaCreate
		 * @summary Field-Schema-Create
		 * @request POST:/api/v1/field-schemas
		 * @secure
		 * @response `201` `FieldSchemaModel` Successful Response
		 * @response `409` `void` Field schema already exists: `{id}`
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaCreate: (data: FieldSchemaModel, params: RequestParams = {}) =>
			this.request<FieldSchemaModel, void | HTTPValidationError>({
				path: `/api/v1/field-schemas`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaGet
		 * @summary Field-Schema-Get
		 * @request GET:/api/v1/field-schemas/{field_schema_id}
		 * @secure
		 * @response `200` `FieldSchemaModel` Successful Response
		 * @response `404` `void` Field schema not found: `{field_schema_id}`
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaGet: (
			{ fieldSchemaId }: FieldSchemaGetParams,
			params: RequestParams = {}
		) =>
			this.request<FieldSchemaModel, void | HTTPValidationError>({
				path: `/api/v1/field-schemas/${fieldSchemaId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaUpdate
		 * @summary Field-Schema-Update
		 * @request PATCH:/api/v1/field-schemas/{field_schema_id}
		 * @secure
		 * @response `200` `FieldSchemaModel` Successful Response
		 * @response `404` `void` Field schema not found: {id}
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaUpdate: (
			{ fieldSchemaId }: FieldSchemaUpdateParams,
			data: FieldSchemaUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<FieldSchemaModel, void | HTTPValidationError>({
				path: `/api/v1/field-schemas/${fieldSchemaId}`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaDelete
		 * @summary Field-Schema-Delete
		 * @request DELETE:/api/v1/field-schemas/{field_schema_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `404` `void` Field schema not found: `{field_schema_id}`
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaDelete: (
			{ fieldSchemaId }: FieldSchemaDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, void | HTTPValidationError>({
				path: `/api/v1/field-schemas/${fieldSchemaId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaBulkUpdate
		 * @summary Field-Schema-Bulk-Update
		 * @request POST:/api/v1/field-schemas/bulk-update
		 * @secure
		 * @response `200` `(FieldSchemaModel)[]` Successful Response
		 * @response `404` `void` Field schema(s) not found: {ids}
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaBulkUpdate: (
			data: FieldSchemaBulkUpdateRequestModel,
			params: RequestParams = {}
		) =>
			this.request<FieldSchemaModel[], void | HTTPValidationError>({
				path: `/api/v1/field-schemas/bulk-update`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags field-schema
		 * @name FieldSchemaBulkDelete
		 * @summary Field-Schema-Bulk-Delete
		 * @request POST:/api/v1/field-schemas/bulk-delete
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		fieldSchemaBulkDelete: (
			data: FieldSchemaBulkDeleteRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/field-schemas/bulk-delete`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	publicSetting = {
		/**
		 * No description
		 *
		 * @tags public-setting
		 * @name PublicSettingGet
		 * @summary Public-Setting-Get
		 * @request GET:/api/v1/public-settings/{setting_id}
		 * @secure
		 * @response `200` `Setting` Successful Response
		 * @response `404` `void` Setting not found: `{setting_id}`
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		publicSettingGet: (
			{ settingId }: PublicSettingGetParams,
			params: RequestParams = {}
		) =>
			this.request<Setting, void | HTTPValidationError>({
				path: `/api/v1/public-settings/${settingId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	setting = {
		/**
		 * No description
		 *
		 * @tags setting
		 * @name SettingList
		 * @summary Setting-List
		 * @request GET:/api/v1/setting
		 * @secure
		 * @response `200` `(Setting)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingList: (query: SettingListParams = {}, params: RequestParams = {}) =>
			this.request<Setting[], HTTPValidationError>({
				path: `/api/v1/setting`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting
		 * @name SettingCreate
		 * @summary Setting-Create
		 * @request POST:/api/v1/setting
		 * @secure
		 * @response `201` `Setting` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingCreate: (
			data: SettingCreateRequestModel,
			params: RequestParams = {}
		) =>
			this.request<Setting, HTTPValidationError>({
				path: `/api/v1/setting`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting
		 * @name SettingUpdate
		 * @summary Setting-Update
		 * @request PATCH:/api/v1/setting
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingUpdate: (data: Setting, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/setting`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting
		 * @name SettingRestore
		 * @summary Setting-Restore
		 * @request PUT:/api/v1/setting
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingRestore: (
			data: SettingRestoreRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/setting`,
				method: 'PUT',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting
		 * @name SettingDetail
		 * @summary Setting-Detail
		 * @request GET:/api/v1/setting/{setting_id}
		 * @secure
		 * @response `200` `Setting` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingDetail: (
			{ settingId }: SettingDetailParams,
			params: RequestParams = {}
		) =>
			this.request<Setting, HTTPValidationError>({
				path: `/api/v1/setting/${settingId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting
		 * @name SettingDelete
		 * @summary Setting-Delete
		 * @request DELETE:/api/v1/setting/{setting_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingDelete: (
			{ settingId }: SettingDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/setting/${settingId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	settingType = {
		/**
		 * No description
		 *
		 * @tags setting-type
		 * @name SettingTypeList
		 * @summary Setting-Type-List
		 * @request GET:/api/v1/setting-type
		 * @secure
		 * @response `200` `(SettingType)[]` Successful Response
		 */
		settingTypeList: (params: RequestParams = {}) =>
			this.request<SettingType[], any>({
				path: `/api/v1/setting-type`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting-type
		 * @name SettingTypeRestore
		 * @summary Setting-Type-Restore
		 * @request PUT:/api/v1/setting-type
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingTypeRestore: (
			data: SettingTypeRestoreRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/setting-type`,
				method: 'PUT',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting-type
		 * @name SettingTypeCreate
		 * @summary Setting-Type-Create
		 * @request POST:/api/v1/setting-type
		 * @secure
		 * @response `201` `SettingType` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingTypeCreate: (data: SettingType, params: RequestParams = {}) =>
			this.request<SettingType, HTTPValidationError>({
				path: `/api/v1/setting-type`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting-type
		 * @name SettingTypeUpdate
		 * @summary Setting-Type-Update
		 * @request PATCH:/api/v1/setting-type
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingTypeUpdate: (data: SettingType, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/setting-type`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting-type
		 * @name SettingTypeDetail
		 * @summary Setting-Type-Detail
		 * @request GET:/api/v1/setting-type/{setting_type_id}
		 * @secure
		 * @response `200` `SettingType` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingTypeDetail: (
			{ settingTypeId }: SettingTypeDetailParams,
			params: RequestParams = {}
		) =>
			this.request<SettingType, HTTPValidationError>({
				path: `/api/v1/setting-type/${settingTypeId}`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags setting-type
		 * @name SettingTypeDelete
		 * @summary Setting-Type-Delete
		 * @request DELETE:/api/v1/setting-type/{setting_type_id}
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		settingTypeDelete: (
			{ settingTypeId }: SettingTypeDeleteParams,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/setting-type/${settingTypeId}`,
				method: 'DELETE',
				secure: true,
				...params,
			}),
	}
	api = {
		/**
		 * No description
		 *
		 * @name GetPreprocessingOld
		 * @summary Get-Preprocessing-Old
		 * @request GET:/api/v1/preprocessing/
		 * @secure
		 * @response `200` `(Preprocessing | EmptyResponse)` Successful Response
		 */
		getPreprocessingOld: (params: RequestParams = {}) =>
			this.request<Preprocessing | EmptyResponse, any>({
				path: `/api/v1/preprocessing/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @name GetPreprocessing
		 * @summary Get-Preprocessing
		 * @request GET:/api/v1/preprocessing
		 * @secure
		 * @response `200` `(Preprocessing | EmptyResponse)` Successful Response
		 */
		getPreprocessing: (params: RequestParams = {}) =>
			this.request<Preprocessing | EmptyResponse, any>({
				path: `/api/v1/preprocessing`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @name ListInterpretation
		 * @summary List Interpretation
		 * @request GET:/api/v1/repricing-interpretation/
		 * @secure
		 * @response `200` `(InterpretationModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		listInterpretation: (
			query: ListInterpretationParams,
			params: RequestParams = {}
		) =>
			this.request<InterpretationModel[], HTTPValidationError>({
				path: `/api/v1/repricing-interpretation/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @name ListInterpretationData
		 * @summary List Interpretation Data
		 * @request GET:/api/v1/repricing-interpretation-data/
		 * @secure
		 * @response `200` `ProductDiffsModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		listInterpretationData: (
			query: ListInterpretationDataParams,
			params: RequestParams = {}
		) =>
			this.request<ProductDiffsModel, HTTPValidationError>({
				path: `/api/v1/repricing-interpretation-data/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @name Logs
		 * @summary Logs
		 * @request GET:/api/v1/user-activity-logs/
		 * @secure
		 * @response `200` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		logs: (query: LogsParams, params: RequestParams = {}) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/user-activity-logs/`,
				method: 'GET',
				query: query,
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @name EventTypes
		 * @summary Event Types
		 * @request GET:/api/v1/user-activity-logs/event-types/
		 * @secure
		 * @response `200` `any` Successful Response
		 */
		eventTypes: (params: RequestParams = {}) =>
			this.request<any, any>({
				path: `/api/v1/user-activity-logs/event-types/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),
	}
	assistant = {
		/**
		 * No description
		 *
		 * @tags assistant
		 * @name AssistantChatSettingsGet
		 * @summary Assistant-Chat-Settings-Get
		 * @request GET:/api/v1/assistant/chat/settings
		 * @secure
		 * @response `200` `ChatSettingsResponseModel` Successful Response
		 */
		assistantChatSettingsGet: (params: RequestParams = {}) =>
			this.request<ChatSettingsResponseModel, any>({
				path: `/api/v1/assistant/chat/settings`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags assistant
		 * @name AssistantChatMessagePostBi
		 * @summary Assistant-Chat-Message-Post-Bi
		 * @request POST:/api/v1/assistant/chat/business-intelligence
		 * @secure
		 * @response `200` `ChatMessageResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		assistantChatMessagePostBi: (
			data: ChatMessageRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ChatMessageResponseModel, HTTPValidationError>({
				path: `/api/v1/assistant/chat/business-intelligence`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags assistant
		 * @name AssistantChatMessagePostInterpretation
		 * @summary Assistant-Chat-Message-Post-Interpretation
		 * @request POST:/api/v1/assistant/chat/price-interpretation
		 * @secure
		 * @response `200` `ChatMessageResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		assistantChatMessagePostInterpretation: (
			data: ChatMessageRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ChatMessageResponseModel, HTTPValidationError>({
				path: `/api/v1/assistant/chat/price-interpretation`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags assistant
		 * @name AssistantChatMessagePostNavigation
		 * @summary Assistant-Chat-Message-Post-Navigation
		 * @request POST:/api/v1/assistant/chat/ai-navigation
		 * @secure
		 * @response `200` `ChatMessageResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		assistantChatMessagePostNavigation: (
			data: ChatMessageRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ChatMessageResponseModel, HTTPValidationError>({
				path: `/api/v1/assistant/chat/ai-navigation`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags assistant
		 * @name AssistantChatMessagePostPricingRule
		 * @summary Assistant-Chat-Message-Post-Pricing-Rule
		 * @request POST:/api/v1/assistant/chat/pricing-rule
		 * @secure
		 * @response `200` `ChatMessageResponseModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		assistantChatMessagePostPricingRule: (
			data: ChatMessageRequestModel,
			params: RequestParams = {}
		) =>
			this.request<ChatMessageResponseModel, HTTPValidationError>({
				path: `/api/v1/assistant/chat/pricing-rule`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags assistant
		 * @name AssistantChatReactionPost
		 * @summary Assistant-Chat-Reaction-Post
		 * @request POST:/api/v1/assistant/chat/reaction
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		assistantChatReactionPost: (
			data: ChatMessageReactionRequestModel,
			params: RequestParams = {}
		) =>
			this.request<void, HTTPValidationError>({
				path: `/api/v1/assistant/chat/reaction`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				...params,
			}),
	}
	promoCampaigns = {
		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name ListPromoCampaigns
		 * @summary List Promo Campaigns
		 * @request GET:/api/v1/promo-campaigns/
		 * @secure
		 * @response `200` `(PromoCampaignModel)[]` Successful Response
		 */
		listPromoCampaigns: (params: RequestParams = {}) =>
			this.request<PromoCampaignModel[], any>({
				path: `/api/v1/promo-campaigns/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name CreatePromoCampaign
		 * @summary Create Promo Campaign
		 * @request POST:/api/v1/promo-campaigns/
		 * @secure
		 * @response `201` `PromoCampaignModel` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		createPromoCampaign: (
			data: PromoCampaignCreateModel,
			params: RequestParams = {}
		) =>
			this.request<PromoCampaignModel, HTTPValidationError>({
				path: `/api/v1/promo-campaigns/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name GetPromoCampaign
		 * @summary Get Promo Campaign
		 * @request GET:/api/v1/promo-campaigns/{promo_campaign_id}/
		 * @secure
		 * @response `200` `PromoCampaignModel` Successful Response
		 * @response `404` `ErrorModel` Not Found
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		getPromoCampaign: (
			{ promoCampaignId }: GetPromoCampaignParams,
			params: RequestParams = {}
		) =>
			this.request<PromoCampaignModel, ErrorModel | HTTPValidationError>({
				path: `/api/v1/promo-campaigns/${promoCampaignId}/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name UpdatePromoCampaign
		 * @summary Update Promo Campaign
		 * @request PATCH:/api/v1/promo-campaigns/{promo_campaign_id}/
		 * @secure
		 * @response `200` `PromoCampaignModel` Successful Response
		 * @response `403` `ErrorModel` Forbidden
		 * @response `404` `ErrorModel` Not Found
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		updatePromoCampaign: (
			{ promoCampaignId }: UpdatePromoCampaignParams,
			data: PromoCampaignUpdateModel,
			params: RequestParams = {}
		) =>
			this.request<PromoCampaignModel, ErrorModel | HTTPValidationError>({
				path: `/api/v1/promo-campaigns/${promoCampaignId}/`,
				method: 'PATCH',
				body: data,
				secure: true,
				type: ContentType.Json,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name DeletePromoCampaign
		 * @summary Delete Promo Campaign
		 * @request DELETE:/api/v1/promo-campaigns/{promo_campaign_id}/
		 * @secure
		 * @response `204` `void` Successful Response
		 * @response `403` `ErrorModel` Forbidden
		 * @response `404` `ErrorModel` Not Found
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		deletePromoCampaign: (
			{ promoCampaignId }: DeletePromoCampaignParams,
			params: RequestParams = {}
		) =>
			this.request<void, ErrorModel | HTTPValidationError>({
				path: `/api/v1/promo-campaigns/${promoCampaignId}/`,
				method: 'DELETE',
				secure: true,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name ListPromoCampaignProducts
		 * @summary List Promo Campaign Products
		 * @request GET:/api/v1/promo-campaigns/{promo_campaign_id}/products/
		 * @secure
		 * @response `200` `(PromoProductModel)[]` Successful Response
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		listPromoCampaignProducts: (
			{ promoCampaignId }: ListPromoCampaignProductsParams,
			params: RequestParams = {}
		) =>
			this.request<PromoProductModel[], HTTPValidationError>({
				path: `/api/v1/promo-campaigns/${promoCampaignId}/products/`,
				method: 'GET',
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags promo-campaigns
		 * @name UploadPromoCampaignProducts
		 * @summary Upload Promo Campaign Products
		 * @request POST:/api/v1/promo-campaigns/{promo_campaign_id}/products/
		 * @secure
		 * @response `201` `any` Successful Response
		 * @response `400` `UploadPromoProductsErrorModel` Bad Request
		 * @response `403` `ErrorModel` Forbidden
		 * @response `404` `ErrorModel` Not Found
		 * @response `422` `HTTPValidationError` Validation Error
		 */
		uploadPromoCampaignProducts: (
			{ promoCampaignId }: UploadPromoCampaignProductsParams,
			data: BodyUploadPromoCampaignProductsApiV1PromoCampaignsPromoCampaignIdProductsPost,
			params: RequestParams = {}
		) =>
			this.request<
				any,
				UploadPromoProductsErrorModel | ErrorModel | HTTPValidationError
			>({
				path: `/api/v1/promo-campaigns/${promoCampaignId}/products/`,
				method: 'POST',
				body: data,
				secure: true,
				type: ContentType.FormData,
				format: 'json',
				...params,
			}),
	}
	cd = {
		/**
		 * No description
		 *
		 * @tags cd
		 * @name ListCompetitiveData
		 * @summary Get competitive data
		 * @request GET:/api/v1/competitive-data/
		 * @secure
		 * @response `200` `CompetitiveDataResponseModel` Successful Response
		 */
		listCompetitiveData: (
			query: ListCompetitiveDataParams,
			params: RequestParams = {}
		) =>
			this.request<CompetitiveDataResponseModel, any>({
				path: `/api/v1/competitive-data/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags cd
		 * @name ListPriceHistory
		 * @summary Get price history
		 * @request GET:/api/v1/price-history/
		 * @secure
		 * @response `200` `PriceHistoryResponseModel` Successful Response
		 */
		listPriceHistory: (
			query: ListPriceHistoryParams,
			params: RequestParams = {}
		) =>
			this.request<PriceHistoryResponseModel, any>({
				path: `/api/v1/price-history/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags cd
		 * @name ListCompetitors
		 * @summary Get competitors
		 * @request GET:/api/v1/competitors/
		 * @secure
		 * @response `200` `CompetitorsResponseModel` Successful Response
		 */
		listCompetitors: (
			query: ListCompetitorsParams,
			params: RequestParams = {}
		) =>
			this.request<CompetitorsResponseModel, any>({
				path: `/api/v1/competitors/`,
				method: 'GET',
				query: query,
				secure: true,
				format: 'json',
				...params,
			}),
	}
}
